import { AllFonts, FontCategory } from './types';
import {
  sentenceCase,
  titleCase,
  alterCase,
  randCase,
  pascalCase,
  hyphenCase,
  snakeCase,
  removePunctuation,
} from './transformers';

export const ASCII_ART_ID = -2;

export const allFonts = {
  '0': {
    name: 'Light Text Bubbles',
    lower: [
      'ⓐ',
      'ⓑ',
      'ⓒ',
      'ⓓ',
      'ⓔ',
      'ⓕ',
      'ⓖ',
      'ⓗ',
      'ⓘ',
      'ⓙ',
      'ⓚ',
      'ⓛ',
      'ⓜ',
      'ⓝ',
      'ⓞ',
      'ⓟ',
      'ⓠ',
      'ⓡ',
      'ⓢ',
      'ⓣ',
      'ⓤ',
      'ⓥ',
      'ⓦ',
      'ⓧ',
      'ⓨ',
      'ⓩ',
    ],
    upper: [
      'Ⓐ',
      'Ⓑ',
      'Ⓒ',
      'Ⓓ',
      'Ⓔ',
      'Ⓕ',
      'Ⓖ',
      'Ⓗ',
      'Ⓘ',
      'Ⓙ',
      'Ⓚ',
      'Ⓛ',
      'Ⓜ',
      'Ⓝ',
      'Ⓞ',
      'Ⓟ',
      'Ⓠ',
      'Ⓡ',
      'Ⓢ',
      'Ⓣ',
      'Ⓤ',
      'Ⓥ',
      'Ⓦ',
      'Ⓧ',
      'Ⓨ',
      'Ⓩ',
    ],
    digits: ['⓪', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'],
    categories: [3, 9],
    id: 0,
    mainCategory: FontCategory.Cool,
  },
  '1': {
    name: 'Fraktur',
    lower: [
      '𝔞',
      '𝔟',
      '𝔠',
      '𝔡',
      '𝔢',
      '𝔣',
      '𝔤',
      '𝔥',
      '𝔦',
      '𝔧',
      '𝔨',
      '𝔩',
      '𝔪',
      '𝔫',
      '𝔬',
      '𝔭',
      '𝔮',
      '𝔯',
      '𝔰',
      '𝔱',
      '𝔲',
      '𝔳',
      '𝔴',
      '𝔵',
      '𝔶',
      '𝔷',
    ],
    upper: [
      '𝔄',
      '𝔅',
      'ℭ',
      '𝔇',
      '𝔈',
      '𝔉',
      '𝔊',
      'ℌ',
      'ℑ',
      '𝔍',
      '𝔎',
      '𝔏',
      '𝔐',
      '𝔑',
      '𝔒',
      '𝔓',
      '𝔔',
      'ℜ',
      '𝔖',
      '𝔗',
      '𝔘',
      '𝔙',
      '𝔚',
      '𝔛',
      '𝔜',
      'ℨ',
    ],
    digits: [],
    categories: [4, 5, FontCategory.Small],
    id: 1,
    mainCategory: FontCategory.Fancy,
  },
  '2': {
    name: 'Cryptic Italic',
    lower: [
      '𐌀',
      '𐌁',
      '𐌂',
      '𐌃',
      '𐌄',
      '𐌅',
      'Ᏽ',
      '𐋅',
      '𐌉',
      'Ꮭ',
      '𐌊',
      '𐌋',
      '𐌌',
      '𐌍',
      'Ꝋ',
      '𐌐',
      '𐌒',
      '𐌓',
      '𐌔',
      '𐌕',
      '𐌵',
      'ᕓ',
      'Ꮤ',
      '𐋄',
      '𐌙',
      'Ɀ',
      '',
    ],
    upper: [
      '𐌀',
      '𐌁',
      '𐌂',
      '𐌃',
      '𐌄',
      '𐌅',
      'Ᏽ',
      '𐋅',
      '𐌉',
      'Ꮭ',
      '𐌊',
      '𐌋',
      '𐌌',
      '𐌍',
      'Ꝋ',
      '𐌐',
      '𐌒',
      '𐌓',
      '𐌔',
      '𐌕',
      '𐌵',
      'ᕓ',
      'Ꮤ',
      '𐋄',
      '𐌙',
      'Ɀ',
    ],
    digits: ['Ꝋ', 'ᛑ', 'ᘖ', 'ᙣ', 'ᔦ', 'ᔕ', 'ᑳ', 'ᒣ', 'ზ', 'ᖗ'],
    categories: [4],
    id: 2,
    mainCategory: FontCategory.Cursive,
  },
  '3': {
    name: 'Math Sans',
    lower: [
      '𝖺',
      '𝖻',
      '𝖼',
      '𝖽',
      '𝖾',
      '𝖿',
      '𝗀',
      '𝗁',
      '𝗂',
      '𝗃',
      '𝗄',
      '𝗅',
      '𝗆',
      '𝗇',
      '𝗈',
      '𝗉',
      '𝗊',
      '𝗋',
      '𝗌',
      '𝗍',
      '𝗎',
      '𝗏',
      '𝗐',
      '𝗑',
      '𝗒',
      '𝗓',
    ],
    upper: [
      '𝖠',
      '𝖡',
      '𝖢',
      '𝖣',
      '𝖤',
      '𝖥',
      '𝖦',
      '𝖧',
      '𝖨',
      '𝖩',
      '𝖪',
      '𝖫',
      '𝖬',
      '𝖭',
      '𝖮',
      '𝖯',
      '𝖰',
      '𝖱',
      '𝖲',
      '𝖳',
      '𝖴',
      '𝖵',
      '𝖶',
      '𝖷',
      '𝖸',
      '𝖹',
    ],
    digits: [],
    categories: [1, 7],
    id: 3,
    mainCategory: FontCategory.Small,
  },
  '4': {
    name: 'Script Bold Italic',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: [],
    categories: [1, 2, 4, 5],
    id: 4,
    mainCategory: FontCategory.Fancy,
  },
  '5': {
    name: 'Fairytale',
    lower: [
      'Ꮧ',
      'Ᏸ',
      'ፈ',
      'Ꮄ',
      'Ꮛ',
      'Ꭶ',
      'Ꮆ',
      'Ꮒ',
      'Ꭵ',
      'Ꮰ',
      'Ꮶ',
      'Ꮭ',
      'Ꮇ',
      'Ꮑ',
      'Ꭷ',
      'Ꭾ',
      'Ꭴ',
      'Ꮢ',
      'Ꮥ',
      'Ꮦ',
      'Ꮼ',
      'Ꮙ',
      'Ꮗ',
      'ጀ',
      'Ꭹ',
      'ፚ',
    ],
    upper: [
      'Ꮧ',
      'Ᏸ',
      'ፈ',
      'Ꮄ',
      'Ꮛ',
      'Ꭶ',
      'Ꮆ',
      'Ꮒ',
      'Ꭵ',
      'Ꮰ',
      'Ꮶ',
      'Ꮭ',
      'Ꮇ',
      'Ꮑ',
      'Ꭷ',
      'Ꭾ',
      'Ꭴ',
      'Ꮢ',
      'Ꮥ',
      'Ꮦ',
      'Ꮼ',
      'Ꮙ',
      'Ꮗ',
      'ጀ',
      'Ꭹ',
      'ፚ',
    ],
    digits: [],
    categories: [6],
    id: 5,
    mainCategory: FontCategory.Glitch,
  },
  '6': {
    name: 'Hearts',
    lower: [
      'a♥',
      'b♥',
      'c♥',
      'd♥',
      'e♥',
      'f♥',
      'g♥',
      'h♥',
      'i♥',
      'j♥',
      'k♥',
      'l♥',
      'm♥',
      'n♥',
      'o♥',
      'p♥',
      'q♥',
      'r♥',
      's♥',
      't♥',
      'u♥',
      'v♥',
      'w♥',
      'x♥',
      'y♥',
      'z♥',
    ],
    upper: [
      'A♥',
      'B♥',
      'C♥',
      'D♥',
      'E♥',
      'F♥',
      'G♥',
      'H♥',
      'I♥',
      'J♥',
      'K♥',
      'L♥',
      'M♥',
      'N♥',
      'O♥',
      'P♥',
      'Q♥',
      'R♥',
      'S♥',
      'T♥',
      'U♥',
      'V♥',
      'W♥',
      'X♥',
      'Y♥',
      'Z♥',
    ],
    digits: ['0♥', '1♥', '2♥', '3♥', '4♥', '5♥', '6♥', '7♥', '8♥', '9♥'],
    categories: [9],
    prefix: '♥',
    id: 6,
    mainCategory: FontCategory.Wrappers,
  },
  '7': {
    name: 'Emojis Text',
    lower: [
      '🅰',
      '🅱',
      '🌜',
      '🐬',
      '𝓔',
      '🔩',
      '🐋',
      '♓',
      '🕴',
      '🎷',
      '🎉',
      '👢',
      'Ⓜ',
      '🥄',
      '😀',
      '🅿',
      '🍳',
      '🌱',
      '💲',
      '🍄',
      '⛎',
      '✌',
      '🔱',
      '❎',
      '🏋',
      '💤',
    ],
    upper: [
      '🅰',
      '🅱',
      '🌜',
      '🐬',
      '𝓔',
      '🔩',
      '🐋',
      '♓',
      '🕴',
      '🎷',
      '🎉',
      '👢',
      'Ⓜ',
      '🥄',
      '😀',
      '🅿',
      '🍳',
      '🌱',
      '💲',
      '🍄',
      '⛎',
      '✌',
      '🔱',
      '❎',
      '🏋',
      '💤',
    ],
    digits: [],
    categories: [11],
    id: 7,
    mainCategory: FontCategory.Codes,
  },
  '8': {
    name: 'Dark Text Bubbles',
    lower: [
      '🅐',
      '🅑',
      '🅒',
      '🅓',
      '🅔',
      '🅕',
      '🅖',
      '🅗',
      '🅘',
      '🅙',
      '🅚',
      '🅛',
      '🅜',
      '🅝',
      '🅞',
      '🅟',
      '🅠',
      '🅡',
      '🅢',
      '🅣',
      '🅤',
      '🅥',
      '🅦',
      '🅧',
      '🅨',
      '🅩',
    ],
    upper: [
      '🅐',
      '🅑',
      '🅒',
      '🅓',
      '🅔',
      '🅕',
      '🅖',
      '🅗',
      '🅘',
      '🅙',
      '🅚',
      '🅛',
      '🅜',
      '🅝',
      '🅞',
      '🅟',
      '🅠',
      '🅡',
      '🅢',
      '🅣',
      '🅤',
      '🅥',
      '🅦',
      '🅧',
      '🅨',
      '🅩',
    ],
    digits: ['⓿', '➊', '➋', '➌', '➍', '➎', '➏', '➐', '➑', '➒'],
    categories: [3, 9, FontCategory.Small],
    id: 8,
    mainCategory: FontCategory.Cool,
  },
  '9': {
    name: 'Fraktur Bold',
    lower: [
      '𝖆',
      '𝖇',
      '𝖈',
      '𝖉',
      '𝖊',
      '𝖋',
      '𝖌',
      '𝖍',
      '𝖎',
      '𝖏',
      '𝖐',
      '𝖑',
      '𝖒',
      '𝖓',
      '𝖔',
      '𝖕',
      '𝖖',
      '𝖗',
      '𝖘',
      '𝖙',
      '𝖚',
      '𝖛',
      '𝖜',
      '𝖝',
      '𝖞',
      '𝖟',
    ],
    upper: [
      '𝕬',
      '𝕭',
      '𝕮',
      '𝕯',
      '𝕰',
      '𝕱',
      '𝕲',
      '𝕳',
      '𝕴',
      '𝕵',
      '𝕶',
      '𝕷',
      '𝕸',
      '𝕹',
      '𝕺',
      '𝕻',
      '𝕼',
      '𝕽',
      '𝕾',
      '𝕿',
      '𝖀',
      '𝖁',
      '𝖂',
      '𝖃',
      '𝖄',
      '𝖅',
    ],
    digits: [],
    categories: [2, 4, 5],
    id: 9,
    mainCategory: FontCategory.Fancy,
  },
  '10': {
    name: 'Monospace Text',
    lower: [
      '𝚊',
      '𝚋',
      '𝚌',
      '𝚍',
      '𝚎',
      '𝚏',
      '𝚐',
      '𝚑',
      '𝚒',
      '𝚓',
      '𝚔',
      '𝚕',
      '𝚖',
      '𝚗',
      '𝚘',
      '𝚙',
      '𝚚',
      '𝚛',
      '𝚜',
      '𝚝',
      '𝚞',
      '𝚟',
      '𝚠',
      '𝚡',
      '𝚢',
      '𝚣',
    ],
    upper: [
      '𝙰',
      '𝙱',
      '𝙲',
      '𝙳',
      '𝙴',
      '𝙵',
      '𝙶',
      '𝙷',
      '𝙸',
      '𝙹',
      '𝙺',
      '𝙻',
      '𝙼',
      '𝙽',
      '𝙾',
      '𝙿',
      '𝚀',
      '𝚁',
      '𝚂',
      '𝚃',
      '𝚄',
      '𝚅',
      '𝚆',
      '𝚇',
      '𝚈',
      '𝚉',
    ],
    digits: [],
    categories: [1, 5, FontCategory.Small],
    id: 10,
    mainCategory: FontCategory.Fancy,
  },
  '11': {
    name: 'Subscript',
    lower: [
      'ₐ',
      'b',
      'c',
      'd',
      'ₑ',
      'f',
      'g',
      'ₕ',
      'ᵢ',
      'ⱼ',
      'ₖ',
      'ₗ',
      'ₘ',
      'ₙ',
      'ₒ',
      'ₚ',
      'q',
      'ᵣ',
      'ₛ',
      'ₜ',
      'ᵤ',
      'ᵥ',
      'w',
      'ₓ',
      'y',
      'z',
    ],
    upper: [
      'ₐ',
      'B',
      'C',
      'D',
      'ₑ',
      'F',
      'G',
      'ₕ',
      'ᵢ',
      'ⱼ',
      'ₖ',
      'ₗ',
      'ₘ',
      'ₙ',
      'ₒ',
      'ₚ',
      'Q',
      'ᵣ',
      'ₛ',
      'ₜ',
      'ᵤ',
      'ᵥ',
      'W',
      'ₓ',
      'Y',
      'Z',
    ],
    digits: ['₀', '₁', '₂', '₃', '₄', '₅', '₆', '₇', '₈', '₉'],
    categories: [1, 3, FontCategory.Small],
    id: 11,
    mainCategory: FontCategory.Small,
  },
  '12': {
    name: 'Superscript',
    lower: [
      'ᵃ',
      'ᵇ',
      'ᶜ',
      'ᵈ',
      'ᵉ',
      'ᶠ',
      'ᵍ',
      'ʰ',
      'ⁱ',
      'ʲ',
      'ᵏ',
      'ˡ',
      'ᵐ',
      'ⁿ',
      'ᵒ',
      'ᵖ',
      'q',
      'ʳ',
      'ˢ',
      'ᵗ',
      'ᵘ',
      'ᵛ',
      'ʷ',
      'ˣ',
      'ʸ',
      'ᶻ',
    ],
    upper: [
      'ᴬ',
      'ᴮ',
      'ᶜ',
      'ᴰ',
      'ᴱ',
      'ᶠ',
      'ᴳ',
      'ᴴ',
      'ᴵ',
      'ᴶ',
      'ᴷ',
      'ᴸ',
      'ᴹ',
      'ᴺ',
      'ᴼ',
      'ᴾ',
      'Q',
      'ᴿ',
      'ˢ',
      'ᵀ',
      'ᵁ',
      'ⱽ',
      'ᵂ',
      'ˣ',
      'ʸ',
      'ᶻ',
    ],
    digits: ['⁰', '¹', '²', '³', '⁴', '⁵', '⁶', '⁷', '⁸', '⁹'],
    categories: [3, 7],
    id: 12,
    mainCategory: FontCategory.Small,
  },
  '13': {
    name: 'Full Width',
    lower: [
      'ａ',
      'ｂ',
      'ｃ',
      'ｄ',
      'ｅ',
      'ｆ',
      'ｇ',
      'ｈ',
      'ｉ',
      'ｊ',
      'ｋ',
      'ｌ',
      'ｍ',
      'ｎ',
      'ｏ',
      'ｐ',
      'ｑ',
      'ｒ',
      'ｓ',
      'ｔ',
      'ｕ',
      'ｖ',
      'ｗ',
      'ｘ',
      'ｙ',
      'ｚ',
    ],
    upper: [
      'Ａ',
      'Ｂ',
      'Ｃ',
      'Ｄ',
      'Ｅ',
      'Ｆ',
      'Ｇ',
      'Ｈ',
      'Ｉ',
      'Ｊ',
      'Ｋ',
      'Ｌ',
      'Ｍ',
      'Ｎ',
      'Ｏ',
      'Ｐ',
      'Ｑ',
      'Ｒ',
      'Ｓ',
      'Ｔ',
      'Ｕ',
      'Ｖ',
      'Ｗ',
      'Ｘ',
      'Ｙ',
      'Ｚ',
    ],
    digits: ['０', '１', '２', '３', '４', '５', '６', '７', '８', '９'],
    categories: [3],
    id: 13,
    mainCategory: FontCategory.Cool,
  },
  '14': {
    name: 'Parenthesis',
    lower: [
      '⒜',
      '⒝',
      '⒞',
      '⒟',
      '⒠',
      '⒡',
      '⒢',
      '⒣',
      '⒤',
      '⒥',
      '⒦',
      '⒧',
      '⒨',
      '⒩',
      '⒪',
      '⒫',
      '⒬',
      '⒭',
      '⒮',
      '⒯',
      '⒰',
      '⒱',
      '⒲',
      '⒳',
      '⒴',
      '⒵',
    ],
    upper: [
      '⒜',
      '⒝',
      '⒞',
      '⒟',
      '⒠',
      '⒡',
      '⒢',
      '⒣',
      '⒤',
      '⒥',
      '⒦',
      '⒧',
      '⒨',
      '⒩',
      '⒪',
      '⒫',
      '⒬',
      '⒭',
      '⒮',
      '⒯',
      '⒰',
      '⒱',
      '⒲',
      '⒳',
      '⒴',
      '⒵',
    ],
    digits: ['0', '⑴', '⑵', '⑶', '⑷', '⑸', '⑹', '⑺', '⑻', '⑼'],
    categories: [9],
    id: 14,
    mainCategory: FontCategory.Wrappers,
  },
  '15': {
    name: 'Wizard',
    lower: [
      'ǟ',
      'ɮ',
      'ƈ',
      'ɖ',
      'ɛ',
      'ʄ',
      'ɢ',
      'ɦ',
      'ɨ',
      'ʝ',
      'ӄ',
      'ʟ',
      'ʍ',
      'ռ',
      'օ',
      'ք',
      'զ',
      'ʀ',
      'ֆ',
      'ȶ',
      'ʊ',
      'ʋ',
      'ա',
      'Ӽ',
      'ʏ',
      'ʐ',
    ],
    upper: [
      'ǟ',
      'ɮ',
      'ƈ',
      'ɖ',
      'ɛ',
      'ʄ',
      'ɢ',
      'ɦ',
      'ɨ',
      'ʝ',
      'ӄ',
      'ʟ',
      'ʍ',
      'ռ',
      'օ',
      'ք',
      'զ',
      'ʀ',
      'ֆ',
      'ȶ',
      'ʊ',
      'ʋ',
      'ա',
      'Ӽ',
      'ʏ',
      'ʐ',
    ],
    digits: [],
    categories: [5, 6],
    id: 15,
    mainCategory: FontCategory.Glitch,
  },
  '16': {
    name: 'Lefthanded',
    lower: [
      'α',
      'ɓ',
      '૮',
      '∂',
      'ε',
      'ƒ',
      'ɠ',
      'ɦ',
      'เ',
      'ʝ',
      'ҡ',
      'ℓ',
      'ɱ',
      'ɳ',
      'σ',
      'ρ',
      'φ',
      '૨',
      'ร',
      'ƭ',
      'µ',
      'ѵ',
      'ω',
      'א',
      'ყ',
      'ƶ',
    ],
    upper: [
      'α',
      'ɓ',
      '૮',
      '∂',
      'ε',
      'ƒ',
      'ɠ',
      'ɦ',
      'เ',
      'ʝ',
      'ҡ',
      'ℓ',
      'ɱ',
      'ɳ',
      'σ',
      'ρ',
      'φ',
      '૨',
      'ร',
      'ƭ',
      'µ',
      'ѵ',
      'ω',
      'א',
      'ყ',
      'ƶ',
    ],
    digits: [],
    categories: [5],
    id: 16,
    mainCategory: FontCategory.Fancy,
  },
  '17': {
    name: 'Dark Text Squares',
    lower: [
      '🅰',
      '🅱',
      '🅲',
      '🅳',
      '🅴',
      '🅵',
      '🅶',
      '🅷',
      '🅸',
      '🅹',
      '🅺',
      '🅻',
      '🅼',
      '🅽',
      '🅾',
      '🅿',
      '🆀',
      '🆁',
      '🆂',
      '🆃',
      '🆄',
      '🆅',
      '🆆',
      '🆇',
      '🆈',
      '🆉',
    ],
    upper: [
      '🅰',
      '🅱',
      '🅲',
      '🅳',
      '🅴',
      '🅵',
      '🅶',
      '🅷',
      '🅸',
      '🅹',
      '🅺',
      '🅻',
      '🅼',
      '🅽',
      '🅾',
      '🅿',
      '🆀',
      '🆁',
      '🆂',
      '🆃',
      '🆄',
      '🆅',
      '🆆',
      '🆇',
      '🆈',
      '🆉',
    ],
    digits: [],
    categories: [2, 9, FontCategory.Small],
    id: 17,
    mainCategory: FontCategory.Wrappers,
  },
  '18': {
    name: 'Light Text Squares',
    lower: [
      '🄰',
      '🄱',
      '🄲',
      '🄳',
      '🄴',
      '🄵',
      '🄶',
      '🄷',
      '🄸',
      '🄹',
      '🄺',
      '🄻',
      '🄼',
      '🄽',
      '🄾',
      '🄿',
      '🅀',
      '🅁',
      '🅂',
      '🅃',
      '🅄',
      '🅅',
      '🅆',
      '🅇',
      '🅈',
      '🅉',
    ],
    upper: [
      '🄰',
      '🄱',
      '🄲',
      '🄳',
      '🄴',
      '🄵',
      '🄶',
      '🄷',
      '🄸',
      '🄹',
      '🄺',
      '🄻',
      '🄼',
      '🄽',
      '🄾',
      '🄿',
      '🅀',
      '🅁',
      '🅂',
      '🅃',
      '🅄',
      '🅅',
      '🅆',
      '🅇',
      '🅈',
      '🅉',
    ],
    digits: [],
    categories: [3, 9, FontCategory.Small],
    id: 18,
    mainCategory: FontCategory.Wrappers,
  },
  '19': {
    name: 'Double Struck',
    lower: [
      '𝕒',
      '𝕓',
      '𝕔',
      '𝕕',
      '𝕖',
      '𝕗',
      '𝕘',
      '𝕙',
      '𝕚',
      '𝕛',
      '𝕜',
      '𝕝',
      '𝕞',
      '𝕟',
      '𝕠',
      '𝕡',
      '𝕢',
      '𝕣',
      '𝕤',
      '𝕥',
      '𝕦',
      '𝕧',
      '𝕨',
      '𝕩',
      '𝕪',
      '𝕫',
    ],
    upper: [
      '𝔸',
      '𝔹',
      'ℂ',
      '𝔻',
      '𝔼',
      '𝔽',
      '𝔾',
      'ℍ',
      '𝕀',
      '𝕁',
      '𝕂',
      '𝕃',
      '𝕄',
      'ℕ',
      '𝕆',
      'ℙ',
      'ℚ',
      'ℝ',
      '𝕊',
      '𝕋',
      '𝕌',
      '𝕍',
      '𝕎',
      '𝕏',
      '𝕐',
      'ℤ',
    ],
    digits: [],
    categories: [3, 5],
    id: 19,
    mainCategory: FontCategory.Fancy,
  },
  '20': {
    name: 'Cyrillic',
    lower: [
      'а',
      'б',
      'c',
      'д',
      'ё',
      'f',
      'g',
      'н',
      'ї',
      'j',
      'к',
      'г',
      'ѫ',
      'п',
      'ѳ',
      'p',
      'ф',
      'я',
      '$',
      'т',
      'ц',
      'ѵ',
      'щ',
      'ж',
      'ч',
      'з',
    ],
    upper: [
      'А',
      'Б',
      'C',
      'Д',
      'Є',
      'F',
      'G',
      'H',
      'Ї',
      'J',
      'К',
      'Г',
      'Ѫ',
      'Й',
      'Ѳ',
      'P',
      'Ф',
      'Я',
      '$',
      'T',
      'Ц',
      'Ѵ',
      'Ш',
      'Ж',
      'Ч',
      'З',
    ],
    digits: [],
    categories: [3],
    id: 20,
    mainCategory: FontCategory.Cool,
  },
  '21': {
    name: 'Mirrored / Flipped',
    lower: [
      'z',
      'Y',
      'x',
      'w',
      'v',
      'U',
      'T',
      'ꙅ',
      'ᴙ',
      'p',
      'q',
      'o',
      'ᴎ',
      'm',
      'l',
      'k',
      'j',
      'i',
      'H',
      'g',
      'ꟻ',
      'ɘ',
      'b',
      'ↄ',
      'd',
      'A',
    ],
    upper: [
      'Z',
      'Y',
      'X',
      'W',
      'V',
      'U',
      'T',
      'Ꙅ',
      'ᴙ',
      'p',
      'ꟼ',
      'O',
      'ᴎ',
      'M',
      '⅃',
      'K',
      'J',
      'I',
      'H',
      'G',
      'ꟻ',
      'Ǝ',
      'b',
      'Ↄ',
      'd',
      'A',
    ],
    digits: ['', '', '', '', '', '', '', '', '', '', ''],
    categories: [1, 3],
    id: 21,
    mainCategory: FontCategory.Basic,
  },
  '22': {
    name: 'Japanese',
    lower: [
      '卂',
      '乃',
      '匚',
      'ᗪ',
      '乇',
      '千',
      'Ꮆ',
      '卄',
      '丨',
      'ﾌ',
      'Ҝ',
      'ㄥ',
      '爪',
      '几',
      'ㄖ',
      '卩',
      'Ɋ',
      '尺',
      '丂',
      'ㄒ',
      'ㄩ',
      'ᐯ',
      '山',
      '乂',
      'ㄚ',
      '乙',
    ],
    upper: [
      '卂',
      '乃',
      '匚',
      'ᗪ',
      '乇',
      '千',
      'Ꮆ',
      '卄',
      '丨',
      'ﾌ',
      'Ҝ',
      'ㄥ',
      '爪',
      '几',
      'ㄖ',
      '卩',
      'Ɋ',
      '尺',
      '丂',
      'ㄒ',
      'ㄩ',
      'ᐯ',
      '山',
      '乂',
      'ㄚ',
      '乙',
    ],
    digits: [],
    categories: [3],
    id: 22,
    mainCategory: FontCategory.Cool,
  },
  '23': {
    name: 'Arabic',
    lower: [
      'ค',
      '๒',
      'ς',
      '๔',
      'є',
      'Ŧ',
      'ﻮ',
      'ђ',
      'เ',
      'ן',
      'к',
      'l',
      '๓',
      'ภ',
      '๏',
      'ק',
      'ợ',
      'г',
      'ร',
      't',
      'ย',
      'ש',
      'ฬ',
      'ץ',
      'א',
      'z',
    ],
    upper: [
      'ค',
      '๒',
      'ς',
      '๔',
      'є',
      'Ŧ',
      'ﻮ',
      'ђ',
      'เ',
      'ן',
      'к',
      'l',
      '๓',
      'ภ',
      '๏',
      'ק',
      'ợ',
      'г',
      'ร',
      't',
      'ย',
      'ש',
      'ฬ',
      'ץ',
      'א',
      'z',
    ],
    digits: [],
    categories: [3],
    id: 23,
    mainCategory: FontCategory.Cool,
  },
  '24': {
    name: 'Inverted',
    lower: [
      'ɐ',
      'q',
      'ɔ',
      'p',
      'ǝ',
      'ɟ',
      'ƃ',
      'ɥ',
      'ı',
      'ɾ',
      'ʞ',
      'ן',
      'ɯ',
      'u',
      'o',
      'd',
      'b',
      'ɹ',
      's',
      'ʇ',
      'n',
      'ʌ',
      'ʍ',
      'x',
      'ʎ',
      'z',
    ],
    upper: [
      '∀',
      'ᗺ',
      'Ɔ',
      'ᗡ',
      'Ǝ',
      'Ⅎ',
      '⅁',
      'H',
      'I',
      'ſ',
      'ꓘ',
      '˥',
      'W',
      'N',
      'O',
      'Ԁ',
      'ტ',
      'ᴚ',
      'S',
      '⊥',
      '∩',
      'Λ',
      'M',
      'X',
      '⅄',
      'Z',
    ],
    digits: ['0', 'Ɩ', 'ᘔ', 'Ɛ', 'ߤ', '5', '9', 'ㄥ', '8', '6'],
    categories: [1, 3],
    id: 24,
    mainCategory: FontCategory.Basic,
  },
  '25': {
    name: 'Math Sans Bold Italic',
    lower: [
      '𝙖',
      '𝙗',
      '𝙘',
      '𝙙',
      '𝙚',
      '𝙛',
      '𝙜',
      '𝙝',
      '𝙞',
      '𝙟',
      '𝙠',
      '𝙡',
      '𝙢',
      '𝙣',
      '𝙤',
      '𝙥',
      '𝙦',
      '𝙧',
      '𝙨',
      '𝙩',
      '𝙪',
      '𝙫',
      '𝙬',
      '𝙭',
      '𝙮',
      '𝙯',
    ],
    upper: [
      '𝘼',
      '𝘽',
      '𝘾',
      '𝘿',
      '𝙀',
      '𝙁',
      '𝙂',
      '𝙃',
      '𝙄',
      '𝙅',
      '𝙆',
      '𝙇',
      '𝙈',
      '𝙉',
      '𝙊',
      '𝙋',
      '𝙌',
      '𝙍',
      '𝙎',
      '𝙏',
      '𝙐',
      '𝙑',
      '𝙒',
      '𝙓',
      '𝙔',
      '𝙕',
    ],
    digits: [],
    categories: [1, 2, 4],
    id: 25,
    mainCategory: FontCategory.Basic,
  },
  '26': {
    name: 'Diagonal Strikes',
    lower: [
      'a̷',
      '̷b̷',
      '̷c̷',
      '̷d̷',
      '̷e̷',
      '̷f̷',
      '̷g̷',
      '̷h̷',
      '̷i̷',
      '̷j̷',
      '̷k̷',
      '̷l̷',
      '̷m̷',
      '̷n̷',
      '̷o̷',
      '̷p̷',
      '̷q̷',
      '̷r̷',
      '̷s̷',
      '̷t̷',
      '̷u̷',
      '̷v̷',
      '̷w̷',
      '̷x̷',
      '̷y̷',
      '̷z̷',
    ],
    upper: [
      '̷A̷',
      '̷B̷',
      '̷C̷',
      '̷D̷',
      '̷E̷',
      '̷F̷',
      '̷G̷',
      '̷H̷',
      '̷I̷',
      '̷J̷',
      '̷K̷',
      '̷L̷',
      '̷M̷',
      '̷N̷',
      '̷O̷',
      '̷P̷',
      '̷Q̷',
      '̷R̷',
      '̷S̷',
      '̷T̷',
      '̷U̷',
      '̷V̷',
      '̷W̷',
      '̷X̷',
      '̷Y̷',
      '̷Z̷',
    ],
    digits: ['̷0̷', '̷1̷', '̷2̷', '̷3̷', '̷4̷', '̷5̷', '̷6̷', '̷7̷', '̷8̷', '̷9̷'],
    categories: [6],
    id: 26,
    mainCategory: FontCategory.Glitch,
  },
  '27': {
    name: 'Ancient Style 1',
    lower: [
      'ꍏ',
      'ꌃ',
      'ꉓ',
      'ꀸ',
      'ꍟ',
      'ꎇ',
      'ꁅ',
      'ꃅ',
      'ꀤ',
      'ꀭ',
      'ꀘ',
      '꒒',
      'ꂵ',
      'ꈤ',
      'ꂦ',
      'ꉣ',
      'ꆰ',
      'ꋪ',
      'ꌗ',
      '꓄',
      'ꀎ',
      'ꃴ',
      'ꅏ',
      'ꊼ',
      'ꌩ',
      'ꁴ',
    ],
    upper: [
      'ꍏ',
      'ꌃ',
      'ꉓ',
      'ꀸ',
      'ꍟ',
      'ꎇ',
      'ꁅ',
      'ꃅ',
      'ꀤ',
      'ꀭ',
      'ꀘ',
      '꒒',
      'ꂵ',
      'ꈤ',
      'ꂦ',
      'ꉣ',
      'ꆰ',
      'ꋪ',
      'ꌗ',
      '꓄',
      'ꀎ',
      'ꃴ',
      'ꅏ',
      'ꊼ',
      'ꌩ',
      'ꁴ',
    ],
    digits: [],
    categories: [6],
    id: 27,
    mainCategory: FontCategory.Glitch,
  },
  '28': {
    name: 'Dot Separated',
    lower: [
      'ᆞaᆞ',
      'ᆞbᆞ',
      'ᆞcᆞ',
      'ᆞdᆞ',
      'ᆞeᆞ',
      'ᆞfᆞ',
      'ᆞgᆞ',
      'ᆞhᆞ',
      'ᆞiᆞ',
      'ᆞjᆞ',
      'ᆞkᆞ',
      'ᆞlᆞ',
      'ᆞmᆞ',
      'ᆞnᆞ',
      'ᆞoᆞ',
      'ᆞpᆞ',
      'ᆞqᆞ',
      'ᆞrᆞ',
      'ᆞsᆞ',
      'ᆞtᆞ',
      'ᆞuᆞ',
      'ᆞvᆞ',
      'ᆞwᆞ',
      'ᆞxᆞ',
      'ᆞyᆞ',
      'ᆞzᆞ',
    ],
    upper: [
      'ᆞAᆞ',
      'ᆞBᆞ',
      'ᆞCᆞ',
      'ᆞDᆞ',
      'ᆞEᆞ',
      'ᆞFᆞ',
      'ᆞGᆞ',
      'ᆞHᆞ',
      'ᆞIᆞ',
      'ᆞJᆞ',
      'ᆞKᆞ',
      'ᆞLᆞ',
      'ᆞMᆞ',
      'ᆞNᆞ',
      'ᆞOᆞ',
      'ᆞPᆞ',
      'ᆞQᆞ',
      'ᆞRᆞ',
      'ᆞSᆞ',
      'ᆞTᆞ',
      'ᆞUᆞ',
      'ᆞVᆞ',
      'ᆞWᆞ',
      'ᆞXᆞ',
      'ᆞYᆞ',
      'ᆞZᆞ',
    ],
    digits: ['ᆞ0ᆞ', 'ᆞ1ᆞ', 'ᆞ2ᆞ', 'ᆞ3ᆞ', 'ᆞ4ᆞ', 'ᆞ5ᆞ', 'ᆞ6ᆞ', 'ᆞ7ᆞ', 'ᆞ8ᆞ', 'ᆞ9ᆞ'],
    categories: [9],
    id: 28,
    mainCategory: FontCategory.Wrappers,
  },
  '29': {
    name: 'Mixed Style 1',
    lower: [
      '𝐚',
      '๒',
      'Ć',
      '𝓭',
      '𝑒',
      'ⓕ',
      '𝕘',
      '𝓱',
      'Ɨ',
      'Ｊ',
      'Ⓚ',
      'ᒪ',
      'м',
      '𝐍',
      'Ø',
      '卩',
      'q',
      'я',
      '丂',
      '𝐓',
      'ย',
      'ｖ',
      '𝔀',
      'x',
      '𝔂',
      '𝓩',
    ],
    upper: [
      '𝐀',
      'β',
      'ⓒ',
      '𝓭',
      '𝑒',
      'ⓕ',
      'ᵍ',
      'ⓗ',
      'Ꭵ',
      'ן',
      'ᵏ',
      '𝕃',
      'ｍ',
      'ⓝ',
      '𝓸',
      'Ƥ',
      'ℚ',
      'ⓡ',
      '𝓼',
      'Ｔ',
      '𝓾',
      'v',
      '𝓌',
      'ⓧ',
      'ץ',
      'Ż',
    ],
    digits: ['０', '➀', '❷', '➂', '４', '❺', '６', '❼', '➇', '❾'],
    categories: [3, 6],
    id: 29,
    mainCategory: FontCategory.Glitch,
  },
  '30': {
    name: 'Handwriting',
    lower: [
      '𝒶',
      '𝒷',
      '𝒸',
      '𝒹',
      '𝑒',
      '𝒻',
      '𝑔',
      '𝒽',
      '𝒾',
      '𝒿',
      '𝓀',
      '𝓁',
      '𝓂',
      '𝓃',
      '𝑜',
      '𝓅',
      '𝓆',
      '𝓇',
      '𝓈',
      '𝓉',
      '𝓊',
      '𝓋',
      '𝓌',
      '𝓍',
      '𝓎',
      '𝓏',
    ],
    upper: [
      '𝒜',
      '𝐵',
      '𝒞',
      '𝒟',
      '𝐸',
      '𝐹',
      '𝒢',
      '𝐻',
      '𝐼',
      '𝒥',
      '𝒦',
      '𝐿',
      '𝑀',
      '𝒩',
      '𝒪',
      '𝒫',
      '𝒬',
      '𝑅',
      '𝒮',
      '𝒯',
      '𝒰',
      '𝒱',
      '𝒲',
      '𝒳',
      '𝒴',
      '𝒵',
    ],
    digits: [],
    categories: [1, 3, 4, 5],
    id: 30,
    mainCategory: FontCategory.Cursive,
  },
  '31': {
    name: 'Acute Accents',
    lower: [
      'á',
      'b',
      'ć',
      'd',
      'é',
      'f',
      'ǵ',
      'h',
      'í',
      'j',
      'ḱ',
      'ĺ',
      'ḿ',
      'ń',
      'ő',
      'ṕ',
      'q',
      'ŕ',
      'ś',
      't',
      'ú',
      'v',
      'ẃ',
      'x',
      'ӳ',
      'ź',
    ],
    upper: [
      'Á',
      'B',
      'Ć',
      'D',
      'É',
      'F',
      'Ǵ',
      'H',
      'í',
      'J',
      'Ḱ',
      'Ĺ',
      'Ḿ',
      'Ń',
      'Ő',
      'Ṕ',
      'Q',
      'Ŕ',
      'ś',
      'T',
      'Ű',
      'V',
      'Ẃ',
      'X',
      'Ӳ',
      'Ź',
    ],
    digits: [],
    categories: [6],
    id: 31,
    mainCategory: FontCategory.Glitch,
  },
  '32': {
    name: 'Fading Effect',
    lower: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', ''],
    categories: [8],
    prefix: '█▓▒▒░░░',
    suffix: '░░░▒▒▓█',
    id: 32,
    mainCategory: FontCategory.SymbolText,
  },
  '33': {
    name: 'Modern Greek',
    lower: [
      'Λ',
      'B',
      'ᄃ',
      'D',
      'Σ',
      'F',
      'G',
      'Ή',
      'I',
      'J',
      'K',
      'ᄂ',
      'M',
      'П',
      'Ө',
      'P',
      'Q',
      'Я',
      'Ƨ',
      'Ƭ',
      'Ц',
      'V',
      'Щ',
      'X',
      'Y',
      'Z',
    ],
    upper: [
      'Λ',
      'B',
      'ᄃ',
      'D',
      'Σ',
      'F',
      'G',
      'Ή',
      'I',
      'J',
      'K',
      'ᄂ',
      'M',
      'П',
      'Ө',
      'P',
      'Q',
      'Я',
      'Ƨ',
      'Ƭ',
      'Ц',
      'V',
      'Щ',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [3],
    id: 33,
    mainCategory: FontCategory.Cool,
  },
  '34': {
    name: 'Underlined by Dashes',
    lower: [
      'a̠',
      '̠b̠',
      '̠c̠',
      '̠d̠',
      '̠e̠',
      '̠f̠',
      '̠g̠',
      '̠h̠',
      '̠i̠',
      '̠j̠',
      '̠k̠',
      '̠l̠',
      '̠m̠',
      '̠n̠',
      '̠o̠',
      '̠p̠',
      '̠q̠',
      '̠r̠',
      '̠s̠',
      '̠t̠',
      '̠u̠',
      '̠v̠',
      '̠w̠',
      '̠x̠',
      '̠y̠',
      '̠z̠',
    ],
    upper: [
      'A̠',
      '̠B̠',
      '̠C̠',
      '̠D̠',
      '̠E̠',
      '̠F̠',
      '̠G̠',
      '̠H̠',
      '̠I̠',
      '̠J̠',
      '̠K̠',
      '̠L̠',
      '̠M̠',
      '̠N̠',
      '̠O̠',
      '̠P̠',
      '̠Q̠',
      '̠R̠',
      '̠S̠',
      '̠T̠',
      '̠U̠',
      '̠V̠',
      '̠W̠',
      '̠X̠',
      '̠Y̠',
      '̠Z̠',
    ],
    digits: ['0̠', '̠1̠', '̠2̠', '̠3̠', '̠4̠', '̠5̠', '̠6̠', '̠7̠', '̠8̠', '̠9̠'],
    categories: [6],
    id: 34,
    mainCategory: FontCategory.Glitch,
  },
  '35': {
    name: 'Lined up',
    lower: [
      'ᅳaᅳ',
      'ᅳbᅳ',
      'ᅳcᅳ',
      'ᅳdᅳ',
      'ᅳeᅳ',
      'ᅳfᅳ',
      'ᅳgᅳ',
      'ᅳhᅳ',
      'ᅳiᅳ',
      'ᅳjᅳ',
      'ᅳkᅳ',
      'ᅳlᅳ',
      'ᅳmᅳ',
      'ᅳnᅳ',
      'ᅳoᅳ',
      'ᅳpᅳ',
      'ᅳqᅳ',
      'ᅳrᅳ',
      'ᅳsᅳ',
      'ᅳtᅳ',
      'ᅳuᅳ',
      'ᅳvᅳ',
      'ᅳwᅳ',
      'ᅳxᅳ',
      'ᅳyᅳ',
      'ᅳzᅳ',
    ],
    upper: [
      'ᅳAᅳ',
      'ᅳBᅳ',
      'ᅳCᅳ',
      'ᅳDᅳ',
      'ᅳEᅳ',
      'ᅳFᅳ',
      'ᅳGᅳ',
      'ᅳHᅳ',
      'ᅳIᅳ',
      'ᅳJᅳ',
      'ᅳKᅳ',
      'ᅳLᅳ',
      'ᅳMᅳ',
      'ᅳNᅳ',
      'ᅳOᅳ',
      'ᅳPᅳ',
      'ᅳQᅳ',
      'ᅳRᅳ',
      'ᅳSᅳ',
      'ᅳTᅳ',
      'ᅳUᅳ',
      'ᅳVᅳ',
      'ᅳWᅳ',
      'ᅳXᅳ',
      'ᅳYᅳ',
      'ᅳZᅳ',
    ],
    digits: ['ᅳ0ᅳ', 'ᅳ1ᅳ', 'ᅳ2ᅳ', 'ᅳ3ᅳ', 'ᅳ4ᅳ', 'ᅳ5ᅳ', 'ᅳ6ᅳ', 'ᅳ7ᅳ', 'ᅳ8ᅳ', 'ᅳ9ᅳ'],
    categories: [9],
    id: 35,
    mainCategory: FontCategory.Wrappers,
  },
  '36': {
    name: 'Mixed Style 2',
    lower: [
      '𝐚',
      'ᵇ',
      '¢',
      'ᗪ',
      'ｅ',
      'ғ',
      'g',
      'ⓗ',
      '𝕀',
      'ｊ',
      'Ҝ',
      'ᒪ',
      'м',
      'ภ',
      '𝑜',
      'ρ',
      '𝓺',
      'я',
      'ᔕ',
      '丅',
      '𝓊',
      '𝐯',
      'Ŵ',
      'ⓧ',
      'Ⓨ',
      'ℤ',
    ],
    upper: [
      'ａ',
      'ｂ',
      '𝔠',
      'ᵈ',
      'έ',
      '𝔽',
      'g',
      'ⓗ',
      '𝓘',
      'Ⓙ',
      'Ќ',
      'l',
      '𝓂',
      'ή',
      '𝐎',
      '𝓟',
      '𝕢',
      '𝔯',
      '𝐒',
      '𝕥',
      '𝓊',
      'ν',
      'ᗯ',
      'Ⓧ',
      'у',
      'Ż',
    ],
    digits: ['０', '❶', '２', '３', '４', '５', '６', '７', '➇', '❾'],
    categories: [3, 6],
    id: 36,
    mainCategory: FontCategory.Glitch,
  },
  '37': {
    name: 'UpAndDown',
    lower: [
      'ₐ',
      'b',
      'c',
      'd',
      'ₑ',
      'f',
      'g',
      'ₕ',
      'ᵢ',
      'ⱼ',
      'ₖ',
      'ₗ',
      'ₘ',
      'ₙ',
      'ₒ',
      'ₚ',
      'q',
      'ᵣ',
      'ₛ',
      'ₜ',
      'ᵤ',
      'ᵥ',
      'w',
      'ₓ',
      'y',
      'z',
    ],
    upper: [
      'ₐ',
      'B',
      'C',
      'D',
      'ₑ',
      'F',
      'G',
      'ₕ',
      'ᵢ',
      'ⱼ',
      'ₖ',
      'ₗ',
      'ₘ',
      'ₙ',
      'ₒ',
      'ₚ',
      'Q',
      'ᵣ',
      'ₛ',
      'ₜ',
      'ᵤ',
      'ᵥ',
      'W',
      'ₓ',
      'Y',
      'Z',
    ],
    digits: ['₀', '₁', '₂', '₃', '₄', '₅', '₆', '₇', '₈', '₉'],
    categories: [3, 7],
    id: 37,
    mainCategory: FontCategory.Small,
  },
  '38': {
    name: 'European Characters',
    lower: [
      'å',
      'ß',
      '¢',
      'Ð',
      'ê',
      '£',
      'g',
      'h',
      'ï',
      'j',
      'k',
      'l',
      'm',
      'ñ',
      'ð',
      'þ',
      'q',
      'r',
      '§',
      '†',
      'µ',
      'v',
      'w',
      'x',
      '¥',
      'z',
    ],
    upper: [
      'Ä',
      'ß',
      'Ç',
      'Ð',
      'È',
      '£',
      'G',
      'H',
      'Ì',
      'J',
      'K',
      'L',
      'M',
      'ñ',
      'Ö',
      'þ',
      'Q',
      'R',
      '§',
      '†',
      'Ú',
      'V',
      'W',
      '×',
      '¥',
      'Z',
    ],
    digits: [],
    categories: [3],
    id: 38,
    mainCategory: FontCategory.Cool,
  },
  '39': {
    name: 'Asian Characters',
    lower: [
      'ﾑ',
      '乃',
      'ᄃ',
      'り',
      '乇',
      'ｷ',
      'ム',
      'ん',
      'ﾉ',
      'ﾌ',
      'ズ',
      'ﾚ',
      'ﾶ',
      '刀',
      'の',
      'ｱ',
      'ゐ',
      '尺',
      '丂',
      'ｲ',
      'ひ',
      '√',
      'W',
      'ﾒ',
      'ﾘ',
      '乙',
    ],
    upper: [
      'ﾑ',
      '乃',
      'ᄃ',
      'り',
      '乇',
      'ｷ',
      'ム',
      'ん',
      'ﾉ',
      'ﾌ',
      'ズ',
      'ﾚ',
      'ﾶ',
      '刀',
      'の',
      'ｱ',
      'ゐ',
      '尺',
      '丂',
      'ｲ',
      'ひ',
      '√',
      'W',
      'ﾒ',
      'ﾘ',
      '乙',
    ],
    digits: [],
    categories: [3],
    id: 39,
    mainCategory: FontCategory.Cool,
  },
  '40': {
    name: 'Mono Upper',
    lower: [
      'ᴀ',
      'ʙ',
      'ᴄ',
      'ᴅ',
      'ᴇ',
      'ꜰ',
      'ɢ',
      'ʜ',
      'ɪ',
      'ᴊ',
      'ᴋ',
      'ʟ',
      'ᴍ',
      'ɴ',
      'ᴏ',
      'ᴘ',
      'Q',
      'ʀ',
      'ꜱ',
      'ᴛ',
      'ᴜ',
      'ᴠ',
      'ᴡ',
      'x',
      'ʏ',
      'ᴢ',
    ],
    upper: [
      'ᴀ',
      'ʙ',
      'ᴄ',
      'ᴅ',
      'ᴇ',
      'ꜰ',
      'ɢ',
      'ʜ',
      'ɪ',
      'ᴊ',
      'ᴋ',
      'ʟ',
      'ᴍ',
      'ɴ',
      'ᴏ',
      'ᴘ',
      'Q',
      'ʀ',
      'ꜱ',
      'ᴛ',
      'ᴜ',
      'ᴠ',
      'ᴡ',
      'x',
      'ʏ',
      'ᴢ',
    ],
    digits: [],
    categories: [1, 3, 5, FontCategory.Small],
    id: 40,
    mainCategory: FontCategory.Basic,
  },
  '41': {
    name: 'Dark Brackets',
    lower: [
      '【a】',
      '【b】',
      '【c】',
      '【d】',
      '【e】',
      '【f】',
      '【g】',
      '【h】',
      '【i】',
      '【j】',
      '【k】',
      '【l】',
      '【m】',
      '【n】',
      '【o】',
      '【p】',
      '【q】',
      '【r】',
      '【s】',
      '【t】',
      '【u】',
      '【v】',
      '【w】',
      '【x】',
      '【y】',
      '【z】',
    ],
    upper: [
      '【A】',
      '【B】',
      '【C】',
      '【D】',
      '【E】',
      '【F】',
      '【G】',
      '【H】',
      '【I】',
      '【J】',
      '【K】',
      '【L】',
      '【M】',
      '【N】',
      '【O】',
      '【P】',
      '【Q】',
      '【R】',
      '【S】',
      '【T】',
      '【U】',
      '【V】',
      '【W】',
      '【X】',
      '【Y】',
      '【Z】',
    ],
    digits: [
      '【0】',
      '【1】',
      '【2】',
      '【3】',
      '【4】',
      '【5】',
      '【6】',
      '【7】',
      '【8】',
      '【9】',
    ],
    categories: [9],
    id: 41,
    mainCategory: FontCategory.Wrappers,
  },
  '42': {
    name: 'Devlish',
    lower: [
      'α',
      'Ⴆ',
      'ƈ',
      'ԃ',
      'ҽ',
      'ϝ',
      'ɠ',
      'ԋ',
      'ι',
      'ʝ',
      'ƙ',
      'ʅ',
      'ɱ',
      'ɳ',
      'σ',
      'ρ',
      'ϙ',
      'ɾ',
      'ʂ',
      'ƚ',
      'υ',
      'ʋ',
      'ɯ',
      'x',
      'ყ',
      'ȥ',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [3],
    id: 42,
    mainCategory: FontCategory.Cool,
  },
  '43': {
    name: 'Metal Ümlauts',
    lower: [
      'ä',
      'ḅ',
      'ċ',
      'ḋ',
      'ë',
      'ḟ',
      'ġ',
      'ḧ',
      'ï',
      'j',
      'ḳ',
      'ḷ',
      'ṁ',
      'ṅ',
      'ö',
      'ṗ',
      'q',
      'ṛ',
      'ṡ',
      'ẗ',
      'ü',
      'ṿ',
      'ẅ',
      'ẍ',
      'ÿ',
      'ż',
    ],
    upper: [
      'Ä',
      'Ḅ',
      'Ċ',
      'Ḋ',
      'Ё',
      'Ḟ',
      'Ġ',
      'Ḧ',
      'Ї',
      'J',
      'Ḳ',
      'Ḷ',
      'Ṁ',
      'Ṅ',
      'Ö',
      'Ṗ',
      'Q',
      'Ṛ',
      'Ṡ',
      'Ṫ',
      'Ü',
      'Ṿ',
      'Ẅ',
      'Ẍ',
      'Ÿ',
      'Ż',
    ],
    digits: [],
    categories: [6],
    id: 43,
    mainCategory: FontCategory.Glitch,
  },
  '44': {
    name: 'Curvy',
    lower: [
      'ᗩ',
      'ᗷ',
      'ᑕ',
      'ᗪ',
      'E',
      'ᖴ',
      'G',
      'ᕼ',
      'I',
      'ᒍ',
      'K',
      'ᒪ',
      'ᗰ',
      'ᑎ',
      'O',
      'ᑭ',
      'ᑫ',
      'ᖇ',
      'ᔕ',
      'T',
      'ᑌ',
      'ᐯ',
      'ᗯ',
      '᙭',
      'Y',
      'ᘔ',
    ],
    upper: [
      'ᗩ',
      'ᗷ',
      'ᑕ',
      'ᗪ',
      'E',
      'ᖴ',
      'G',
      'ᕼ',
      'I',
      'ᒍ',
      'K',
      'ᒪ',
      'ᗰ',
      'ᑎ',
      'O',
      'ᑭ',
      'ᑫ',
      'ᖇ',
      'ᔕ',
      'T',
      'ᑌ',
      'ᐯ',
      'ᗯ',
      '᙭',
      'Y',
      'ᘔ',
    ],
    digits: [],
    categories: [3],
    id: 44,
    mainCategory: FontCategory.Cool,
  },
  '45': {
    name: 'Math Sans Italic',
    lower: [
      '𝘢',
      '𝘣',
      '𝘤',
      '𝘥',
      '𝘦',
      '𝘧',
      '𝘨',
      '𝘩',
      '𝘪',
      '𝘫',
      '𝘬',
      '𝘭',
      '𝘮',
      '𝘯',
      '𝘰',
      '𝘱',
      '𝘲',
      '𝘳',
      '𝘴',
      '𝘵',
      '𝘶',
      '𝘷',
      '𝘸',
      '𝘹',
      '𝘺',
      '𝘻',
    ],
    upper: [
      '𝘈',
      '𝘉',
      '𝘊',
      '𝘋',
      '𝘌',
      '𝘍',
      '𝘎',
      '𝘏',
      '𝘐',
      '𝘑',
      '𝘒',
      '𝘓',
      '𝘔',
      '𝘕',
      '𝘖',
      '𝘗',
      '𝘘',
      '𝘙',
      '𝘚',
      '𝘛',
      '𝘜',
      '𝘝',
      '𝘞',
      '𝘟',
      '𝘠',
      '𝘡',
    ],
    digits: [],
    categories: [1, 4],
    id: 45,
    mainCategory: FontCategory.Basic,
  },
  '46': {
    name: 'Boxed in',
    lower: [
      '[̲̅a]',
      '[̲̅b]',
      '[̲̅c]',
      '[̲̅d]',
      '[̲̅e]',
      '[̲̅f]',
      '[̲̅g]',
      '[̲̅h]',
      '[̲̅i]',
      '[̲̅j]',
      '[̲̅k]',
      '[̲̅l]',
      '[̲̅m]',
      '[̲̅n]',
      '[̲̅o]',
      '[̲̅p]',
      '[̲̅q]',
      '[̲̅r]',
      '[̲̅s]',
      '[̲̅t]',
      '[̲̅u]',
      '[̲̅v]',
      '[̲̅w]',
      '[̲̅x]',
      '[̲̅y]',
      '[̲̅z]',
    ],
    upper: [
      '[̲̅A]',
      '[̲̅B]',
      '[̲̅C]',
      '[̲̅D]',
      '[̲̅E]',
      '[̲̅F]',
      '[̲̅G]',
      '[̲̅H]',
      '[̲̅I]',
      '[̲̅J]',
      '[̲̅K]',
      '[̲̅L]',
      '[̲̅M]',
      '[̲̅N]',
      '[̲̅O]',
      '[̲̅P]',
      '[̲̅Q]',
      '[̲̅R]',
      '[̲̅S]',
      '[̲̅T]',
      '[̲̅U]',
      '[̲̅V]',
      '[̲̅W]',
      '[̲̅X]',
      '[̲̅Y]',
      '[̲̅Z]',
    ],
    digits: ['[̲̅0]', '[̲̅1]', '[̲̅2]', '[̲̅3]', '[̲̅4]', '[̲̅5]', '[̲̅6]', '[̲̅7]', '[̲̅8]', '[̲̅9]'],
    categories: [9],
    id: 46,
    mainCategory: FontCategory.Wrappers,
  },
  '47': {
    name: 'Arrows',
    lower: [
      '»a»',
      '»b»',
      '»c»',
      '»d»',
      '»e»',
      '»f»',
      '»g»',
      '»h»',
      '»i»',
      '»j»',
      '»k»',
      '»l»',
      '»m»',
      '»n»',
      '»o»',
      '»p»',
      '»q»',
      '»r»',
      '»s»',
      '»t»',
      '»u»',
      '»v»',
      '»w»',
      '»x»',
      '»y»',
      '»z»',
    ],
    upper: [
      '»A»',
      '»B»',
      '»C»',
      '»D»',
      '»E»',
      '»F»',
      '»G»',
      '»H»',
      '»I»',
      '»J»',
      '»K»',
      '»L»',
      '»M»',
      '»N»',
      '»O»',
      '»P»',
      '»Q»',
      '»R»',
      '»S»',
      '»T»',
      '»U»',
      '»V»',
      '»W»',
      '»X»',
      '»Y»',
      '»Z»',
    ],
    digits: ['»0»', '»1»', '»2»', '»3»', '»4»', '»5»', '»6»', '»7»', '»8»', '»9»'],
    categories: [8],
    prefix: '»»»',
    suffix: '»»»',
    id: 47,
    mainCategory: FontCategory.SymbolText,
  },
  '48': {
    name: 'Mixed Style 3',
    lower: [
      'α',
      '𝕓',
      '匚',
      'Đ',
      'ⓔ',
      '𝐟',
      'Ꮆ',
      'ｈ',
      '𝒾',
      'ʲ',
      'к',
      'ⓛ',
      'Μ',
      'ℕ',
      'ㄖ',
      'ᑭ',
      'ᵠ',
      'ℝ',
      '丂',
      '𝐭',
      'ᵘ',
      '𝓋',
      'ώ',
      'χ',
      '𝕐',
      '𝔃',
    ],
    upper: [
      'ᗩ',
      '𝐁',
      'Ｃ',
      '𝒹',
      '𝒆',
      '𝔣',
      '𝓰',
      '𝒽',
      '𝒾',
      'ڶ',
      'ķ',
      '𝔩',
      'ᗰ',
      '𝓃',
      '𝓸',
      '𝐏',
      'Ω',
      'ｒ',
      'ｓ',
      'ｔ',
      'υ',
      '𝓥',
      'ώ',
      'Ж',
      'Ƴ',
      'z',
    ],
    digits: ['０', '１', '❷', '３', '❹', '➄', '６', '７', '➇', '❾'],
    categories: [3, 6],
    id: 48,
    mainCategory: FontCategory.Glitch,
  },
  '49': {
    name: 'Math Italic',
    lower: [
      '𝒂',
      '𝒃',
      '𝒄',
      '𝒅',
      '𝒆',
      '𝒇',
      '𝒈',
      '𝒉',
      '𝒊',
      '𝒋',
      '𝒌',
      '𝒍',
      '𝒎',
      '𝒏',
      '𝒐',
      '𝒑',
      '𝒒',
      '𝒓',
      '𝒔',
      '𝒕',
      '𝒖',
      '𝒗',
      '𝒘',
      '𝒙',
      '𝒚',
      '𝒛',
    ],
    upper: [
      '𝑨',
      '𝑩',
      '𝑪',
      '𝑫',
      '𝑬',
      '𝑭',
      '𝑮',
      '𝑯',
      '𝑰',
      '𝑱',
      '𝑲',
      '𝑳',
      '𝑴',
      '𝑵',
      '𝑶',
      '𝑷',
      '𝑸',
      '𝑹',
      '𝑺',
      '𝑻',
      '𝑼',
      '𝑽',
      '𝑾',
      '𝑿',
      '𝒀',
      '𝒁',
    ],
    digits: [],
    categories: [1, 2, 4],
    id: 49,
    mainCategory: FontCategory.Basic,
  },
  '50': {
    name: 'Bandaid',
    lower: [
      'a͓̽',
      '͓̽b͓̽',
      '͓̽c͓̽',
      '͓̽d͓̽',
      '͓̽e͓̽',
      '͓̽f͓̽',
      '͓̽g͓̽',
      '͓̽h͓̽',
      '͓̽i͓̽',
      '͓̽j͓̽',
      '͓̽k͓̽',
      '͓̽l͓̽',
      '͓̽m͓̽',
      '͓̽n͓̽',
      '͓̽o͓̽',
      '͓̽p͓̽',
      '͓̽q͓̽',
      '͓̽r͓̽',
      '͓̽s͓̽',
      '͓̽t͓̽',
      '͓̽u͓̽',
      '͓̽v͓̽',
      '͓̽w͓̽',
      '͓̽x͓̽',
      '͓̽y͓̽',
      '͓̽z͓̽',
    ],
    upper: [
      '͓̽A͓̽',
      '͓̽B͓̽',
      '͓̽C͓̽',
      '͓̽D͓̽',
      '͓̽E͓̽',
      '͓̽F͓̽',
      '͓̽G͓̽',
      '͓̽H͓̽',
      '͓̽I͓̽',
      '͓̽J͓̽',
      '͓̽K͓̽',
      '͓̽L͓̽',
      '͓̽M͓̽',
      '͓̽N͓̽',
      '͓̽O͓̽',
      '͓̽P͓̽',
      '͓̽Q͓̽',
      '͓̽R͓̽',
      '͓̽S͓̽',
      '͓̽T͓̽',
      '͓̽U͓̽',
      '͓̽V͓̽',
      '͓̽W͓̽',
      '͓̽X͓̽',
      '͓̽Y͓̽',
      '͓̽Z͓̽',
    ],
    digits: ['͓̽0͓̽', '͓̽1͓̽', '͓̽2͓̽', '͓̽3͓̽', '͓̽4͓̽', '͓̽5͓̽', '͓̽6͓̽', '͓̽7͓̽', '͓̽8͓̽', '͓̽9͓̽'],
    categories: [6],
    id: 50,
    mainCategory: FontCategory.Glitch,
  },
  '51': {
    name: 'Delta',
    lower: [
      'Δ',
      'β',
      'Ć',
      'Đ',
      '€',
      '₣',
      'Ǥ',
      'Ħ',
      'Ɨ',
      'Ĵ',
      'Ҝ',
      'Ł',
      'Μ',
      'Ň',
      'Ø',
      'Ƥ',
      'Ω',
      'Ř',
      'Ş',
      'Ŧ',
      'Ữ',
      'V',
      'Ŵ',
      'Ж',
      '¥',
      'Ž',
    ],
    upper: [
      'Δ',
      'β',
      'Ć',
      'Đ',
      '€',
      '₣',
      'Ǥ',
      'Ħ',
      'Ɨ',
      'Ĵ',
      'Ҝ',
      'Ł',
      'Μ',
      'Ň',
      'Ø',
      'Ƥ',
      'Ω',
      'Ř',
      'Ş',
      'Ŧ',
      'Ữ',
      'V',
      'Ŵ',
      'Ж',
      '¥',
      'Ž',
    ],
    digits: [],
    categories: [6],
    id: 51,
    mainCategory: FontCategory.Glitch,
  },
  '52': {
    name: 'Math Style',
    lower: [
      'α',
      'в',
      '¢',
      '∂',
      'є',
      'ƒ',
      'g',
      'н',
      'ι',
      'נ',
      'к',
      'ℓ',
      'м',
      'η',
      'σ',
      'ρ',
      'q',
      'я',
      'ѕ',
      'т',
      'υ',
      'ν',
      'ω',
      'χ',
      'у',
      'z',
    ],
    upper: [
      'α',
      'в',
      '¢',
      '∂',
      'є',
      'ƒ',
      'g',
      'н',
      'ι',
      'נ',
      'к',
      'ℓ',
      'м',
      'η',
      'σ',
      'ρ',
      'q',
      'я',
      'ѕ',
      'т',
      'υ',
      'ν',
      'ω',
      'χ',
      'у',
      'z',
    ],
    digits: [],
    categories: [3, FontCategory.Small],
    id: 52,
    mainCategory: FontCategory.Cool,
  },
  '53': {
    name: 'Windy',
    lower: [
      '≋a≋',
      '≋b≋',
      '≋c≋',
      '≋d≋',
      '≋e≋',
      '≋f≋',
      '≋g≋',
      '≋h≋',
      '≋i≋',
      '≋j≋',
      '≋k≋',
      '≋l≋',
      '≋m≋',
      '≋n≋',
      '≋o≋',
      '≋p≋',
      '≋q≋',
      '≋r≋',
      '≋s≋',
      '≋t≋',
      '≋u≋',
      '≋v≋',
      '≋w≋',
      '≋x≋',
      '≋y≋',
      '≋z≋',
    ],
    upper: [
      '≋A≋',
      '≋B≋',
      '≋C≋',
      '≋D≋',
      '≋E≋',
      '≋F≋',
      '≋G≋',
      '≋H≋',
      '≋I≋',
      '≋J≋',
      '≋K≋',
      '≋L≋',
      '≋M≋',
      '≋N≋',
      '≋O≋',
      '≋P≋',
      '≋Q≋',
      '≋R≋',
      '≋S≋',
      '≋T≋',
      '≋U≋',
      '≋V≋',
      '≋W≋',
      '≋X≋',
      '≋Y≋',
      '≋Z≋',
    ],
    digits: ['≋0≋', '≋1≋', '≋2≋', '≋3≋', '≋4≋', '≋5≋', '≋6≋', '≋7≋', '≋8≋', '≋9≋'],
    categories: [9],
    id: 53,
    mainCategory: FontCategory.Wrappers,
  },
  '54': {
    name: 'Strikethrough',
    lower: [
      '̶a̶',
      '̶b̶',
      '̶c̶',
      '̶d̶',
      '̶e̶',
      '̶f̶',
      '̶g̶',
      '̶h̶',
      '̶i̶',
      '̶j̶',
      '̶k̶',
      '̶l̶',
      '̶m̶',
      '̶n̶',
      '̶o̶',
      '̶p̶',
      '̶q̶',
      '̶r̶',
      '̶s̶',
      '̶t̶',
      '̶u̶',
      '̶v̶',
      '̶w̶',
      '̶x̶',
      '̶y̶',
      '̶z̶',
    ],
    upper: [
      '̶A̶',
      '̶B̶',
      '̶C̶',
      '̶D̶',
      '̶E̶',
      '̶F̶',
      '̶G̶',
      '̶H̶',
      '̶I̶',
      '̶J̶',
      '̶K̶',
      '̶L̶',
      '̶M̶',
      '̶N̶',
      '̶O̶',
      '̶P̶',
      '̶Q̶',
      '̶R̶',
      '̶S̶',
      '̶T̶',
      '̶U̶',
      '̶V̶',
      '̶W̶',
      '̶X̶',
      '̶Y̶',
      '̶Z̶',
    ],
    digits: ['̶0̶', '̶1̶', '̶2̶', '̶3̶', '̶4̶', '̶5̶', '̶6̶', '̶7̶', '̶8̶', '̶9̶'],
    categories: [6],
    id: 54,
    mainCategory: FontCategory.Glitch,
  },
  '55': {
    name: 'X-cross',
    lower: [
      'ͯaͯ',
      'ͯbͯ',
      'ͯcͯ',
      'ͯdͯ',
      'ͯeͯ',
      'ͯfͯ',
      'ͯgͯ',
      'ͯhͯ',
      'ͯiͯ',
      'ͯjͯ',
      'ͯkͯ',
      'ͯlͯ',
      'ͯmͯ',
      'ͯnͯ',
      'ͯoͯ',
      'ͯpͯ',
      'ͯqͯ',
      'ͯrͯ',
      'ͯsͯ',
      'ͯtͯ',
      'ͯuͯ',
      'ͯvͯ',
      'ͯwͯ',
      'ͯxͯ',
      'ͯyͯ',
      'ͯzͯ',
    ],
    upper: [
      'ͯAͯ',
      'ͯBͯ',
      'ͯCͯ',
      'ͯDͯ',
      'ͯEͯ',
      'ͯFͯ',
      'ͯGͯ',
      'ͯHͯ',
      'ͯIͯ',
      'ͯJͯ',
      'ͯKͯ',
      'ͯLͯ',
      'ͯMͯ',
      'ͯNͯ',
      'ͯOͯ',
      'ͯPͯ',
      'ͯQͯ',
      'ͯRͯ',
      'ͯSͯ',
      'ͯTͯ',
      'ͯUͯ',
      'ͯVͯ',
      'ͯWͯ',
      'ͯXͯ',
      'ͯYͯ',
      'ͯZͯ',
    ],
    digits: ['ͯ0ͯ', 'ͯ1ͯ', 'ͯ2ͯ', 'ͯ3ͯ', 'ͯ4ͯ', 'ͯ5ͯ', 'ͯ6ͯ', 'ͯ7ͯ', 'ͯ8ͯ', 'ͯ9ͯ'],
    categories: [6],
    id: 55,
    mainCategory: FontCategory.Glitch,
  },
  '56': {
    name: 'Yatagan',
    lower: [
      'ค',
      '๖',
      '¢',
      '໓',
      'ē',
      'f',
      'ງ',
      'h',
      'i',
      'ว',
      'k',
      'l',
      '๓',
      'ຖ',
      '໐',
      'p',
      '๑',
      'r',
      'Ş',
      't',
      'น',
      'ง',
      'ຟ',
      'x',
      'ฯ',
      'ຊ',
    ],
    upper: [
      'ค',
      '๖',
      '¢',
      '໓',
      'ē',
      'f',
      'ງ',
      'h',
      'i',
      'ว',
      'k',
      'l',
      '๓',
      'ຖ',
      '໐',
      'p',
      '๑',
      'r',
      'Ş',
      't',
      'น',
      'ง',
      'ຟ',
      'x',
      'ฯ',
      'ຊ',
    ],
    digits: [],
    categories: [3],
    id: 56,
    mainCategory: FontCategory.Cool,
  },
  '57': {
    name: 'Soviet',
    lower: [
      'ӓ',
      'ѣ',
      'ҁ',
      'd',
      'Э',
      'f',
      'g',
      'ћ',
      'ї',
      'j',
      'К',
      'l',
      'm',
      'ђ',
      'ѳ',
      'p',
      'q',
      'Г',
      's',
      'ҭ',
      'Ч',
      'ѵ',
      'Ш',
      'x',
      'ӳ',
      'z',
    ],
    upper: [
      'Д',
      'Ѣ',
      'Ҁ',
      'D',
      'З',
      'F',
      'G',
      'њ',
      'I',
      'J',
      'К',
      'L',
      'M',
      'Й',
      'Ф',
      'P',
      'Q',
      'Я',
      'S',
      'Ҭ',
      'Ц',
      'V',
      'Ш',
      'Ж',
      'Ӳ',
      'Z',
    ],
    digits: [],
    categories: [3],
    id: 57,
    mainCategory: FontCategory.Cool,
  },
  '58': {
    name: 'Xeperated',
    lower: [
      '྾a྾',
      '྾b྾',
      '྾c྾',
      '྾d྾',
      '྾e྾',
      '྾f྾',
      '྾g྾',
      '྾h྾',
      '྾i྾',
      '྾j྾',
      '྾k྾',
      '྾l྾',
      '྾m྾',
      '྾n྾',
      '྾o྾',
      '྾p྾',
      '྾q྾',
      '྾r྾',
      '྾s྾',
      '྾t྾',
      '྾u྾',
      '྾v྾',
      '྾w྾',
      '྾x྾',
      '྾y྾',
      '྾z྾',
    ],
    upper: [
      '྾A྾',
      '྾B྾',
      '྾C྾',
      '྾D྾',
      '྾E྾',
      '྾F྾',
      '྾G྾',
      '྾H྾',
      '྾I྾',
      '྾J྾',
      '྾K྾',
      '྾L྾',
      '྾M྾',
      '྾N྾',
      '྾O྾',
      '྾P྾',
      '྾Q྾',
      '྾R྾',
      '྾S྾',
      '྾T྾',
      '྾U྾',
      '྾V྾',
      '྾W྾',
      '྾X྾',
      '྾Y྾',
      '྾Z྾',
    ],
    digits: ['྾0྾', '྾1྾', '྾2྾', '྾3྾', '྾4྾', '྾5྾', '྾6྾', '྾7྾', '྾8྾', '྾9྾'],
    categories: [9],
    id: 58,
    mainCategory: FontCategory.Wrappers,
  },
  '59': {
    name: 'Stroked',
    lower: [
      'Ⱥ',
      'ƀ',
      'ȼ',
      'đ',
      'ɇ',
      'f',
      'ǥ',
      'ħ',
      'ɨ',
      'ɉ',
      'ꝁ',
      'ł',
      'm',
      'n',
      'ø',
      'ᵽ',
      'ꝗ',
      'ɍ',
      's',
      'ŧ',
      'ᵾ',
      'v',
      'w',
      'x',
      'ɏ',
      'ƶ',
    ],
    upper: [
      'Ⱥ',
      'Ƀ',
      'Ȼ',
      'Đ',
      'Ɇ',
      'F',
      'Ǥ',
      'Ħ',
      'Ɨ',
      'Ɉ',
      'Ꝁ',
      'Ł',
      'M',
      'N',
      'Ø',
      'Ᵽ',
      'Ꝗ',
      'Ɍ',
      'S',
      'Ŧ',
      'ᵾ',
      'V',
      'W',
      'X',
      'Ɏ',
      'Ƶ',
    ],
    digits: [],
    categories: [6],
    id: 59,
    mainCategory: FontCategory.Glitch,
  },
  '60': {
    name: 'Math Bold',
    lower: [
      '𝐚',
      '𝐛',
      '𝐜',
      '𝐝',
      '𝐞',
      '𝐟',
      '𝐠',
      '𝐡',
      '𝐢',
      '𝐣',
      '𝐤',
      '𝐥',
      '𝐦',
      '𝐧',
      '𝐨',
      '𝐩',
      '𝐪',
      '𝐫',
      '𝐬',
      '𝐭',
      '𝐮',
      '𝐯',
      '𝐰',
      '𝐱',
      '𝐲',
      '𝐳',
    ],
    upper: [
      '𝐀',
      '𝐁',
      '𝐂',
      '𝐃',
      '𝐄',
      '𝐅',
      '𝐆',
      '𝐇',
      '𝐈',
      '𝐉',
      '𝐊',
      '𝐋',
      '𝐌',
      '𝐍',
      '𝐎',
      '𝐏',
      '𝐐',
      '𝐑',
      '𝐒',
      '𝐓',
      '𝐔',
      '𝐕',
      '𝐖',
      '𝐗',
      '𝐘',
      '𝐙',
    ],
    digits: [],
    categories: [1, 2],
    id: 60,
    mainCategory: FontCategory.Basic,
  },
  '61': {
    name: 'Lines, Lines, Lines.',
    lower: [
      'a̳̿͟͞',
      'b̳̿͟͞',
      'c̳̿͟͞',
      'd̳̿͟͞',
      'e̳̿͟͞',
      'f̳̿͟͞',
      'g̳̿͟͞',
      'h̳̿͟͞',
      'i̳̿͟͞',
      'j̳̿͟͞',
      'k̳̿͟͞',
      'l̳̿͟͞',
      'm̳̿͟͞',
      'n̳̿͟͞',
      'o̳̿͟͞',
      'p̳̿͟͞',
      'q̳̿͟͞',
      'r̳̿͟͞',
      's̳̿͟͞',
      't̳̿͟͞',
      'u̳̿͟͞',
      'v̳̿͟͞',
      'w̳̿͟͞',
      'x̳̿͟͞',
      'y̳̿͟͞',
      'z̳̿͟͞',
    ],
    upper: [
      'A̳̿͟͞',
      'B̳̿͟͞',
      'C̳̿͟͞',
      'D̳̿͟͞',
      'E̳̿͟͞',
      'F̳̿͟͞',
      'G̳̿͟͞',
      'H̳̿͟͞',
      'I̳̿͟͞',
      'J̳̿͟͞',
      'K̳̿͟͞',
      'L̳̿͟͞',
      'M̳̿͟͞',
      'N̳̿͟͞',
      'O̳̿͟͞',
      'P̳̿͟͞',
      'Q̳̿͟͞',
      'R̳̿͟͞',
      'S̳̿͟͞',
      'T̳̿͟͞',
      'U̳̿͟͞',
      'V̳̿͟͞',
      'W̳̿͟͞',
      'X̳̿͟͞',
      'Y̳̿͟͞',
      'Z̳̿͟͞',
    ],
    digits: ['0̳̿͟͞', '1̳̿͟͞', '2̳̿͟͞', '3̳̿͟͞', '4̳̿͟͞', '5̳̿͟͞', '6̳̿͟͞', '7̳̿͟͞', '8̳̿͟͞', '9̳̿͟͞'],
    categories: [6],
    id: 61,
    mainCategory: FontCategory.Glitch,
  },
  '62': {
    name: 'Anchor Style',
    lower: [
      'ą',
      'ҍ',
      'ç',
      'ժ',
      'ҽ',
      'ƒ',
      'ց',
      'հ',
      'ì',
      'ʝ',
      'ҟ',
      'Ӏ',
      'ʍ',
      'ղ',
      'օ',
      'ք',
      'զ',
      'ɾ',
      'ʂ',
      'է',
      'մ',
      'ѵ',
      'ա',
      '×',
      'վ',
      'Հ',
    ],
    upper: [
      'Ⱥ',
      'β',
      '↻',
      'Ꭰ',
      'Ɛ',
      'Ƒ',
      'Ɠ',
      'Ƕ',
      'į',
      'ل',
      'Ҡ',
      'Ꝉ',
      'Ɱ',
      'ហ',
      'ට',
      'φ',
      'Ҩ',
      'འ',
      'Ϛ',
      'Ͳ',
      'Ա',
      'Ỽ',
      'చ',
      'ჯ',
      'Ӌ',
      'ɀ',
    ],
    digits: ['0', '1', 'ϩ', 'Ӡ', '५', 'Ƽ', 'Ϭ', '7', '8', '9'],
    categories: [6],
    id: 62,
    mainCategory: FontCategory.Glitch,
  },
  '63': {
    name: 'Print Stamp',
    lower: [
      '░a░',
      '░b░',
      '░c░',
      '░d░',
      '░e░',
      '░f░',
      '░g░',
      '░h░',
      '░i░',
      '░j░',
      '░k░',
      '░l░',
      '░m░',
      '░n░',
      '░o░',
      '░p░',
      '░q░',
      '░r░',
      '░s░',
      '░t░',
      '░u░',
      '░v░',
      '░w░',
      '░x░',
      '░y░',
      '░z░',
    ],
    upper: [
      '░A░',
      '░B░',
      '░C░',
      '░D░',
      '░E░',
      '░F░',
      '░G░',
      '░H░',
      '░I░',
      '░J░',
      '░K░',
      '░L░',
      '░M░',
      '░N░',
      '░O░',
      '░P░',
      '░Q░',
      '░R░',
      '░S░',
      '░T░',
      '░U░',
      '░V░',
      '░W░',
      '░X░',
      '░Y░',
      '░Z░',
    ],
    digits: ['░0░', '░1░', '░2░', '░3░', '░4░', '░5░', '░6░', '░7░', '░8░', '░9░'],
    categories: [9],
    id: 63,
    mainCategory: FontCategory.Wrappers,
  },
  '64': {
    name: 'Hook Brackets',
    lower: [
      '『a』',
      '『b』',
      '『c』',
      '『d』',
      '『e』',
      '『f』',
      '『g』',
      '『h』',
      '『i』',
      '『j』',
      '『k』',
      '『l』',
      '『m』',
      '『n』',
      '『o』',
      '『p』',
      '『q』',
      '『r』',
      '『s』',
      '『t』',
      '『u』',
      '『v』',
      '『w』',
      '『x』',
      '『y』',
      '『z』',
    ],
    upper: [
      '『A』',
      '『B』',
      '『C』',
      '『D』',
      '『E』',
      '『F』',
      '『G』',
      '『H』',
      '『I』',
      '『J』',
      '『K』',
      '『L』',
      '『M』',
      '『N』',
      '『O』',
      '『P』',
      '『Q』',
      '『R』',
      '『S』',
      '『T』',
      '『U』',
      '『V』',
      '『W』',
      '『X』',
      '『Y』',
      '『Z』',
    ],
    digits: [
      '『0』',
      '『1』',
      '『2』',
      '『3』',
      '『4』',
      '『5』',
      '『6』',
      '『7』',
      '『8』',
      '『9』',
    ],
    categories: [9],
    id: 64,
    mainCategory: FontCategory.Wrappers,
  },
  '65': {
    name: 'Double Strokes',
    lower: [
      '₳',
      '฿',
      '₵',
      'Đ',
      'Ɇ',
      '₣',
      '₲',
      'Ⱨ',
      'ł',
      'J',
      '₭',
      'Ⱡ',
      '₥',
      '₦',
      'Ø',
      '₱',
      'Q',
      'Ɽ',
      '₴',
      '₮',
      'Ʉ',
      'V',
      '₩',
      'Ӿ',
      'Ɏ',
      'Ⱬ',
    ],
    upper: [
      '₳',
      '฿',
      '₵',
      'Đ',
      'Ɇ',
      '₣',
      '₲',
      'Ⱨ',
      'ł',
      'J',
      '₭',
      'Ⱡ',
      '₥',
      '₦',
      'Ø',
      '₱',
      'Q',
      'Ɽ',
      '₴',
      '₮',
      'Ʉ',
      'V',
      '₩',
      'Ӿ',
      'Ɏ',
      'Ⱬ',
    ],
    digits: [],
    categories: [6],
    id: 65,
    mainCategory: FontCategory.Glitch,
  },
  '66': {
    name: 'Shadow',
    lower: [
      '̷a̷',
      '̷b̷',
      '̷c̷',
      '̷d̷',
      '̷e̷',
      '̷f̷',
      '̷g̷',
      '̷h̷',
      '̷i̷',
      '̷j̷',
      '̷k̷',
      '̷l̷',
      '̷m̷',
      '̷n̷',
      '̷o̷',
      '̷p̷',
      '̷q̷',
      '̷r̷',
      '̷s̷',
      '̷t̷',
      '̷u̷',
      '̷v̷',
      '̷w̷',
      '̷x̷',
      '̷y̷',
      '̷z̷',
    ],
    upper: [
      '̷A̷',
      '̷B̷',
      '̷C̷',
      '̷D̷',
      '̷E̷',
      '̷F̷',
      '̷G̷',
      '̷H̷',
      '̷I̷',
      '̷J̷',
      '̷K̷',
      '̷L̷',
      '̷M̷',
      '̷N̷',
      '̷O̷',
      '̷P̷',
      '̷Q̷',
      '̷R̷',
      '̷S̷',
      '̷T̷',
      '̷U̷',
      '̷V̷',
      '̷W̷',
      '̷X̷',
      '̷Y̷',
      '̷Z̷',
    ],
    digits: ['̷0̷', '̷1̷', '̷2̷', '̷3̷', '̷4̷', '̷5̷', '̷6̷', '̷7̷', '̷8̷', '̷9̷'],
    categories: [6],
    id: 66,
    mainCategory: FontCategory.Glitch,
  },
  '67': {
    name: 'Fireworks',
    lower: [
      '҉a҉',
      '҉b҉',
      '҉c҉',
      '҉d҉',
      '҉e҉',
      '҉f҉',
      '҉g҉',
      '҉h҉',
      '҉i҉',
      '҉j҉',
      '҉k҉',
      '҉l҉',
      '҉m҉',
      '҉n҉',
      '҉o҉',
      '҉p҉',
      '҉q҉',
      '҉r҉',
      '҉s҉',
      '҉t҉',
      '҉u҉',
      '҉v҉',
      '҉w҉',
      '҉x҉',
      '҉y҉',
      '҉z҉',
    ],
    upper: [
      '҉A҉',
      '҉B҉',
      '҉C҉',
      '҉D҉',
      '҉E҉',
      '҉F҉',
      '҉G҉',
      '҉H҉',
      '҉I҉',
      '҉J҉',
      '҉K҉',
      '҉L҉',
      '҉M҉',
      '҉N҉',
      '҉O҉',
      '҉P҉',
      '҉Q҉',
      '҉R҉',
      '҉S҉',
      '҉T҉',
      '҉U҉',
      '҉V҉',
      '҉W҉',
      '҉X҉',
      '҉Y҉',
      '҉Z҉',
    ],
    digits: ['҉0҉', '҉1҉', '҉2҉', '҉3҉', '҉4҉', '҉5҉', '҉6҉', '҉7҉', '҉8҉', '҉9҉'],
    categories: [6],
    id: 67,
    mainCategory: FontCategory.Glitch,
  },
  '68': {
    name: 'Pointing Back',
    lower: [
      '«a«',
      '«b«',
      '«c«',
      '«d«',
      '«e«',
      '«f«',
      '«g«',
      '«h«',
      '«i«',
      '«j«',
      '«k«',
      '«l«',
      '«m«',
      '«n«',
      '«o«',
      '«p«',
      '«q«',
      '«r«',
      '«s«',
      '«t«',
      '«u«',
      '«v«',
      '«w«',
      '«x«',
      '«y«',
      '«z«',
    ],
    upper: [
      '«A«',
      '«B«',
      '«C«',
      '«D«',
      '«E«',
      '«F«',
      '«G«',
      '«H«',
      '«I«',
      '«J«',
      '«K«',
      '«L«',
      '«M«',
      '«N«',
      '«O«',
      '«P«',
      '«Q«',
      '«R«',
      '«S«',
      '«T«',
      '«U«',
      '«V«',
      '«W«',
      '«X«',
      '«Y«',
      '«Z«',
    ],
    digits: ['«0«', '«1«', '«2«', '«3«', '«4«', '«5«', '«6«', '«7«', '«8«', '«9«'],
    categories: [9],
    id: 68,
    mainCategory: FontCategory.Wrappers,
  },
  '69': {
    name: 'Pointing Forward',
    lower: [
      '»a»',
      '»b»',
      '»c»',
      '»d»',
      '»e»',
      '»f»',
      '»g»',
      '»h»',
      '»i»',
      '»j»',
      '»k»',
      '»l»',
      '»m»',
      '»n»',
      '»o»',
      '»p»',
      '»q»',
      '»r»',
      '»s»',
      '»t»',
      '»u»',
      '»v»',
      '»w»',
      '»x»',
      '»y»',
      '»z»',
    ],
    upper: [
      '»A»',
      '»B»',
      '»C»',
      '»D»',
      '»E»',
      '»F»',
      '»G»',
      '»H»',
      '»I»',
      '»J»',
      '»K»',
      '»L»',
      '»M»',
      '»N»',
      '»O»',
      '»P»',
      '»Q»',
      '»R»',
      '»S»',
      '»T»',
      '»U»',
      '»V»',
      '»W»',
      '»X»',
      '»Y»',
      '»Z»',
    ],
    digits: ['»0»', '»1»', '»2»', '»3»', '»4»', '»5»', '»6»', '»7»', '»8»', '»9»'],
    categories: [9],
    id: 69,
    mainCategory: FontCategory.Wrappers,
  },
  '70': {
    name: 'Air Quotes',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', ''],
    categories: [2, 4, 8],
    prefix: '✌',
    suffix: '✌',
    id: 70,
    mainCategory: FontCategory.SymbolText,
  },
  '71': {
    name: 'Manuscript',
    lower: [
      '𝖆',
      '𝖇',
      '𝖈',
      '𝖉',
      '𝖊',
      '𝖋',
      '𝖌',
      '𝖍',
      '𝖎',
      '𝖏',
      '𝖐',
      '𝖑',
      '𝖒',
      '𝖓',
      '𝖔',
      '𝖕',
      '𝖖',
      '𝖗',
      '𝖘',
      '𝖙',
      '𝖚',
      '𝖛',
      '𝖜',
      '𝖝',
      '𝖞',
      '𝖟',
    ],
    upper: [
      '𝕬',
      '𝕭',
      '𝕮',
      '𝕯',
      '𝕰',
      '𝕱',
      '𝕲',
      '𝕳',
      '𝕴',
      '𝕵',
      '𝕶',
      '𝕷',
      '𝕸',
      '𝕹',
      '𝕺',
      '𝕻',
      '𝕼',
      '𝕽',
      '𝕾',
      '𝕿',
      '𝖀',
      '𝖁',
      '𝖂',
      '𝖃',
      '𝖄',
      '𝖅',
    ],
    digits: ['𝟎', '𝟏', '𝟐', '𝟑', '𝟒', '𝟓', '𝟔', '𝟕', '𝟖', '𝟗'],
    categories: [2, 5, 8],
    suffix: '✍',
    id: 71,
    mainCategory: FontCategory.SymbolText,
  },
  '72': {
    name: 'Wavy',
    lower: [
      'a̴',
      '̴b̴',
      '̴c̴',
      '̴d̴',
      '̴e̴',
      '̴f̴',
      '̴g̴',
      '̴h̴',
      '̴i̴',
      '̴j̴',
      '̴k̴',
      '̴l̴',
      '̴m̴',
      '̴n̴',
      '̴o̴',
      '̴p̴',
      '̴q̴',
      '̴r̴',
      '̴s̴',
      '̴t̴',
      '̴u̴',
      '̴v̴',
      '̴w̴',
      '̴x̴',
      '̴y̴',
      '̴z̴',
    ],
    upper: [
      '̴A̴',
      '̴B̴',
      '̴C̴',
      '̴D̴',
      '̴E̴',
      '̴F̴',
      '̴G̴',
      '̴H̴',
      '̴I̴',
      '̴J̴',
      '̴K̴',
      '̴L̴',
      '̴M̴',
      '̴N̴',
      '̴O̴',
      '̴P̴',
      '̴Q̴',
      '̴R̴',
      '̴S̴',
      '̴T̴',
      '̴U̴',
      '̴V̴',
      '̴W̴',
      '̴X̴',
      '̴Y̴',
      '̴Z̴',
    ],
    digits: ['̴0̴', '̴1̴', '̴2̴', '̴3̴', '̴4̴', '̴5̴', '̴6̴', '̴7̴', '̴8̴', '̴9̴'],
    categories: [6],
    id: 72,
    mainCategory: FontCategory.Glitch,
  },
  '73': {
    name: 'Double Underlines',
    lower: [
      'a̲',
      '̲b̲',
      '̲c̲',
      '̲d̲',
      '̲e̲',
      '̲f̲',
      '̲g̲',
      '̲h̲',
      '̲i̲',
      '̲j̲',
      '̲k̲',
      '̲l̲',
      '̲m̲',
      '̲n̲',
      '̲o̲',
      '̲p̲',
      '̲q̲',
      '̲r̲',
      '̲s̲',
      '̲t̲',
      '̲u̲',
      '̲v̲',
      '̲w̲',
      '̲x̲',
      '̲y̲',
      '̲z̲',
    ],
    upper: [
      '̲A̲',
      '̲B̲',
      '̲C̲',
      '̲D̲',
      '̲E̲',
      '̲F̲',
      '̲G̲',
      '̲H̲',
      '̲I̲',
      '̲J̲',
      '̲K̲',
      '̲L̲',
      '̲M̲',
      '̲N̲',
      '̲O̲',
      '̲P̲',
      '̲Q̲',
      '̲R̲',
      '̲S̲',
      '̲T̲',
      '̲U̲',
      '̲V̲',
      '̲W̲',
      '̲X̲',
      '̲Y̲',
      '̲Z̲',
    ],
    digits: ['̲0̲', '̲1̲', '̲2̲', '̲3̲', '̲4̲', '̲5̲', '̲6̲', '̲7̲', '̲8̲', '̲9̲'],
    categories: [6],
    id: 73,
    mainCategory: FontCategory.Glitch,
  },
  '74': {
    name: 'Double Double Dots',
    lower: [
      'ᆢaᆢ',
      'ᆢbᆢ',
      'ᆢcᆢ',
      'ᆢdᆢ',
      'ᆢeᆢ',
      'ᆢfᆢ',
      'ᆢgᆢ',
      'ᆢhᆢ',
      'ᆢiᆢ',
      'ᆢjᆢ',
      'ᆢkᆢ',
      'ᆢlᆢ',
      'ᆢmᆢ',
      'ᆢnᆢ',
      'ᆢoᆢ',
      'ᆢpᆢ',
      'ᆢqᆢ',
      'ᆢrᆢ',
      'ᆢsᆢ',
      'ᆢtᆢ',
      'ᆢuᆢ',
      'ᆢvᆢ',
      'ᆢwᆢ',
      'ᆢxᆢ',
      'ᆢyᆢ',
      'ᆢzᆢ',
    ],
    upper: [
      'ᆢAᆢ',
      'ᆢBᆢ',
      'ᆢCᆢ',
      'ᆢDᆢ',
      'ᆢEᆢ',
      'ᆢFᆢ',
      'ᆢGᆢ',
      'ᆢHᆢ',
      'ᆢIᆢ',
      'ᆢJᆢ',
      'ᆢKᆢ',
      'ᆢLᆢ',
      'ᆢMᆢ',
      'ᆢNᆢ',
      'ᆢOᆢ',
      'ᆢPᆢ',
      'ᆢQᆢ',
      'ᆢRᆢ',
      'ᆢSᆢ',
      'ᆢTᆢ',
      'ᆢUᆢ',
      'ᆢVᆢ',
      'ᆢWᆢ',
      'ᆢXᆢ',
      'ᆢYᆢ',
      'ᆢZᆢ',
    ],
    digits: ['ᆢ0ᆢ', 'ᆢ1ᆢ', 'ᆢ2ᆢ', 'ᆢ3ᆢ', 'ᆢ4ᆢ', 'ᆢ5ᆢ', 'ᆢ6ᆢ', 'ᆢ7ᆢ', 'ᆢ8ᆢ', 'ᆢ9ᆢ'],
    categories: [9],
    id: 74,
    mainCategory: FontCategory.Wrappers,
  },
  '75': {
    name: 'Hourglass',
    lower: [
      'a',
      '♭',
      '꒞',
      '꒯',
      '㉹',
      'f',
      '꒸',
      '♬',
      'ﭐ',
      '꒻',
      'k',
      'L',
      'Ѫ',
      'ո',
      '♡',
      'р',
      'զ',
      'r',
      'Ֆ',
      '†',
      'ﮠ',
      'v',
      'ա',
      '꒾',
      'վ',
      'Հ',
    ],
    upper: [
      'A',
      '♭',
      '꒞',
      '꒯',
      '㉹',
      'f',
      '꒸',
      '♬',
      'ﭐ',
      '꒻',
      'k',
      'L',
      'Ѫ',
      'ո',
      '♡',
      'р',
      'զ',
      'r',
      'Ֆ',
      '†',
      'ﮠ',
      'v',
      'ա',
      '꒾',
      'վ',
      'Հ',
    ],
    digits: [],
    categories: [6],
    id: 75,
    mainCategory: FontCategory.Glitch,
  },
  '76': {
    name: 'Cryptic',
    lower: [
      'ᗩ',
      'ᗷ',
      'ᑢ',
      'ᕲ',
      'ᘿ',
      'ᖴ',
      'ᘜ',
      'ᕼ',
      'ᓰ',
      'ᒚ',
      'k',
      'ᒪ',
      'ᘻ',
      'ᘉ',
      'ᓍ',
      'ᕵ',
      'ᕴ',
      'ᖇ',
      'S',
      'ᖶ',
      'ᑘ',
      'ᐺ',
      'ᘺ',
      '᙭',
      'ᖻ',
      'ᗱ',
    ],
    upper: [
      'ᗩ',
      'ᗷ',
      'ᑢ',
      'ᕲ',
      'ᘿ',
      'ᖴ',
      'ᘜ',
      'ᕼ',
      'ᓰ',
      'ᒚ',
      'K',
      'ᒪ',
      'ᘻ',
      'ᘉ',
      'ᓍ',
      'ᕵ',
      'ᕴ',
      'ᖇ',
      'S',
      'ᖶ',
      'ᑘ',
      'ᐺ',
      'ᘺ',
      '᙭',
      'ᖻ',
      'ᗱ',
    ],
    digits: [],
    categories: [6],
    id: 76,
    mainCategory: FontCategory.Glitch,
  },
  '77': {
    name: 'Double Lines',
    lower: [
      'ᆖaᆖ',
      'ᆖbᆖ',
      'ᆖcᆖ',
      'ᆖdᆖ',
      'ᆖeᆖ',
      'ᆖfᆖ',
      'ᆖgᆖ',
      'ᆖhᆖ',
      'ᆖiᆖ',
      'ᆖjᆖ',
      'ᆖkᆖ',
      'ᆖlᆖ',
      'ᆖmᆖ',
      'ᆖnᆖ',
      'ᆖoᆖ',
      'ᆖpᆖ',
      'ᆖqᆖ',
      'ᆖrᆖ',
      'ᆖsᆖ',
      'ᆖtᆖ',
      'ᆖuᆖ',
      'ᆖvᆖ',
      'ᆖwᆖ',
      'ᆖxᆖ',
      'ᆖyᆖ',
      'ᆖzᆖ',
    ],
    upper: [
      'ᆖAᆖ',
      'ᆖBᆖ',
      'ᆖCᆖ',
      'ᆖDᆖ',
      'ᆖEᆖ',
      'ᆖFᆖ',
      'ᆖGᆖ',
      'ᆖHᆖ',
      'ᆖIᆖ',
      'ᆖJᆖ',
      'ᆖKᆖ',
      'ᆖLᆖ',
      'ᆖMᆖ',
      'ᆖNᆖ',
      'ᆖOᆖ',
      'ᆖPᆖ',
      'ᆖQᆖ',
      'ᆖRᆖ',
      'ᆖSᆖ',
      'ᆖTᆖ',
      'ᆖUᆖ',
      'ᆖVᆖ',
      'ᆖWᆖ',
      'ᆖXᆖ',
      'ᆖYᆖ',
      'ᆖZᆖ',
    ],
    digits: ['ᆖ0ᆖ', 'ᆖ1ᆖ', 'ᆖ2ᆖ', 'ᆖ3ᆖ', 'ᆖ4ᆖ', 'ᆖ5ᆖ', 'ᆖ6ᆖ', 'ᆖ7ᆖ', 'ᆖ8ᆖ', 'ᆖ9ᆖ'],
    categories: [9],
    id: 77,
    mainCategory: FontCategory.Wrappers,
  },
  '78': {
    name: 'Censored',
    lower: [
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
    ],
    upper: [
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
      '█',
    ],
    digits: ['█', '█', '█', '█', '█', '█', '█', '█', '█', '█'],
    categories: [11],
    id: 78,
    mainCategory: FontCategory.Codes,
  },
  '79': {
    name: 'Music Bars',
    lower: [
      '̳a̳',
      '̳b̳',
      '̳c̳',
      '̳d̳',
      '̳e̳',
      '̳f̳',
      '̳g̳',
      '̳h̳',
      '̳i̳',
      '̳j̳',
      '̳k̳',
      '̳l̳',
      '̳m̳',
      '̳n̳',
      '̳o̳',
      '̳p̳',
      '̳q̳',
      '̳r̳',
      '̳s̳',
      '̳t̳',
      '̳u̳',
      '̳v̳',
      '̳w̳',
      '̳x̳',
      '̳y̳',
      '̳z̳',
    ],
    upper: [
      '̳A̳',
      '̳B̳',
      '̳C̳',
      '̳D̳',
      '̳E̳',
      '̳F̳',
      '̳G̳',
      '̳H̳',
      '̳I̳',
      '̳J̳',
      '̳K̳',
      '̳L̳',
      '̳M̳',
      '̳N̳',
      '̳O̳',
      '̳P̳',
      '̳Q̳',
      '̳R̳',
      '̳S̳',
      '̳T̳',
      '̳U̳',
      '̳V̳',
      '̳W̳',
      '̳X̳',
      '̳Y̳',
      '̳Z̳',
    ],
    digits: ['̳0̳', '̳1̳', '̳2̳', '̳3̳', '̳4̳', '̳5̳', '̳6̳', '̳7̳', '̳8̳', '̳9̳'],
    categories: [6],
    id: 79,
    mainCategory: FontCategory.Glitch,
  },
  '80': {
    name: 'All The Way Up',
    lower: [
      'a͎',
      '͎b͎',
      '͎c͎',
      '͎d͎',
      '͎e͎',
      '͎f͎',
      '͎g͎',
      '͎h͎',
      '͎i͎',
      '͎j͎',
      '͎k͎',
      '͎l͎',
      '͎m͎',
      '͎n͎',
      '͎o͎',
      '͎p͎',
      '͎q͎',
      '͎r͎',
      '͎s͎',
      '͎t͎',
      '͎u͎',
      '͎v͎',
      '͎w͎',
      '͎x͎',
      '͎y͎',
      '͎z͎',
    ],
    upper: [
      '͎A͎',
      '͎B͎',
      '͎C͎',
      '͎D͎',
      '͎E͎',
      '͎F͎',
      '͎G͎',
      '͎H͎',
      '͎I͎',
      '͎J͎',
      '͎K͎',
      '͎L͎',
      '͎M͎',
      '͎N͎',
      '͎O͎',
      '͎P͎',
      '͎Q͎',
      '͎R͎',
      '͎S͎',
      '͎T͎',
      '͎U͎',
      '͎V͎',
      '͎W͎',
      '͎X͎',
      '͎Y͎',
      '͎Z͎',
    ],
    digits: ['͎0͎', '͎1͎', '͎2͎', '͎3͎', '͎4͎', '͎5͎', '͎6͎', '͎7͎', '͎8͎', '͎9͎'],
    categories: [6],
    id: 80,
    mainCategory: FontCategory.Glitch,
  },
  '81': {
    name: 'Comet Tail',
    lower: [
      'ǎ̴̯̀͠',
      'b̸̼̋͛̑͆̈́͗̿̅',
      'c̵̛̥͊',
      'd̶̡̲̗̼̮̤̤̳̲͖͓͍͔͓̓̎̽́̽̏̐͂̆͆͘͘͘',
      'ë̸͓̮͉͈͇͍̖͎̩̞͈́́́̋̇̾͋̈́̾͆͑͘͘͜͠͝',
      'f̵̢̻͈̫̬̻͔̘̞͈̆̇̍̈̌͊ͅ',
      'ǧ̷̡̟̲̹̩̱͉̮̭͇͚̮̖̟̽̓͊̔̓̕',
      'ḥ̸̨̧̗̮̖̽̂̓̀̍̋͋́̅̃͘͜͝',
      'i̶̡̹͈͎̳̞͙͖̾̂̀͑̀͆̑̓̽̉͐͘͘ͅ',
      'j̵̬̺̭̼̺̫̦͚̬̼͚͙̰̭̐̐ͅ',
      'k̵̘̺̦͉͖̪̪͖͉͊̆̔́̈́̍̃̈́͒̂̑̀̚͜͝',
      'l̶̬̞͎̖͉̹̝͕̝͖̣̉͆',
      'm̵̢͕̫̓̔͑̊̈',
      'ǹ̷̨͍̮̥̹̘͙̗̻̬̬̜̥̮̃̒̈́̽͗̿̍̄̂̏͆͠͝',
      'ŏ̸̡̼̺̫̥̻͈̞̍͆̏̓́͜͝ͅ',
      'p̴̩͙̺̩͓̣͈͖̎ͅ',
      'q̶̡̛̥̫͓̩̫͇̥̋͊̇̄͐̈́̓͠',
      'r̵̡͕͈͚͍͍̼͕̍̀̈́̽̎̍͗̍́̏̚͜͠',
      's̴̹̀̎̇͗̍͗̾̋̏̈͐͒̕͠͠ͅ',
      't̸̫̫̤͕̳̻̰̣̭́̌̉͝ͅ',
      'u̷̬̩̰̫͕̘͎̔́̃̄̍͋̓',
      'ṽ̵͇̟̺̣͓̰̭̲̼̻̪̩̰͒̓̿̄̾̔̊͝ͅ',
      'ẃ̸̝̝̰͋͒',
      'x̵̢̝̹̘͖͖̜̩̝͗̽́̑͗͋',
      'y̶͔͗',
      'z̷̛̻̤̯̥̝͎̯͚̹͇͗̆̄̈́̅̎̓̿̎͋́̅̈́̚͜',
    ],
    upper: [
      'Ą̵̺̰̻̻͔͇͓̈́̓͛̏̈́͌͋̄̑͆̏',
      'B̶̨̛̺̤̱̾̀́̋̔̆̏̎͘͘',
      'C̴̀͐ͅ',
      'Ḑ̷̮̳̣̟͉͋͗̓̕͜',
      'Ȩ̸̪̯̗̘̥̣̲̣̣͍͚͙̥̩́̀̈̆͑',
      'F̵̜̜͎͉̯̜̓͂',
      'G̶̺̥̎̄͌͑͂̔̏̓̂́̈́͜͝͝͝͝ͅ',
      'Ḩ̵̛̘̤͙͔̝̫̖̻̦̞͙̺̅̿͘͝',
      'I̸̺̺͎̰̥̜̯̼̮̰͖̜͂͆̿̈́̿̔',
      'Ĵ̸͔̣̮̤̝̥̆̏͋͒͝',
      'K̵̢̛̛͉̳̫͔̺̱̗̫̽̉́͋̾́͂͛',
      'L̷͖͈̓͌̎̉͒͗͂̓̌̚͝',
      'M̶̧͚̪͉̯̜̰͎̘̀͋̇̀͗̍́͆̑̏͂̿̊̚',
      'N̸̡̧͕͙̼̻̳̦̪̞̯͎̦͓̏̒͌͑͒͊̾͌̑̅̕͝ͅ',
      'O̵̧̗͕̹̼̦̗̮̱̝͆͊́́̈̿̋ͅ',
      'P̷̛̛̛̩̺͇̊̅̍͂͗͑͐̎̂̏̐̐',
      'Q̷̡̠̝͚̼̘̜̜̠͍͓̎̒̀̿͋̅̄̀̿̄̏͠ͅ',
      'Ŗ̷͇̙̰̭̪̟̺̲̜̹͔̎̍́ͅ',
      'Ś̸͙̺̥̰̯͙̭͆̏͂',
      'T̷̡̧̬̲̭̦̘̩̊̉͛̓̓̌͌̕',
      'U̴̡̢̱̳̳͓̗͔̮̔͜͜͜',
      'V̵̧͖͙̲̯̞͇̲͔̤͊̔͌͂͆͑́́̑͒͝',
      'W̵̰̻͍̉̔̅̀̐͐͒͆̒̚',
      'X̶̨̢̗͍̪͚͍̱̭̣̰̳̠͌̓͌̅͆̈́̊̅̓̿͠',
      'Ý̴̥͙̘̇̈́̇̃͒̿́͘͘͝͝ͅ',
      'Z̵̥̼̐̀̐́̅̀̈͆̓͒́̕̚͠',
    ],
    digits: ['0̴̛̫̪̯̺̭̻̭͖̲̮͓̋̉̀̑͗̃̌͠ͅ', '1̵̡̱̟͇̙͕͎̻̖̌', '2̸̨̨̢̛̝̣̝̻̺͖̳̹̦̼̖̩̎̾̈́̄́̊̕͘͝', '3̵̧͔̖̪̗̺̺͙̭̮̘̂̀̂̒͂͌͑̈́̏̈̒́͛͜͠', '4̴̧̢͙̫͖͕̩̭̞̗̲̞̮̩̌̈́͆͑̏̈́̏̐̇̈́', '5̷̧̡̛̭̞͙͓̰͔̞̠̗̫͊̇̐͆̋̀̑͗̇̚͘͝͠͠', '6̴̧̡̢̝̼͈͔̙̪͔͉̻͑̔̓͜͝ͅ', '7̵̡̰̞̞͙͎͖̪̲̻̮̈́̈̔̃́̀̔̍̌̈́̌̀͒', '8̶͙̣̲̟̞̺̗̤̰͓̳̼̽͜', '9̴̛̳̟̤̯̤̮̞̩̦͐̎͂̐̏̈́̒̚͜'],
    categories: [6],
    className: 'high01',
    id: 81,
    mainCategory: FontCategory.Glitch,
  },
  '82': {
    name: 'Wise Characters',
    lower: [
      'λ',
      'ß',
      'Ȼ',
      'ɖ',
      'ε',
      'ʃ',
      'Ģ',
      'ħ',
      'ί',
      'ĵ',
      'κ',
      'ι',
      'ɱ',
      'ɴ',
      'Θ',
      'ρ',
      'ƣ',
      'ર',
      'Ș',
      'τ',
      'Ʋ',
      'ν',
      'ώ',
      'Χ',
      'ϓ',
      'Հ',
    ],
    upper: [
      'λ',
      'ß',
      'Ȼ',
      'ɖ',
      'ε',
      'ʃ',
      'Ģ',
      'ħ',
      'ί',
      'ĵ',
      'κ',
      'ι',
      'ɱ',
      'ɴ',
      'Θ',
      'ρ',
      'ƣ',
      'ર',
      'Ș',
      'τ',
      'Ʋ',
      'ν',
      'ώ',
      'Χ',
      'ϓ',
      'Հ',
    ],
    digits: [],
    categories: [6],
    id: 82,
    mainCategory: FontCategory.Glitch,
  },
  '83': {
    name: 'HOT',
    lower: [
      'a̾',
      '̾b̾',
      '̾c̾',
      '̾d̾',
      '̾e̾',
      '̾f̾',
      '̾g̾',
      '̾h̾',
      '̾i̾',
      '̾j̾',
      '̾k̾',
      '̾l̾',
      '̾m̾',
      '̾n̾',
      '̾o̾',
      '̾p̾',
      '̾q̾',
      '̾r̾',
      '̾s̾',
      '̾t̾',
      '̾u̾',
      '̾v̾',
      '̾w̾',
      '̾x̾',
      '̾y̾',
      '̾z̾',
    ],
    upper: [
      'A̾',
      '̾B̾',
      '̾C̾',
      '̾D̾',
      '̾E̾',
      '̾F̾',
      '̾G̾',
      '̾H̾',
      '̾I̾',
      '̾J̾',
      '̾K̾',
      '̾L̾',
      '̾M̾',
      '̾N̾',
      '̾O̾',
      '̾P̾',
      '̾Q̾',
      '̾R̾',
      '̾S̾',
      '̾T̾',
      '̾U̾',
      '̾V̾',
      '̾W̾',
      '̾X̾',
      '̾Y̾',
      '̾Z̾',
    ],
    digits: ['0̾', '̾1̾', '̾2̾', '̾3̾', '̾4̾', '̾5̾', '̾6̾', '̾7̾', '̾8̾', '̾9̾'],
    categories: [6],
    id: 83,
    mainCategory: FontCategory.Glitch,
  },
  '84': {
    name: 'Math Sans Bold',
    lower: [
      '𝗮',
      '𝗯',
      '𝗰',
      '𝗱',
      '𝗲',
      '𝗳',
      '𝗴',
      '𝗵',
      '𝗶',
      '𝗷',
      '𝗸',
      '𝗹',
      '𝗺',
      '𝗻',
      '𝗼',
      '𝗽',
      '𝗾',
      '𝗿',
      '𝘀',
      '𝘁',
      '𝘂',
      '𝘃',
      '𝘄',
      '𝘅',
      '𝘆',
      '𝘇',
    ],
    upper: [
      '𝗔',
      '𝗕',
      '𝗖',
      '𝗗',
      '𝗘',
      '𝗙',
      '𝗚',
      '𝗛',
      '𝗜',
      '𝗝',
      '𝗞',
      '𝗟',
      '𝗠',
      '𝗡',
      '𝗢',
      '𝗣',
      '𝗤',
      '𝗥',
      '𝗦',
      '𝗧',
      '𝗨',
      '𝗩',
      '𝗪',
      '𝗫',
      '𝗬',
      '𝗭',
    ],
    digits: [],
    categories: [1, 2],
    id: 84,
    mainCategory: FontCategory.Basic,
  },
  '85': {
    name: 'Ancient Style 2',
    lower: [
      'ꋫ',
      'ꃃ',
      'ꏸ',
      'ꁕ',
      'ꍟ',
      'ꄘ',
      'ꁍ',
      'ꑛ',
      'ꂑ',
      'ꀭ',
      'ꀗ',
      '꒒',
      'ꁒ',
      'ꁹ',
      'ꆂ',
      'ꉣ',
      'ꁸ',
      '꒓',
      'ꌚ',
      '꓅',
      'ꐇ',
      'ꏝ',
      'ꅐ',
      'ꇓ',
      'ꐟ',
      'ꁴ',
    ],
    upper: [
      'ꋫ',
      'ꃃ',
      'ꏸ',
      'ꁕ',
      'ꍟ',
      'ꄘ',
      'ꁍ',
      'ꑛ',
      'ꂑ',
      'ꀭ',
      'ꀗ',
      '꒒',
      'ꁒ',
      'ꁹ',
      'ꆂ',
      'ꉣ',
      'ꁸ',
      '꒓',
      'ꌚ',
      '꓅',
      'ꐇ',
      'ꏝ',
      'ꅐ',
      'ꇓ',
      'ꐟ',
      'ꁴ',
    ],
    digits: [],
    categories: [6],
    id: 85,
    mainCategory: FontCategory.Glitch,
  },
  '86': {
    name: 'Ancient Style 3',
    lower: [
      'ꁲ',
      'ꋰ',
      'ꀯ',
      'ꂠ',
      'ꈼ',
      'ꄞ',
      'ꁅ',
      'ꍩ',
      'ꂑ',
      '꒻',
      'ꀗ',
      '꒒',
      'ꂵ',
      'ꋊ',
      'ꂦ',
      'ꉣ',
      'ꁷ',
      'ꌅ',
      'ꌚ',
      'ꋖ',
      'ꐇ',
      'ꀰ',
      'ꅏ',
      'ꇒ',
      'ꐞ',
      'ꁴ',
    ],
    upper: [
      'ꁲ',
      'ꋰ',
      'ꀯ',
      'ꂠ',
      'ꈼ',
      'ꄞ',
      'ꁅ',
      'ꍩ',
      'ꂑ',
      '꒻',
      'ꀗ',
      '꒒',
      'ꂵ',
      'ꋊ',
      'ꂦ',
      'ꉣ',
      'ꁷ',
      'ꌅ',
      'ꌚ',
      'ꋖ',
      'ꐇ',
      'ꀰ',
      'ꅏ',
      'ꇒ',
      'ꐞ',
      'ꁴ',
    ],
    digits: [],
    categories: [6],
    id: 86,
    mainCategory: FontCategory.Glitch,
  },
  '87': {
    name: 'Dotted Pattern',
    lower: [
      '፠a፠',
      '፠b፠',
      '፠c፠',
      '፠d፠',
      '፠e፠',
      '፠f፠',
      '፠g፠',
      '፠h፠',
      '፠i፠',
      '፠j፠',
      '፠k፠',
      '፠l፠',
      '፠m፠',
      '፠n፠',
      '፠o፠',
      '፠p፠',
      '፠q፠',
      '፠r፠',
      '፠s፠',
      '፠t፠',
      '፠u፠',
      '፠v፠',
      '፠w፠',
      '፠x፠',
      '፠y፠',
      '፠z፠',
    ],
    upper: [
      '፠A፠',
      '፠B፠',
      '፠C፠',
      '፠D፠',
      '፠E፠',
      '፠F፠',
      '፠G፠',
      '፠H፠',
      '፠I፠',
      '፠J፠',
      '፠K፠',
      '፠L፠',
      '፠M፠',
      '፠N፠',
      '፠O፠',
      '፠P፠',
      '፠Q፠',
      '፠R፠',
      '፠S፠',
      '፠T፠',
      '፠U፠',
      '፠V፠',
      '፠W፠',
      '፠X፠',
      '፠Y፠',
      '፠Z፠',
    ],
    digits: ['፠0፠', '፠1፠', '፠2፠', '፠3፠', '፠4፠', '፠5፠', '፠6፠', '፠7፠', '፠8፠', '፠9፠'],
    categories: [9],
    id: 87,
    mainCategory: FontCategory.Wrappers,
  },
  '88': {
    name: 'Food Emojis',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: ['', '0', '1', '2', '3', '4', '5', '6', '7', '8', ''],
    categories: [2, 4, 8],
    prefix: '🍕🍟🥪 ',
    suffix: ' 🥙🥡🍖',
    id: 88,
    mainCategory: FontCategory.SymbolText,
  },
  '89': {
    name: '73x7',
    lower: [
      '4',
      '8',
      '(',
      'd',
      '3',
      'f',
      '9',
      'h',
      '!',
      'j',
      'k',
      '1',
      'm',
      'n',
      '0',
      'p',
      'q',
      'r',
      '5',
      '7',
      'u',
      'v',
      'w',
      'x',
      'y',
      '2',
    ],
    upper: [
      '4',
      '8',
      '(',
      'D',
      '3',
      'F',
      '9',
      'H',
      '!',
      'J',
      'K',
      '1',
      'M',
      'N',
      '0',
      'P',
      'Q',
      'R',
      '5',
      '7',
      'U',
      'V',
      'W',
      'X',
      'Y',
      '2',
    ],
    digits: [],
    categories: [11],
    id: 89,
    mainCategory: FontCategory.Codes,
  },
  '90': {
    name: 'Triangle Brackets',
    lower: [
      '⦉a⦊',
      '⦉b⦊',
      '⦉c⦊',
      '⦉d⦊',
      '⦉e⦊',
      '⦉f⦊',
      '⦉g⦊',
      '⦉h⦊',
      '⦉i⦊',
      '⦉j⦊',
      '⦉k⦊',
      '⦉l⦊',
      '⦉m⦊',
      '⦉n⦊',
      '⦉o⦊',
      '⦉p⦊',
      '⦉q⦊',
      '⦉r⦊',
      '⦉s⦊',
      '⦉t⦊',
      '⦉u⦊',
      '⦉v⦊',
      '⦉w⦊',
      '⦉x⦊',
      '⦉y⦊',
      '⦉z⦊',
    ],
    upper: [
      '⦉A⦊',
      '⦉B⦊',
      '⦉C⦊',
      '⦉D⦊',
      '⦉E⦊',
      '⦉F⦊',
      '⦉G⦊',
      '⦉H⦊',
      '⦉I⦊',
      '⦉J⦊',
      '⦉K⦊',
      '⦉L⦊',
      '⦉M⦊',
      '⦉N⦊',
      '⦉O⦊',
      '⦉P⦊',
      '⦉Q⦊',
      '⦉R⦊',
      '⦉S⦊',
      '⦉T⦊',
      '⦉U⦊',
      '⦉V⦊',
      '⦉W⦊',
      '⦉X⦊',
      '⦉Y⦊',
      '⦉Z⦊',
    ],
    digits: ['⦉0⦊', '⦉1⦊', '⦉2⦊', '⦉3⦊', '⦉4⦊', '⦉5⦊', '⦉6⦊', '⦉7⦊', '⦉8⦊', '⦉9⦊'],
    categories: [9],
    id: 90,
    mainCategory: FontCategory.Wrappers,
  },
  '91': {
    name: 'Heavy Arrow Brackets',
    lower: [
      '❰a❱',
      '❰b❱',
      '❰c❱',
      '❰d❱',
      '❰e❱',
      '❰f❱',
      '❰g❱',
      '❰h❱',
      '❰i❱',
      '❰j❱',
      '❰k❱',
      '❰l❱',
      '❰m❱',
      '❰n❱',
      '❰o❱',
      '❰p❱',
      '❰q❱',
      '❰r❱',
      '❰s❱',
      '❰t❱',
      '❰u❱',
      '❰v❱',
      '❰w❱',
      '❰x❱',
      '❰y❱',
      '❰z❱',
    ],
    upper: [
      '❰A❱',
      '❰B❱',
      '❰C❱',
      '❰D❱',
      '❰E❱',
      '❰F❱',
      '❰G❱',
      '❰H❱',
      '❰I❱',
      '❰J❱',
      '❰K❱',
      '❰L❱',
      '❰M❱',
      '❰N❱',
      '❰O❱',
      '❰P❱',
      '❰Q❱',
      '❰R❱',
      '❰S❱',
      '❰T❱',
      '❰U❱',
      '❰V❱',
      '❰W❱',
      '❰X❱',
      '❰Y❱',
      '❰Z❱',
    ],
    digits: ['❰0❱', '❰1❱', '❰2❱', '❰3❱', '❰4❱', '❰5❱', '❰6❱', '❰7❱', '❰8❱', '❰9❱'],
    categories: [9],
    id: 91,
    mainCategory: FontCategory.Wrappers,
  },
  '92': {
    name: 'Jumpy Text',
    lower: [
      '࿚a࿚',
      '࿚b࿚',
      '࿚c࿚',
      '࿚d࿚',
      '࿚e࿚',
      '࿚f࿚',
      '࿚g࿚',
      '࿚h࿚',
      '࿚i࿚',
      '࿚j࿚',
      '࿚k࿚',
      '࿚l࿚',
      '࿚m࿚',
      '࿚n࿚',
      '࿚o࿚',
      '࿚p࿚',
      '࿚q࿚',
      '࿚r࿚',
      '࿚s࿚',
      '࿚t࿚',
      '࿚u࿚',
      '࿚v࿚',
      '࿚w࿚',
      '࿚x࿚',
      '࿚y࿚',
      '࿚z',
    ],
    upper: [
      '࿚A࿚',
      '࿚B࿚',
      '࿚C࿚',
      '࿚D࿚',
      '࿚E࿚',
      '࿚F࿚',
      '࿚G࿚',
      '࿚H࿚',
      '࿚I࿚',
      '࿚J࿚',
      '࿚K࿚',
      '࿚L࿚',
      '࿚M࿚',
      '࿚N࿚',
      '࿚O࿚',
      '࿚P࿚',
      '࿚Q࿚',
      '࿚R࿚',
      '࿚S࿚',
      '࿚T࿚',
      '࿚U࿚',
      '࿚V࿚',
      '࿚W࿚',
      '࿚X࿚',
      '࿚Y࿚',
      '࿚Z',
    ],
    digits: ['࿚0࿚', '࿚1࿚', '࿚2࿚', '࿚3࿚', '࿚4࿚', '࿚5࿚', '࿚6࿚', '࿚7࿚', '࿚8࿚', '࿚9࿚'],
    categories: [9],
    id: 92,
    mainCategory: FontCategory.Wrappers,
  },
  '93': {
    name: 'Tent Village',
    lower: [
      'ᄉaᄉ',
      'ᄉbᄉ',
      'ᄉcᄉ',
      'ᄉdᄉ',
      'ᄉeᄉ',
      'ᄉfᄉ',
      'ᄉgᄉ',
      'ᄉhᄉ',
      'ᄉiᄉ',
      'ᄉjᄉ',
      'ᄉkᄉ',
      'ᄉlᄉ',
      'ᄉmᄉ',
      'ᄉnᄉ',
      'ᄉoᄉ',
      'ᄉpᄉ',
      'ᄉqᄉ',
      'ᄉrᄉ',
      'ᄉsᄉ',
      'ᄉtᄉ',
      'ᄉuᄉ',
      'ᄉvᄉ',
      'ᄉwᄉ',
      'ᄉxᄉ',
      'ᄉyᄉ',
      'ᄉzᄉ',
    ],
    upper: [
      'ᄉAᄉ',
      'ᄉBᄉ',
      'ᄉCᄉ',
      'ᄉDᄉ',
      'ᄉEᄉ',
      'ᄉFᄉ',
      'ᄉGᄉ',
      'ᄉHᄉ',
      'ᄉIᄉ',
      'ᄉJᄉ',
      'ᄉKᄉ',
      'ᄉLᄉ',
      'ᄉMᄉ',
      'ᄉNᄉ',
      'ᄉOᄉ',
      'ᄉPᄉ',
      'ᄉQᄉ',
      'ᄉRᄉ',
      'ᄉSᄉ',
      'ᄉTᄉ',
      'ᄉUᄉ',
      'ᄉVᄉ',
      'ᄉWᄉ',
      'ᄉXᄉ',
      'ᄉYᄉ',
      'ᄉZᄉ',
    ],
    digits: [
      'ᄉ0ᄉ',
      'ᄉ1ᄉ',
      'ᄉ2ᄉ',
      'ᄉ3ᄉ',
      'ᄉ4ᄉ',
      'ᄉ5ᄉ',
      'ᄉ6ᄉ',
      'ᄉ7ᄉ',
      'ᄉ8ᄉ',
      'ᄉ9ᄉ',
    ],
    categories: [9],
    id: 93,
    mainCategory: FontCategory.Wrappers,
  },
  '94': {
    name: 'Funky',
    lower: [
      'α',
      'в',
      '¢',
      '∂',
      'є',
      'ƒ',
      'g',
      'н',
      'ι',
      'נ',
      'к',
      'ℓ',
      'м',
      'η',
      'σ',
      'ρ',
      'q',
      'я',
      'ѕ',
      'т',
      'υ',
      'ν',
      'ω',
      'χ',
      'у',
      'z',
    ],
    upper: [
      'α',
      'в',
      '¢',
      '∂',
      'є',
      'ƒ',
      'g',
      'н',
      'ι',
      'נ',
      'к',
      'ℓ',
      'м',
      'η',
      'σ',
      'ρ',
      'q',
      'я',
      'ѕ',
      'т',
      'υ',
      'ν',
      'ω',
      'χ',
      'у',
      'z',
    ],
    digits: [],
    categories: [3, 5, 7],
    id: 94,
    mainCategory: FontCategory.Cool,
  },
  '95': {
    name: 'Colons',
    lower: [
      'ᆢaᆢ',
      'ᆢbᆢ',
      'ᆢcᆢ',
      'ᆢdᆢ',
      'ᆢeᆢ',
      'ᆢfᆢ',
      'ᆢgᆢ',
      'ᆢhᆢ',
      'ᆢiᆢ',
      'ᆢjᆢ',
      'ᆢkᆢ',
      'ᆢlᆢ',
      'ᆢmᆢ',
      'ᆢnᆢ',
      'ᆢoᆢ',
      'ᆢpᆢ',
      'ᆢqᆢ',
      'ᆢrᆢ',
      'ᆢsᆢ',
      'ᆢtᆢ',
      'ᆢuᆢ',
      'ᆢvᆢ',
      'ᆢwᆢ',
      'ᆢxᆢ',
      'ᆢyᆢ',
      'ᆢzᆢ',
    ],
    upper: [
      'ᆢAᆢ',
      'ᆢBᆢ',
      'ᆢCᆢ',
      'ᆢDᆢ',
      'ᆢEᆢ',
      'ᆢFᆢ',
      'ᆢGᆢ',
      'ᆢHᆢ',
      'ᆢIᆢ',
      'ᆢJᆢ',
      'ᆢKᆢ',
      'ᆢLᆢ',
      'ᆢMᆢ',
      'ᆢNᆢ',
      'ᆢOᆢ',
      'ᆢPᆢ',
      'ᆢQᆢ',
      'ᆢRᆢ',
      'ᆢSᆢ',
      'ᆢTᆢ',
      'ᆢUᆢ',
      'ᆢVᆢ',
      'ᆢWᆢ',
      'ᆢXᆢ',
      'ᆢYᆢ',
      'ᆢZᆢ',
    ],
    digits: ['ᆢ0ᆢ', 'ᆢ1ᆢ', 'ᆢ2ᆢ', 'ᆢ3ᆢ', 'ᆢ4ᆢ', 'ᆢ5ᆢ', 'ᆢ6ᆢ', 'ᆢ7ᆢ', 'ᆢ8ᆢ', 'ᆢ9ᆢ'],
    categories: [9],
    id: 95,
    mainCategory: FontCategory.Wrappers,
  },
  '96': {
    name: '3 Vertical Dots',
    lower: [
      '፧a፧',
      '፧b፧',
      '፧c፧',
      '፧d፧',
      '፧e፧',
      '፧f፧',
      '፧g፧',
      '፧h፧',
      '፧i፧',
      '፧j፧',
      '፧k፧',
      '፧l፧',
      '፧m፧',
      '፧n፧',
      '፧o፧',
      '፧p፧',
      '፧q፧',
      '፧r፧',
      '፧s፧',
      '፧t፧',
      '፧u፧',
      '፧v፧',
      '፧w፧',
      '፧x፧',
      '፧y፧',
      '፧z፧',
    ],
    upper: [
      '፧A፧',
      '፧B፧',
      '፧C፧',
      '፧D፧',
      '፧E፧',
      '፧F፧',
      '፧G፧',
      '፧H፧',
      '፧I፧',
      '፧J፧',
      '፧K፧',
      '፧L፧',
      '፧M፧',
      '፧N፧',
      '፧O፧',
      '፧P፧',
      '፧Q፧',
      '፧R፧',
      '፧S፧',
      '፧T፧',
      '፧U፧',
      '፧V፧',
      '፧W፧',
      '፧X፧',
      '፧Y፧',
      '፧Z፧',
    ],
    digits: ['፧0፧', '፧1፧', '፧2፧', '፧3፧', '፧4፧', '፧5፧', '፧6፧', '፧7፧', '፧8፧', '፧9፧'],
    categories: [9],
    id: 96,
    mainCategory: FontCategory.Wrappers,
  },
  '97': {
    name: 'Yoda',
    lower: [
      'ล',
      'в',
      '¢',
      '∂',
      'э',
      'ƒ',
      'φ',
      'ђ',
      'เ',
      'נ',
      'к',
      'ℓ',
      'м',
      'и',
      '๏',
      'ק',
      'ợ',
      'я',
      'ร',
      '†',
      'µ',
      '√',
      'ω',
      'җ',
      'ý',
      'ž',
    ],
    upper: [
      'ล',
      'в',
      '¢',
      '∂',
      'э',
      'ƒ',
      'φ',
      'ђ',
      'เ',
      'נ',
      'к',
      'ℓ',
      'м',
      'и',
      '๏',
      'ק',
      'ợ',
      'я',
      'ร',
      '†',
      'µ',
      '√',
      'ω',
      'җ',
      'ý',
      'ž',
    ],
    digits: [],
    categories: [6],
    id: 97,
    mainCategory: FontCategory.Glitch,
  },
  '98': {
    name: 'Fahrenheit',
    lower: [
      'ꋬ',
      'ꉉ',
      '℃',
      'ꌛ',
      '℮',
      '℉',
      'ꍌ',
      'ꈚ',
      'ꊛ',
      'ꋒ',
      '㏍',
      'ꅤ',
      'ꀪ',
      'ꁣ',
      'ꇩ',
      'ꀆ',
      'ꆰ',
      'ꋪ',
      'ꈛ',
      '꓄',
      'ꀀ',
      '℣',
      'ꂸ',
      'ꊩ',
      'ꌦ',
      'ꍈ',
    ],
    upper: [
      'ꋬ',
      'ꉉ',
      '℃',
      'ꌛ',
      '℮',
      '℉',
      'ꍌ',
      'ꈚ',
      'ꊛ',
      'ꋒ',
      '㏍',
      'ꅤ',
      'ꀪ',
      'ꁣ',
      'ꇩ',
      'ꀆ',
      'ꆰ',
      'ꋪ',
      'ꈛ',
      '꓄',
      'ꀀ',
      '℣',
      'ꂸ',
      'ꊩ',
      'ꌦ',
      'ꍈ',
    ],
    digits: [],
    categories: [6],
    id: 98,
    mainCategory: FontCategory.Glitch,
  },
  '99': {
    name: 'Weird Text 1',
    lower: [
      'a̷̙̬͍̪̗̝̤̪͗̀',
      '̵͚̗ͬb̷̼̠͕͔̯̟̖͙̋ͥ̋ͯ͆̍̚͢',
      '̯͉̀̇ͥ̕c̸̠̦̞͛̔ͨ̀',
      '̩͔͉̙̪̘͓̟͌ͥ̉ͤ̏d͕ͭͮ̽ͧ͗͠͞͞',
      '̷̠͈̥̻̗̣͚̺̏̀̕e̒ͦ̇̈҉͙͓̳',
      '̨̬̜̖̫̝͓̯͔̇͗ͭͬ͡f̨̤̪̫͈͙̺͑ͯ̀͒̽̄̕͢',
      'ͤͦ̅̽̈̍͏̩̠͚ḡ͕̤͕ͪ̉͟',
      '̷̝̦̮̹̫̭̲͔̏͋̇̂̾h͚̬̲̘̥͐͋̒ͣ͟͢͢',
      '̮̘̣̭̰͓̖̗̆͗̊ͮ̏̑ͯ̈̉͞i̓͏͙̬̝',
      '̨͔̩̰̹̍ͥ̓̅̉ͯ́̂͘j̵͍̟̝̝̖̮̓ͭͨ̂̐̚',
      '̷̺̺͙͐ͫͫ̃͟k͛ͨ̉̚҉̳̬̼͓͔̀',
      'ͩ̃͛̊̒̄͞҉̖͚̪͙l̤̯̞͖ͦ̈ͬ̀',
      '͕̩̠̬̪̟ͦ̎̂̄͂m̤̲̣̻̮̞ͧ̂͛̓̌͑ͬ',
      '̸̴̹͓͍̘͊́̏͒ͣ͛n̨̥͍̬͈ͧ̓́̿̕',
      '͈̼̯̜̔͆͂̇͝ͅo͇̬͎ͦ',
      '̛̪͍̘͕̥̠̮͇͚ͩ̈́̍ͮ́ͦ̈̎̀p̙̞͍ͪͨ̔̂',
      '̶̷̜̺͙̩͖͐ͨ̏̓̚q̭̯ͮ͌̓̉̏́͡',
      '̵͕̺ͮ̀̚ͅr̨̲̦̰̪̿̅̓̇̀̒̐͜͟',
      '̪̻͉̞̞̗̠̎͂̃̑ͧ͘͜s̸͖̖̹̑͒ͭ̓̂̈',
      'ͫ̂͏̨̯̲̭͞t̵̡̠̘̙̮̥̯̰̄͋',
      '̷̡̱͕̲̖̋̊̃͂͗̚͜ų̘͔͎̖͍͍̞ͫ̀͢͜ͅ',
      '͉͎̱̗͖͙̼͍ͪͪ̽̑͊́͢v̩̣̗̩͇̦̎͂̀́',
      '̛̲͍̮̼͚̮̘̓͑w͚͓̃ͤ́ͮ͆ͧ̑ͫ͢',
      '̵̧̜̥͕̹͓̯ͤ̅ͥ́x̶̵͔͙̞̬͚̰̘́̾̋̌̃̐͗̅ͮ',
      '̰̟͙͙̤̲̍ͣͬy̧̛̘̬̫͂̅̃̅̽̓̇',
      '͇̯̙̐̊ͨͮ͞z̫̎ͨ̊͑́ͥ̚ͅ',
    ],
    upper: [
      'A̟̤̖̗͈̦͔̮͐̒̇ͩ͋̃̾̇̕',
      '̸͖͓̯͓̉̇̃̍B̠̬̲͉̱̠̌̅͠',
      '̦̞̆̾̌ͮͤ̎Č̼͉̣̿ͨ̉͘͟',
      '̢̦̦̠ͩͧ̋ͭͯ̇D̦̿ͮ',
      '̖̦͕̬͔̹͌̓E̤͙̰̖̘̣͕̰ͫͪ͢',
      '̴͚̫̲̳͚͈̭̊̄̆̐̌͜ͅͅFͮ͗͑̈́ͦ̑͏͖̺̱̻͡',
      '̴̰̦̗̤͍̈́̿͡Ǧ͚̗̜̬̤̺̼͟͝͞',
      '̼̟͈̹̙͔̟̏̉̽̅͛H̬͈̩͔̜͔̝͎̩̋̂̂͂͌͝',
      '̝̣͔̝͎̎̃̈́̾̈̇̓̑́͞I͕̣͛̏ͨͦ̃',
      '̸͕͓̄̐̓ͮ̏͑̈́̋̀J̢͔͖͉̫̩̻̔',
      '̬̱̣̠͔͌̑͗́K̥̹̳̖̭̖̝͎ͯ̒̆͛̍͐ͣ',
      '̥̘ͭ͠L̏ͦ̀ͯͨ͋͟͏̣̪͘',
      '̡̬̃̔̂͢͝M̻̯̔ͤ͑̐̇̈̎̉́',
      '̰͎̰͗ͩ̌̽̿̎̂N͚̘̖̻̓́',
      '̸̸̖͙͇͙͉̯̞̦ͥ̉͒̌͌̒͟Ọ̥ͫ̌͟ͅ',
      '̹͈͎̜̟̯̺͊̿̋́̋ͪͩ̉̚͢P̯̜̑̊̀̿ͅ',
      '̭̪͉͔̫͉̮͑̿̈́̿ͪͣ̌̍͢ͅQ̨̙͉̯̤̬͇̹̥ͧ̌̀͠',
      '͖̭̳̥̝͇͚ͬ̈͝R̈́̐̽͡͏̠̫',
      '̷̦̫̟͓̝̣͙̞͓͂̈́ͯ̌͡S̛͇͉͈ͥ͊̉̄̾͜͡',
      '̷͈͖̊͋̉̀T̉ͣ̾́̋ͩ͏̧̫̦̥͙',
      '̾̍ͨ͐ͤ̚͏͏̷̝̪̫̪͈͍̱̣Ū͉̭̬̩̀̒̌ͮ͐',
      '̡̭̳̹͚̅͂̔̓̔̍V͇̘̥͖͙̈ͩ̉',
      '̸̻͔͍̘͒ͨͤ̐ͬ̓̽̊W̧͍̫̔ͧ͐͆̌̈́ͪ͌',
      '̧͖̘̝̻̮̭̠̌ͥ̌͗͌͛X̗͔̣͉̦̖̫̻̏͋̇͞',
      '͔̗͇̪̩̖̖̍̅̌͒ͬ̈́́͢Ỷ̢̱̭͋̌̃ͨͬ͐͟͡',
      '̛͙̯̮̪̹̃ͭͬͣZ̸̶̧̟̦ͨ̅ͦͭͧ',
    ],
    digits: ['0̧̢̱̯̺͓̜̳̗̗ͨ͐̔͆', '̱̘̦̏̄ͧ͂͆͘͞1͕͇̱̙͈̂̾̿̈͒ͅ', '̵̖̦̠͐͊͘͞ͅ2̏̀̈ͥ̒̔ͬ͗͏̘̜͇̕ͅ', '̴̩͔͖̬̞̭̗̊ͥ̎͛͋ͦ̉͠ͅ3̡̣̟͉̮͚͍̍͠', '̖͚̒̐̾̾4̞́ͬ̇̒͗', '̹̗͉̹̣̦̤̤̦͗̾̀̐5̙͙̙̘͕͉̹ͩ͂̽ͧͨ', '̯̤͚̗̹̱̭̰̒ͯͣͫ͝6̱͔̦̳͕̘͓̤ͣ͒̓̀̽̀̾̋ͬ̀', '̑ͧ͗ͪ̃ͭ̇҉̬̻̼̹͍7̖̟̟̥͙͍͙̂̂̒ͨ͡ͅ', '̩̪̭̊̍͊̓̀̚͘8̻̲̠̩͍̤̾̐ͪͪ͛ͤ͘', '̓ͬ̍͊ͨ̈͏̯̥͍̹9̧̣̯͖̫̱̮̬̱̺̀͑̾'],
    className: 'high02',
    categories: [6],
    id: 99,
    mainCategory: FontCategory.Glitch,
  },
  '100': {
    name: 'Faux Cyrillic',
    lower: [
      'а',
      'ъ',
      'с',
      'ↁ',
      'э',
      'f',
      'Б',
      'Ђ',
      'і',
      'ј',
      'к',
      'l',
      'м',
      'и',
      'о',
      'р',
      'q',
      'ѓ',
      'ѕ',
      'т',
      'ц',
      'v',
      'ш',
      'х',
      'Ў',
      'z',
    ],
    upper: [
      'Д',
      'Б',
      'Ҁ',
      'ↁ',
      'Є',
      'F',
      'Б',
      'Н',
      'І',
      'Ј',
      'Ќ',
      'L',
      'М',
      'И',
      'Ф',
      'Р',
      'Q',
      'Я',
      'Ѕ',
      'Г',
      'Ц',
      'V',
      'Щ',
      'Ж',
      'Ч',
      'Z',
    ],
    digits: [],
    categories: [6],
    id: 100,
    mainCategory: FontCategory.Glitch,
  },
  '101': {
    name: 'Between Lines',
    lower: [
      'ǀaǀ',
      'ǀbǀ',
      'ǀcǀ',
      'ǀdǀ',
      'ǀeǀ',
      'ǀfǀ',
      'ǀgǀ',
      'ǀhǀ',
      'ǀiǀ',
      'ǀjǀ',
      'ǀkǀ',
      'ǀlǀ',
      'ǀmǀ',
      'ǀnǀ',
      'ǀoǀ',
      'ǀpǀ',
      'ǀqǀ',
      'ǀrǀ',
      'ǀsǀ',
      'ǀtǀ',
      'ǀuǀ',
      'ǀvǀ',
      'ǀwǀ',
      'ǀxǀ',
      'ǀyǀ',
      'ǀzǀ',
    ],
    upper: [
      'ǀAǀ',
      'ǀBǀ',
      'ǀCǀ',
      'ǀDǀ',
      'ǀEǀ',
      'ǀFǀ',
      'ǀGǀ',
      'ǀHǀ',
      'ǀIǀ',
      'ǀJǀ',
      'ǀKǀ',
      'ǀLǀ',
      'ǀMǀ',
      'ǀNǀ',
      'ǀOǀ',
      'ǀPǀ',
      'ǀQǀ',
      'ǀRǀ',
      'ǀSǀ',
      'ǀTǀ',
      'ǀUǀ',
      'ǀVǀ',
      'ǀWǀ',
      'ǀXǀ',
      'ǀYǀ',
      'ǀZǀ',
    ],
    digits: ['ǀ0ǀ', 'ǀ1ǀ', 'ǀ2ǀ', 'ǀ3ǀ', 'ǀ4ǀ', 'ǀ5ǀ', 'ǀ6ǀ', 'ǀ7ǀ', 'ǀ8ǀ', 'ǀ9ǀ'],
    categories: [9],
    id: 101,
    mainCategory: FontCategory.Wrappers,
  },
  '102': {
    name: 'Lenticular Lens',
    lower: [
      '〖a〗',
      '〖b〗',
      '〖c〗',
      '〖d〗',
      '〖e〗',
      '〖f〗',
      '〖g〗',
      '〖h〗',
      '〖i〗',
      '〖j〗',
      '〖k〗',
      '〖l〗',
      '〖m〗',
      '〖n〗',
      '〖o〗',
      '〖p〗',
      '〖q〗',
      '〖r〗',
      '〖s〗',
      '〖t〗',
      '〖u〗',
      '〖v〗',
      '〖w〗',
      '〖x〗',
      '〖y〗',
      '〖z〗',
    ],
    upper: [
      '〖A〗',
      '〖B〗',
      '〖C〗',
      '〖D〗',
      '〖E〗',
      '〖F〗',
      '〖G〗',
      '〖H〗',
      '〖I〗',
      '〖J〗',
      '〖K〗',
      '〖L〗',
      '〖M〗',
      '〖N〗',
      '〖O〗',
      '〖P〗',
      '〖Q〗',
      '〖R〗',
      '〖S〗',
      '〖T〗',
      '〖U〗',
      '〖V〗',
      '〖W〗',
      '〖X〗',
      '〖Y〗',
      '〖Z〗',
    ],
    digits: [
      '〖0〗',
      '〖1〗',
      '〖2〗',
      '〖3〗',
      '〖4〗',
      '〖5〗',
      '〖6〗',
      '〖7〗',
      '〖8〗',
      '〖9〗',
    ],
    categories: [9],
    id: 102,
    mainCategory: FontCategory.Wrappers,
  },
  '103': {
    name: 'Double Parentheses',
    lower: [
      '｟a｠',
      '｟b｠',
      '｟c｠',
      '｟d｠',
      '｟e｠',
      '｟f｠',
      '｟g｠',
      '｟h｠',
      '｟i｠',
      '｟j｠',
      '｟k｠',
      '｟l｠',
      '｟m｠',
      '｟n｠',
      '｟o｠',
      '｟p｠',
      '｟q｠',
      '｟r｠',
      '｟s｠',
      '｟t｠',
      '｟u｠',
      '｟v｠',
      '｟w｠',
      '｟x｠',
      '｟y｠',
      '｟z｠',
    ],
    upper: [
      '｟A｠',
      '｟B｠',
      '｟C｠',
      '｟D｠',
      '｟E｠',
      '｟F｠',
      '｟G｠',
      '｟H｠',
      '｟I｠',
      '｟J｠',
      '｟K｠',
      '｟L｠',
      '｟M｠',
      '｟N｠',
      '｟O｠',
      '｟P｠',
      '｟Q｠',
      '｟R｠',
      '｟S｠',
      '｟T｠',
      '｟U｠',
      '｟V｠',
      '｟W｠',
      '｟X｠',
      '｟Y｠',
      '｟Z｠',
    ],
    digits: [
      '｟0｠',
      '｟1｠',
      '｟2｠',
      '｟3｠',
      '｟4｠',
      '｟5｠',
      '｟6｠',
      '｟7｠',
      '｟8｠',
      '｟9｠',
    ],
    categories: [9],
    id: 103,
    mainCategory: FontCategory.Wrappers,
  },
  '104': {
    name: 'Bubbly',
    lower: [
      '࿁a࿁',
      '࿁b࿁',
      '࿁c࿁',
      '࿁d࿁',
      '࿁e࿁',
      '࿁f࿁',
      '࿁g࿁',
      '࿁h࿁',
      '࿁i࿁',
      '࿁j࿁',
      '࿁k࿁',
      '࿁l࿁',
      '࿁m࿁',
      '࿁n࿁',
      '࿁o࿁',
      '࿁p࿁',
      '࿁q࿁',
      '࿁r࿁',
      '࿁s࿁',
      '࿁t࿁',
      '࿁u࿁',
      '࿁v࿁',
      '࿁w࿁',
      '࿁x࿁',
      '࿁y࿁',
      '࿁z࿁',
    ],
    upper: [
      '࿁A࿁',
      '࿁B࿁',
      '࿁C࿁',
      '࿁D࿁',
      '࿁E࿁',
      '࿁F࿁',
      '࿁G࿁',
      '࿁H࿁',
      '࿁I࿁',
      '࿁J࿁',
      '࿁K࿁',
      '࿁L࿁',
      '࿁M࿁',
      '࿁N࿁',
      '࿁O࿁',
      '࿁P࿁',
      '࿁Q࿁',
      '࿁R࿁',
      '࿁S࿁',
      '࿁T࿁',
      '࿁U࿁',
      '࿁V࿁',
      '࿁W࿁',
      '࿁X࿁',
      '࿁Y࿁',
      '࿁Z࿁',
    ],
    digits: ['࿁0࿁', '࿁1࿁', '࿁2࿁', '࿁3࿁', '࿁4࿁', '࿁5࿁', '࿁6࿁', '࿁7࿁', '࿁8࿁', '࿁9࿁'],
    categories: [9],
    id: 104,
    mainCategory: FontCategory.Wrappers,
  },
  '105': {
    name: 'Icey',
    lower: [
      'a͏́͏͖͍̞̥',
      '̴͝͏̬͙͕ͅb͎͚̤̩̪͎͕̖͚',
      '̬͟c̟̪',
      '̹̖̘ḑ̱̥̜́',
      '̛̘̯̙͈̫̹̜͢ͅȩ̣̰͓̻͎͡',
      '̝̺̠̖̭́͟͝f̷̩̲͈',
      '̳̞͔̭̤̩͍g̨̪̣̤͎̟͟͠',
      '̝̙̲̰͚̗͓͝h̢̟̲͠',
      '҉͏̫̼̜͉̭i̙͙̙̥̰̯͎̘',
      '҉̠̦͍͓͖ͅj̷̩͕̲̖',
      '̸̰̤̱͚͙ͅk̫̰͇̲̼̪͚̤',
      '̜͔̘̰͇́͠l͏̘̜̭̤̱͇͞',
      '̧̰̣̼̘̱̰̥͟͜m̵̧̯͖̺̥',
      '̖̹̦̙͝͞n̴̫̘͈͈͈̳̩͢',
      '̛̛ͅo͈̙̦',
      '̜͇̫̹̞͜͞p̱̳̹̻̱̻̘̠͉',
      '̪̮̭͚̥̰̲̺q͍͓͔͎͘͡',
      '̡̺̘͍͚̻̤ŗ̸̲͙͉͓͚',
      '̧͈͇̘͎̫͙̰̗̩s͇',
      '̵͈̤̩̝̣ṱ͓̕',
      '̴̯̘̮̯̲͈̙̳̲́͢u̧̢̖̞̝̖̤̥̱̳͝',
      '͏̵̼̝́v͏̮̮̼̤̣̬',
      '̛̗͖̜́w͚͈̟̬̩',
      '̝̺͇̱̘x͏̘̪̰͖͇͎̬',
      '̛͕͚̝̘̞y̕҉͙̝̟̞͈̪̼',
      '̥̻̲̭̜̠̭̳͚́z̸̩̲ͅ',
    ],
    upper: [
      'A͢͏̜̖̙̲',
      '̰̲̣B̡̭͎͓͓',
      '̵̶̱͉̳̠͢C̢̩͍̳̱͠',
      '̵̸͈̝͚̻̣̲̩͔̝́D̷̰̘̹͈̜̺͓͇̀',
      '҉̶̡͕͓̪͚͕̩͈͔̩E̱̭̘̫̮',
      '͇̻͕͔̳́͞ͅF̝͟͝',
      '͎̠̬̜̱̲̮̤͞G̷̜͍͚͎̤̀',
      '̴̥̺̤̠̲̟̳͘H͖̠͓͜ͅ',
      '̨̣͕͉̫̜ͅI̴̞̦̦̗̥',
      '̵̟̱̩͚͈͈J̛̰̬͈',
      '̖̻̰̟̟͝K͏͈̯̭̭̥̠̗̙',
      '̷̠̤͓͉̱̹͖̻͓͝L̶̥̤̤̪̜̩͇͟',
      '̛͍̥M͏̬̗͍͓̘',
      '̵͎̲̞̣̥͘N͚̟͉̭̘͟',
      '̷̱̖̫̟̺̰͢͞O͍̱͎̯̣͕̤̜͝',
      '̡̬̣̯̼͓͈̹͢P̷̷͇̳͔̪̹͉̯̟̟',
      '̶̪͖̞̯Q̢͔͉̮',
      '̰͖̯͕̥̱̲̰̳͟Ŗ̜̯͟͡',
      '̥͇̰͉͖̭̫̻̜͡Ş̯͕',
      '̙̥̻̰̻̀͡T̩̙̰̬͙͖ͅ',
      '̗͈̳̙̕ͅŲ̵̼̳̱͙͎̲̘̩',
      '͕̦͇̣V̶̧̩̞̙͙͎̤̠͠',
      '̰͟W̨̛̺̪̱̼',
      '̶̞͖̱́X̧͇̥̞͙̻',
      '̼͓̮̟̱̩̼̪͎͞Y̺̱̪͘',
      '̮͓̗̮̹͕ͅZ̵͔̞̥͙̜͕͇͓',
    ],
    className: 'highBottom',
    digits: ['0̶̡͍̕', '̴̦̗̪1̙̙̝̤̬̕͜', '̶͍̩̦̣2̨̝͉͎̥', '̶̮̰͢3͈̲̖̠̺͞', '̛̠͈̗̪̜4̶̫̠ͅ', '̸̡̗̣̥͍5̸̼͖͢', '̶̧̤̳̦̕6̭͎̖̖̯̠̣̀', '̴̦̱̱͇̙͈7̫̜͉̜̥̟̺͘', '͈̱̮͟͟8̸̠͖͙̩̘̠͚͟', '̰͕̤9̪͖͝'],
    categories: [9],
    id: 105,
    mainCategory: FontCategory.Wrappers,
  },
  '106': {
    name: 'Volume',
    lower: [
      '𝐚',
      '𝐛',
      '𝐜',
      '𝐝',
      '𝐞',
      '𝐟',
      '𝐠',
      '𝐡',
      '𝐢',
      '𝐣',
      '𝐤',
      '𝐥',
      '𝐦',
      '𝐧',
      '𝐨',
      '𝐩',
      '𝐪',
      '𝐫',
      '𝐬',
      '𝐭',
      '𝐮',
      '𝐯',
      '𝐰',
      '𝐱',
      '𝐲',
      '𝐳',
    ],
    upper: [
      '𝐀',
      '𝐁',
      '𝐂',
      '𝐃',
      '𝐄',
      '𝐅',
      '𝐆',
      '𝐇',
      '𝐈',
      '𝐉',
      '𝐊',
      '𝐋',
      '𝐌',
      '𝐍',
      '𝐎',
      '𝐏',
      '𝐐',
      '𝐑',
      '𝐒',
      '𝐓',
      '𝐔',
      '𝐕',
      '𝐖',
      '𝐗',
      '𝐘',
      '𝐙',
    ],
    digits: ['𝟎', '𝟏', '𝟐', '𝟑', '𝟒', '𝟓', '𝟔', '𝟕', '𝟖', '𝟗'],
    categories: [8],
    prefix: '✩░▒▓▆▅▃▂▁',
    suffix: '▁▂▃▅▆▓▒░✩',
    id: 106,
    mainCategory: FontCategory.SymbolText,
  },
  '107': {
    name: 'Princess Style',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: [],
    categories: [8],
    prefix: '✴.·´¯`·.·★  🎀',
    suffix: '🎀  ★·.·`¯´·.✴',
    id: 107,
    mainCategory: FontCategory.SymbolText,
  },
  '108': {
    name: 'Cupido',
    lower: [
      'ᅳaᅳ',
      'ᅳbᅳ',
      'ᅳcᅳ',
      'ᅳdᅳ',
      'ᅳeᅳ',
      'ᅳfᅳ',
      'ᅳgᅳ',
      'ᅳhᅳ',
      'ᅳiᅳ',
      'ᅳjᅳ',
      'ᅳkᅳ',
      'ᅳlᅳ',
      'ᅳmᅳ',
      'ᅳnᅳ',
      'ᅳoᅳ',
      'ᅳpᅳ',
      'ᅳqᅳ',
      'ᅳrᅳ',
      'ᅳsᅳ',
      'ᅳtᅳ',
      'ᅳuᅳ',
      'ᅳvᅳ',
      'ᅳwᅳ',
      'ᅳxᅳ',
      'ᅳyᅳ',
      'ᅳzᅳ',
    ],
    upper: [
      'ᅳAᅳ',
      'ᅳBᅳ',
      'ᅳCᅳ',
      'ᅳDᅳ',
      'ᅳEᅳ',
      'ᅳFᅳ',
      'ᅳGᅳ',
      'ᅳHᅳ',
      'ᅳIᅳ',
      'ᅳJᅳ',
      'ᅳKᅳ',
      'ᅳLᅳ',
      'ᅳMᅳ',
      'ᅳNᅳ',
      'ᅳOᅳ',
      'ᅳPᅳ',
      'ᅳQᅳ',
      'ᅳRᅳ',
      'ᅳSᅳ',
      'ᅳTᅳ',
      'ᅳUᅳ',
      'ᅳVᅳ',
      'ᅳWᅳ',
      'ᅳXᅳ',
      'ᅳYᅳ',
      'ᅳZᅳ',
    ],
    digits: ['ᅳ0ᅳ', 'ᅳ1ᅳ', 'ᅳ2ᅳ', 'ᅳ3ᅳ', 'ᅳ4ᅳ', 'ᅳ5ᅳ', 'ᅳ6ᅳ', 'ᅳ7ᅳ', 'ᅳ8ᅳ', 'ᅳ9ᅳ'],
    categories: [8],
    prefix: '»»',
    suffix: '►',
    id: 108,
    mainCategory: FontCategory.SymbolText,
  },
  '109': {
    name: 'Underscores',
    lower: [
      '_a_',
      '_b_',
      '_c_',
      '_d_',
      '_e_',
      '_f_',
      '_g_',
      '_h_',
      '_i_',
      '_j_',
      '_k_',
      '_l_',
      '_m_',
      '_n_',
      '_o_',
      '_p_',
      '_q_',
      '_r_',
      '_s_',
      '_t_',
      '_u_',
      '_v_',
      '_w_',
      '_x_',
      '_y_',
      '_z_',
    ],
    upper: [
      '_A_',
      '_B_',
      '_C_',
      '_D_',
      '_E_',
      '_F_',
      '_G_',
      '_H_',
      '_I_',
      '_J_',
      '_K_',
      '_L_',
      '_M_',
      '_N_',
      '_O_',
      '_P_',
      '_Q_',
      '_R_',
      '_S_',
      '_T_',
      '_U_',
      '_V_',
      '_W_',
      '_X_',
      '_Y_',
      '_Z_',
    ],
    digits: ['_0_', '_1_', '_2_', '_3_', '_4_', '_5_', '_6_', '_7_', '_8_', '_9_'],
    categories: [9],
    id: 109,
    mainCategory: FontCategory.Wrappers,
  },
  '110': {
    name: 'Block Text',
    lower: [
      '',
      '▅▀▅',
      '',
      '▐𝟯',
      '',
      '◖',
      '',
      '◗',
      '',
      '▐⯊',
      '',
      '█▀',
      '',
      '▐▅▚',
      '',
      '█▬█',
      '',
      '█',
      '',
      '▄▌',
      '',
      '▐\t◀',
      '',
      '█▄',
      '',
      '█▚▞▌',
      '',
      '█▚▌',
      '',
      '⬤',
      '',
      '▐◣',
      '',
      '⬤▖',
      '',
      '◤',
      '',
      '▄█▀',
      '',
      '▀█▀',
      '',
      '▐▄█',
      '',
      '▀▄▀',
      '',
      '▀▄▀▄▀',
      '',
      '⧗',
      '',
      '◣▌',
      '',
      '▀█▄\n',
    ],
    upper: [
      '▅▀▅',
      '',
      '▐𝟯',
      '',
      '◖',
      '',
      '◗',
      '',
      '▐⯊',
      '',
      '█▀',
      '',
      '▐▅▚',
      '',
      '█▬█',
      '',
      '█',
      '',
      '▄▌',
      '',
      '▐◀',
      '',
      '█▄',
      '',
      '█▚▞▌',
      '',
      '█▚▌',
      '',
      '⬤',
      '',
      '▐◣',
      '',
      '⬤▖',
      '',
      '▐⬤◣',
      '',
      '▄█▀',
      '',
      '▀█▀',
      '',
      '▐▄█',
      '',
      '▀▄▀',
      '',
      '▀▄▀▄▀',
      '',
      '⧗',
      '',
      '◣▌',
      '',
      '▀█▄\n',
    ],
    digits: ['𝟬', '𝟭', '𝟮', '𝟯', '𝟰', '𝟱', '𝟲', '𝟳', '𝟴', '𝟵'],
    categories: [11],
    id: 110,
    mainCategory: FontCategory.Codes,
  },
  '111': {
    name: 'Music Notes',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: [],
    categories: [2, 4, 8],
    prefix: '¸¸♬·¯·♪·¯·♫¸¸ ',
    suffix: '¸¸♫·¯·♪¸♩·¯·♬¸¸',
    id: 111,
    mainCategory: FontCategory.SymbolText,
  },
  '112': {
    name: 'Love Emojis',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: [],
    categories: [2, 4, 8],
    prefix: '😍💞💘 ',
    suffix: ' 💔💏💖',
    id: 112,
    mainCategory: FontCategory.SymbolText,
  },
  '113': {
    name: 'Mysterious',
    lower: [
      'ค',
      '๒',
      'ƈ',
      'ɗ',
      'ﻉ',
      'ि',
      'ﻭ',
      'ɦ',
      'ٱ',
      'ﻝ',
      'ᛕ',
      'ɭ',
      '๓',
      'ก',
      'ѻ',
      'ρ',
      '۹',
      'ɼ',
      'ร',
      'Շ',
      'પ',
      '۷',
      'ฝ',
      'ซ',
      'ץ',
      'չ',
    ],
    upper: [
      'ค',
      '๒',
      'ƈ',
      'ɗ',
      'ﻉ',
      'ि',
      'ﻭ',
      'ɦ',
      'ٱ',
      'ﻝ',
      'ᛕ',
      'ɭ',
      '๓',
      'ก',
      'ѻ',
      'ρ',
      '۹',
      'ɼ',
      'ร',
      'Շ',
      'પ',
      '۷',
      'ฝ',
      'ซ',
      'ץ',
      'չ',
    ],
    digits: [],
    categories: [6],
    id: 113,
    mainCategory: FontCategory.Glitch,
  },
  '114': {
    name: 'Faux Ethiopian',
    lower: [
      'ል',
      'ጌ',
      'ር',
      'ዕ',
      'ቿ',
      'ቻ',
      'ኗ',
      'ዘ',
      'ጎ',
      'ጋ',
      'ጕ',
      'ረ',
      'ጠ',
      'ክ',
      'ዐ',
      'የ',
      'ዒ',
      'ዪ',
      'ነ',
      'ፕ',
      'ሁ',
      'ሀ',
      'ሠ',
      'ሸ',
      'ሃ',
      'ጊ',
    ],
    upper: [
      'ል',
      'ጌ',
      'ር',
      'ዕ',
      'ቿ',
      'ቻ',
      'ኗ',
      'ዘ',
      'ጎ',
      'ጋ',
      'ጕ',
      'ረ',
      'ጠ',
      'ክ',
      'ዐ',
      'የ',
      'ዒ',
      'ዪ',
      'ነ',
      'ፕ',
      'ሁ',
      'ሀ',
      'ሠ',
      'ሸ',
      'ሃ',
      'ጊ',
    ],
    digits: [],
    categories: [6],
    id: 114,
    mainCategory: FontCategory.Glitch,
  },
  '115': {
    name: 'Umbrella Style',
    lower: [
      'ꍏ',
      '♭',
      '☾',
      '◗',
      '€',
      'Ϝ',
      '❡',
      '♄',
      '♗',
      '♪',
      'ϰ',
      '↳',
      '♔',
      '♫',
      '⊙',
      'ρ',
      '☭',
      '☈',
      'ⓢ',
      '☂',
      '☋',
      '✓',
      'ω',
      '⌘',
      '☿',
      '☡',
    ],
    upper: [
      'ꍏ',
      '♭',
      '☾',
      '◗',
      '€',
      'Ϝ',
      '❡',
      '♄',
      '♗',
      '♪',
      'ϰ',
      '↳',
      '♔',
      '♫',
      '⊙',
      'ρ',
      '☭',
      '☈',
      'ⓢ',
      '☂',
      '☋',
      '✓',
      'ω',
      '⌘',
      '☿',
      '☡',
    ],
    digits: ['⓪', '➊', '➋', '➌', '➍', '➎', '➏', '➐', '➑', '➒'],
    categories: [11],
    id: 115,
    mainCategory: FontCategory.Codes,
  },
  '116': {
    name: 'Country Codes',
    lower: [
      '🇦',
      '🇧',
      '🇨',
      '🇩',
      '🇪',
      '🇫',
      '🇬',
      '🇭',
      '🇮',
      '🇯',
      '🇰',
      '🇱',
      '🇲',
      '🇳',
      '🇴',
      '🇵',
      '🇶',
      '🇷',
      '🇸',
      '🇹',
      '🇺',
      '🇻',
      '🇼',
      '🇽',
      '🇾',
      '🇿',
    ],
    upper: [
      '🇦',
      '🇧',
      '🇨',
      '🇩',
      '🇪',
      '🇫',
      '🇬',
      '🇭',
      '🇮',
      '🇯',
      '🇰',
      '🇱',
      '🇲',
      '🇳',
      '🇴',
      '🇵',
      '🇶',
      '🇷',
      '🇸',
      '🇹',
      '🇺',
      '🇻',
      '🇼',
      '🇽',
      '🇾',
      '🇿',
    ],
    digits: [],
    categories: [11],
    id: 116,
    mainCategory: FontCategory.Codes,
  },
  '117': {
    name: 'Right Direction Above',
    lower: [
      '͐a͐',
      '͐b͐',
      '͐c͐',
      '͐d͐',
      '͐e͐',
      '͐f͐',
      '͐g͐',
      '͐h͐',
      '͐i͐',
      '͐j͐',
      '͐k͐',
      '͐l͐',
      '͐m͐',
      '͐n͐',
      '͐o͐',
      '͐p͐',
      '͐q͐',
      '͐r͐',
      '͐s͐',
      '͐t͐',
      '͐u͐',
      '͐v͐',
      '͐w͐',
      '͐x͐',
      '͐y͐',
      '͐z͐',
    ],
    upper: [
      '͐A͐',
      '͐B͐',
      '͐C͐',
      '͐D͐',
      '͐E͐',
      '͐F͐',
      '͐G͐',
      '͐H͐',
      '͐I͐',
      '͐J͐',
      '͐K͐',
      '͐L͐',
      '͐M͐',
      '͐N͐',
      '͐O͐',
      '͐P͐',
      '͐Q͐',
      '͐R͐',
      '͐S͐',
      '͐T͐',
      '͐U͐',
      '͐V͐',
      '͐W͐',
      '͐X͐',
      '͐Y͐',
      '͐Z͐',
    ],
    digits: ['͐0͐', '͐1͐', '͐2͐', '͐3͐', '͐4͐', '͐5͐', '͐6͐', '͐7͐', '͐8͐', '͐9͐'],
    categories: [6],
    id: 117,
    mainCategory: FontCategory.Glitch,
  },
  '118': {
    name: 'Right Direction Under',
    lower: [
      '͕a͕',
      '͕b͕',
      '͕c͕',
      '͕d͕',
      '͕e͕',
      '͕f͕',
      '͕g͕',
      '͕h͕',
      '͕i͕',
      '͕j͕',
      '͕k͕',
      '͕l͕',
      '͕m͕',
      '͕n͕',
      '͕o͕',
      '͕p͕',
      '͕q͕',
      '͕r͕',
      '͕s͕',
      '͕t͕',
      '͕u͕',
      '͕v͕',
      '͕w͕',
      '͕x͕',
      '͕y͕',
      '͕z͕',
    ],
    upper: [
      '͕A͕',
      '͕B͕',
      '͕C͕',
      '͕D͕',
      '͕E͕',
      '͕F͕',
      '͕G͕',
      '͕H͕',
      '͕I͕',
      '͕J͕',
      '͕K͕',
      '͕L͕',
      '͕M͕',
      '͕N͕',
      '͕O͕',
      '͕P͕',
      '͕Q͕',
      '͕R͕',
      '͕S͕',
      '͕T͕',
      '͕U͕',
      '͕V͕',
      '͕W͕',
      '͕X͕',
      '͕Y͕',
      '͕Z͕',
    ],
    digits: ['͕0͕', '͕1͕', '͕2͕', '͕3͕', '͕4͕', '͕5͕', '͕6͕', '͕7͕', '͕8͕', '͕9͕'],
    categories: [6],
    id: 118,
    mainCategory: FontCategory.Glitch,
  },
  '119': {
    name: 'Hieroglyphs',
    lower: [
      'Թ',
      'Յ',
      'Շ',
      'Ժ',
      'ȝ',
      'Բ',
      'Գ',
      'ɧ',
      'ɿ',
      'ʝ',
      'ƙ',
      'ʅ',
      'ʍ',
      'Ռ',
      'Ծ',
      'ρ',
      'φ',
      'Ր',
      'Տ',
      'Ե',
      'Մ',
      'ע',
      'ա',
      'Ճ',
      'Վ',
      'Հ',
    ],
    upper: [
      'Թ',
      'Յ',
      'Շ',
      'Ժ',
      'ȝ',
      'Բ',
      'Գ',
      'ɧ',
      'ɿ',
      'ʝ',
      'ƙ',
      'ʅ',
      'ʍ',
      'Ռ',
      'Ծ',
      'ρ',
      'φ',
      'Ր',
      'Տ',
      'Ե',
      'Մ',
      'ע',
      'ա',
      'Ճ',
      'Վ',
      'Հ',
    ],
    digits: [],
    categories: [6],
    id: 119,
    mainCategory: FontCategory.Glitch,
  },
  '120': {
    name: 'Swimming in the Sea',
    lower: [
      '࿐a࿐',
      '࿐b࿐',
      '࿐c࿐',
      '࿐d࿐',
      '࿐e࿐',
      '࿐f࿐',
      '࿐g࿐',
      '࿐h࿐',
      '࿐i࿐',
      '࿐j࿐',
      '࿐k࿐',
      '࿐l࿐',
      '࿐m࿐',
      '࿐n࿐',
      '࿐o࿐',
      '࿐p࿐',
      '࿐q࿐',
      '࿐r࿐',
      '࿐s࿐',
      '࿐t࿐',
      '࿐u࿐',
      '࿐v࿐',
      '࿐w࿐',
      '࿐x࿐',
      '࿐y࿐',
      '࿐z࿐',
    ],
    upper: [
      '࿐A࿐',
      '࿐B࿐',
      '࿐C࿐',
      '࿐D࿐',
      '࿐E࿐',
      '࿐F࿐',
      '࿐G࿐',
      '࿐H࿐',
      '࿐I࿐',
      '࿐J࿐',
      '࿐K࿐',
      '࿐L࿐',
      '࿐M࿐',
      '࿐N࿐',
      '࿐O࿐',
      '࿐P࿐',
      '࿐Q࿐',
      '࿐R࿐',
      '࿐S࿐',
      '࿐T࿐',
      '࿐U࿐',
      '࿐V࿐',
      '࿐W࿐',
      '࿐X࿐',
      '࿐Y࿐',
      '࿐Z࿐',
    ],
    digits: ['࿐0࿐', '࿐1࿐', '࿐2࿐', '࿐3࿐', '࿐4࿐', '࿐5࿐', '࿐6࿐', '࿐7࿐', '࿐8࿐', '࿐9࿐'],
    categories: [9],
    id: 120,
    mainCategory: FontCategory.Wrappers,
  },
  '121': {
    name: 'Curved Text',
    lower: [
      '⧼a⧽',
      '⧼b⧽',
      '⧼c⧽',
      '⧼d⧽',
      '⧼e⧽',
      '⧼f⧽',
      '⧼g⧽',
      '⧼h⧽',
      '⧼i⧽',
      '⧼j⧽',
      '⧼k⧽',
      '⧼l⧽',
      '⧼m⧽',
      '⧼n⧽',
      '⧼o⧽',
      '⧼p⧽',
      '⧼q⧽',
      '⧼r⧽',
      '⧼s⧽',
      '⧼t⧽',
      '⧼u⧽',
      '⧼v⧽',
      '⧼w⧽',
      '⧼x⧽',
      '⧼y⧽',
      '⧼z⧽',
    ],
    upper: [
      '⧼A⧽',
      '⧼B⧽',
      '⧼C⧽',
      '⧼D⧽',
      '⧼E⧽',
      '⧼F⧽',
      '⧼G⧽',
      '⧼H⧽',
      '⧼I⧽',
      '⧼J⧽',
      '⧼K⧽',
      '⧼L⧽',
      '⧼M⧽',
      '⧼N⧽',
      '⧼O⧽',
      '⧼P⧽',
      '⧼Q⧽',
      '⧼R⧽',
      '⧼S⧽',
      '⧼T⧽',
      '⧼U⧽',
      '⧼V⧽',
      '⧼W⧽',
      '⧼X⧽',
      '⧼Y⧽',
      '⧼Z⧽',
    ],
    digits: ['⧼0⧽', '⧼1⧽', '⧼2⧽', '⧼3⧽', '⧼4⧽', '⧼5⧽', '⧼6⧽', '⧼7⧽', '⧼8⧽', '⧼9⧽'],
    categories: [9],
    prefix: '⧼',
    suffix: '⧽',
    id: 121,
    mainCategory: FontCategory.Wrappers,
  },
  '122': {
    name: 'Sparkles',
    lower: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [8],
    prefix: '(¯`·._.··¸.-~*´¨¯¨`*·~-.',
    suffix: '.-~*´¨¯¨`*·~-.¸··._.·´¯)',
    id: 122,
    mainCategory: FontCategory.SymbolText,
  },
  '123': {
    name: 'Finish',
    lower: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [8],
    prefix: '▀▄▀▄▀▄',
    suffix: '▄▀▄▀▄▀',
    id: 123,
    mainCategory: FontCategory.SymbolText,
  },
  '124': {
    name: 'Orthodox',
    lower: [
      '@',
      '฿',
      'ς',
      'Ð',
      'Ξ',
      'ךּ',
      'ĝ',
      'Ħ',
      '¡',
      '∂',
      'қ',
      'ĺ',
      'm',
      'מ',
      'θ',
      'Þ',
      'Θ',
      'я',
      '§',
      '‡',
      'ט',
      'ע',
      'שּׂ',
      'Ж',
      'צּ',
      'ζ',
    ],
    upper: [
      '@',
      '฿',
      'ς',
      'Ð',
      'Ξ',
      'ךּ',
      'ĝ',
      'Ħ',
      '¡',
      '∂',
      'қ',
      'ĺ',
      'm',
      'מ',
      'θ',
      'Þ',
      'Θ',
      'я',
      '§',
      '‡',
      'ט',
      'ע',
      'שּׂ',
      'Ж',
      'צּ',
      'ζ',
    ],
    digits: [],
    categories: [6],
    id: 124,
    mainCategory: FontCategory.Glitch,
  },
  '125': {
    name: 'Currencies',
    lower: [
      'a',
      'b',
      '¢',
      '₫',
      '€',
      'ƒ',
      'g',
      'Ω',
      '¡',
      'j',
      '₭',
      'L',
      'm',
      '₪',
      'Φ',
      '₽',
      'φ',
      '₹',
      '$',
      '₮',
      'ρ',
      'ν',
      '₩',
      'Χ',
      '¥',
      'z',
    ],
    upper: [
      'A',
      'B',
      '¢',
      '₫',
      '€',
      'ƒ',
      'g',
      'Ω',
      '¡',
      'j',
      '₭',
      'L',
      'm',
      '₪',
      'Φ',
      '₽',
      'φ',
      '₹',
      '$',
      '₮',
      'ρ',
      'ν',
      '₩',
      'Χ',
      '¥',
      'Z',
    ],
    digits: [],
    categories: [6],
    id: 125,
    mainCategory: FontCategory.Glitch,
  },
  '126': {
    name: 'Stacked above',
    lower: [
      '̅a̅',
      '̅b̅',
      '̅c̅',
      '̅d̅',
      '̅e̅',
      '̅f̅',
      '̅g̅',
      '̅h̅',
      '̅i̅',
      '̅j̅',
      '̅k̅',
      '̅l̅',
      '̅m̅',
      '̅n̅',
      '̅o̅',
      '̅p̅',
      '̅q̅',
      '̅r̅',
      '̅s̅',
      '̅t̅',
      '̅u̅',
      '̅v̅',
      '̅w̅',
      '̅x̅',
      '̅y̅',
      '̅z̅',
    ],
    upper: [
      '̅A̅',
      '̅B̅',
      '̅C̅',
      '̅D̅',
      '̅E̅',
      '̅F̅',
      '̅G̅',
      '̅H̅',
      '̅I̅',
      '̅J̅',
      '̅K̅',
      '̅L̅',
      '̅M̅',
      '̅N̅',
      '̅O̅',
      '̅P̅',
      '̅Q̅',
      '̅R̅',
      '̅S̅',
      '̅T̅',
      '̅U̅',
      '̅V̅',
      '̅W̅',
      '̅X̅',
      '̅Y̅',
      '̅Z̅',
    ],
    digits: ['̅0̅', '̅1̅', '̅2̅', '̅3̅', '̅4̅', '̅5̅', '̅6̅', '̅7̅', '̅8̅', '̅9̅'],
    categories: [6],
    id: 126,
    mainCategory: FontCategory.Glitch,
  },
  '127': {
    name: 'Hebrew',
    lower: [
      'ค',
      '๒',
      'ς',
      '๔',
      'є',
      'Ŧ',
      'ﻮ',
      'ђ',
      'เ',
      'ן',
      'к',
      'ɭ',
      '๓',
      'ภ',
      '๏',
      'ק',
      'ợ',
      'г',
      'ร',
      'Շ',
      'ย',
      'ש',
      'ฬ',
      'א',
      'ץ',
      'չ',
    ],
    upper: [
      'ค',
      '๒',
      'ς',
      '๔',
      'є',
      'Ŧ',
      'ﻮ',
      'ђ',
      'เ',
      'ן',
      'к',
      'ɭ',
      '๓',
      'ภ',
      '๏',
      'ק',
      'ợ',
      'г',
      'ร',
      'Շ',
      'ย',
      'ש',
      'ฬ',
      'א',
      'ץ',
      'չ',
    ],
    digits: [],
    categories: [6],
    id: 127,
    mainCategory: FontCategory.Glitch,
  },
  '128': {
    name: 'Dashed',
    lower: [
      '-a-',
      '-b-',
      '-c-',
      '-d-',
      '-e-',
      '-f-',
      '-g-',
      '-h-',
      '-i-',
      '-j-',
      '-k-',
      '-l-',
      '-m-',
      '-n-',
      '-o-',
      '-p-',
      '-q-',
      '-r-',
      '-s-',
      '-t-',
      '-u-',
      '-v-',
      '-w-',
      '-x-',
      '-y-',
      '-z-',
    ],
    upper: [
      '-A-',
      '-B-',
      '-C-',
      '-D-',
      '-E-',
      '-F-',
      '-G-',
      '-H-',
      '-I-',
      '-J-',
      '-K-',
      '-L-',
      '-M-',
      '-N-',
      '-O-',
      '-P-',
      '-Q-',
      '-R-',
      '-S-',
      '-T-',
      '-U-',
      '-V-',
      '-W-',
      '-X-',
      '-Y-',
      '-Z-',
    ],
    digits: ['-0-', '-1-', '-2-', '-3-', '-4-', '-5-', '-6-', '-7-', '-8-', '-9-'],
    categories: [9],
    id: 128,
    mainCategory: FontCategory.Wrappers,
  },
  '129': {
    name: 'Z Math',
    lower: [
      '⦇a⦈',
      '⦇b⦈',
      '⦇c⦈',
      '⦇d⦈',
      '⦇e⦈',
      '⦇f⦈',
      '⦇g⦈',
      '⦇h⦈',
      '⦇i⦈',
      '⦇j⦈',
      '⦇k⦈',
      '⦇l⦈',
      '⦇m⦈',
      '⦇n⦈',
      '⦇o⦈',
      '⦇p⦈',
      '⦇q⦈',
      '⦇r⦈',
      '⦇s⦈',
      '⦇t⦈',
      '⦇u⦈',
      '⦇v⦈',
      '⦇w⦈',
      '⦇x⦈',
      '⦇y⦈',
      '⦇z⦈',
    ],
    upper: [
      '⦇A⦈',
      '⦇B⦈',
      '⦇C⦈',
      '⦇D⦈',
      '⦇E⦈',
      '⦇F⦈',
      '⦇G⦈',
      '⦇H⦈',
      '⦇I⦈',
      '⦇J⦈',
      '⦇K⦈',
      '⦇L⦈',
      '⦇M⦈',
      '⦇N⦈',
      '⦇O⦈',
      '⦇P⦈',
      '⦇Q⦈',
      '⦇R⦈',
      '⦇S⦈',
      '⦇T⦈',
      '⦇U⦈',
      '⦇V⦈',
      '⦇W⦈',
      '⦇X⦈',
      '⦇Y⦈',
      '⦇Z⦈',
    ],
    digits: ['⦇0⦈', '⦇1⦈', '⦇2⦈', '⦇3⦈', '⦇4⦈', '⦇5⦈', '⦇6⦈', '⦇7⦈', '⦇8⦈', '⦇9⦈'],
    categories: [9],
    id: 129,
    mainCategory: FontCategory.Wrappers,
  },
  '130': {
    name: 'Drinks Emojis',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', ''],
    categories: [2, 4, 8],
    prefix: '🍺🥂🍸 ',
    suffix: ' 🍻🍷🍹',
    id: 130,
    mainCategory: FontCategory.SymbolText,
  },
  '131': {
    name: 'Weird Text 2',
    lower: [
      'à̜̫͍̣͖̑̉ͧ̿',
      'ͬ̅b̖̰̮͊͗ͬ',
      '̯͍̱c̟͕ͩ',
      '͔̤̽͒̓̇d̼̪̫̙̔',
      '̲̦͚̙e͕̬̔͛͌',
      '̖ͥf̥̖̗̔',
      '͍̺̖ͭͪg̻̰̹̥͕͊͛̊ͭ',
      'h̟̪ͮ',
      '̜̟͙͕̎̄̆i͗',
      '̝̝̱ͧj̞̫̽ͭ',
      'ͣ̇̋ͨk͈̲̂̋̍̌',
      '̠͔̞̔͒̐̏́l͙̬̞̥',
      '͙̗͓̖ͬͩ̊m̩͈͕',
      'n͎̦̜̻͈͊͒̀',
      '̥͍̦̩̱o̘͇̩̞ͯ̋ͭ͂',
      '̰̭̝̈p̪̈͊̄',
      '̻͓̻̹̑̌ͣͯ͆q̯̙ͥ́̾͌̎',
      '͕̰̒ͨ̈́r̯̠̦̩ͨ̌̑',
      '̗͓̜̥̭̄̈ͪͧs̲̬̝͕̍ͭ̓ͦ',
      '̠̜̈́ͯ̾͊ͅt͓̙͔͊',
      '̗uͦ',
      '̩͔̩͕̌̆ͅv͚̭̫̖ͤ̚',
      '͍̭̜͔ͯ̉w̯͗ͤ̑͂ͥ',
      '̞̥͎x̞͇',
      '͇͉̬̆ͫ̈́͋̉ͅy̬̣ͦ̇͊̔',
      '̾̾͌z͖͓̏ͅ',
    ],
    upper: [
      'Ä̤́̂̚',
      '̦͓̫̞B̤̠̫',
      '͓̩C͕͓̝͑̈̉̋̒',
      '̗̩̜ͅD̽̒',
      'E̺̭͆̈͋̈́ͅ',
      '̺̘̟̼̓F̣̙̣̟̺͒̐̒',
      '̙̦͂ͧ̚G̭͙͈͉̏ͭ',
      '̽̒̂̑͗ͅH͈̫͓ͭ͐',
      '͎͕̦ͫ̊̊ͨ͑I̗',
      '͉̖̑̍́̓Jͪ͛',
      '̝͉͉͖͔̉K̮͈̤̭͎̽̈́̌̋',
      '̹͖̈́͑̋͑͑L̀',
      'ͫͮͭ̃M̰̖ͤ̚',
      '̼̙͓̝̂̈́N̰͎͚̭̭̊̐͆',
      '̳̻O̪̟͔ͧͥ',
      '̭̿P̳͈̲͙̋̑̂̅̈́',
      '̬̳̼͋̍Q̜̗̞̖̞̊̓̃ͯ',
      '͉̜͌R̞̟͌̊̾̋',
      '̮̪̈S̖̜͚̽',
      '̝̦Țͬ',
      '̳̭̖̦̀͑̾U̱̬̙̠̗ͩ̃͑̏',
      '͔̯͂̋̃̉̎V̮͕͓̞̖',
      '͔̳̮̪͎ͤͬͤW̙̰͍̻̹̋ͩ͐ͪ̚',
      '̗̠͖̞̬͐̓̑̇X͗',
      '̣̝́Y͇̚',
      '̮̟̗̪͊̑ͩ̎̚Z̥͕̤̗͍̃̌͛̐',
    ],
    digits: ['0̯', '̜͓̩͕̓͑ͯ̅ͥ1̠̲̮̥̄', '͙̓̊̎2̼̝͓ͣ', '̺̖̳3͖̭̲̆̄̓̏ͫ', '̳4̓͆', '̲ͣ̃͊5̬̠ͣ͑͑ͧ͊', '͛͑́̄6̽', '7͇͙̟ͦ', '̮8̬̦̱̉', '̣͐ͬ̈́9̻̭̠̩͎̐̃̌̂̓'],
    categories: [6],
    className: 'high01',
    id: 131,
    mainCategory: FontCategory.Glitch,
  },
  '132': {
    name: 'Weird Text 3',
    lower: [
      'a͏́͏͖͍̞̥',
      '̴͝͏̬͙͕ͅb͎͚̤̩̪͎͕̖͚',
      '̬͟c̟̪',
      '̹̖̘ḑ̱̥̜́',
      '̛̘̯̙͈̫̹̜͢ͅȩ̣̰͓̻͎͡',
      '̝̺̠̖̭́͟͝f̷̩̲͈',
      '̳̞͔̭̤̩͍g̨̪̣̤͎̟͟͠',
      '̝̙̲̰͚̗͓͝h̢̟̲͠',
      '҉͏̫̼̜͉̭i̙͙̙̥̰̯͎̘',
      '҉̠̦͍͓͖ͅj̷̩͕̲̖',
      '̸̰̤̱͚͙ͅk̫̰͇̲̼̪͚̤',
      '̜͔̘̰͇́͠l͏̘̜̭̤̱͇͞',
      '̧̰̣̼̘̱̰̥͟͜m̵̧̯͖̺̥',
      '̖̹̦̙͝͞n̴̫̘͈͈͈̳̩͢',
      '̛̛ͅo͈̙̦',
      '̜͇̫̹̞͜͞p̱̳̹̻̱̻̘̠͉',
      '̪̮̭͚̥̰̲̺q͍͓͔͎͘͡',
      '̡̺̘͍͚̻̤ŗ̸̲͙͉͓͚',
      '̧͈͇̘͎̫͙̰̗̩s͇',
      '̵͈̤̩̝̣ṱ͓̕',
      '̴̯̘̮̯̲͈̙̳̲́͢u̧̢̖̞̝̖̤̥̱̳͝',
      '͏̵̼̝́v͏̮̮̼̤̣̬',
      '̛̗͖̜́w͚͈̟̬̩',
      '̝̺͇̱̘x͏̘̪̰͖͇͎̬',
      '̛͕͚̝̘̞y̕҉͙̝̟̞͈̪̼',
      '̥̻̲̭̜̠̭̳͚́z̸̩̲ͅ',
    ],
    upper: [
      'A͢͏̜̖̙̲',
      '̰̲̣B̡̭͎͓͓',
      '̵̶̱͉̳̠͢C̢̩͍̳̱͠',
      '̵̸͈̝͚̻̣̲̩͔̝́D̷̰̘̹͈̜̺͓͇̀',
      '҉̶̡͕͓̪͚͕̩͈͔̩E̱̭̘̫̮',
      '͇̻͕͔̳́͞ͅF̝͟͝',
      '͎̠̬̜̱̲̮̤͞G̷̜͍͚͎̤̀',
      '̴̥̺̤̠̲̟̳͘H͖̠͓͜ͅ',
      '̨̣͕͉̫̜ͅI̴̞̦̦̗̥',
      '̵̟̱̩͚͈͈J̛̰̬͈',
      '̖̻̰̟̟͝K͏͈̯̭̭̥̠̗̙',
      '̷̠̤͓͉̱̹͖̻͓͝L̶̥̤̤̪̜̩͇͟',
      '̛͍̥M͏̬̗͍͓̘',
      '̵͎̲̞̣̥͘N͚̟͉̭̘͟',
      '̷̱̖̫̟̺̰͢͞O͍̱͎̯̣͕̤̜͝',
      '̡̬̣̯̼͓͈̹͢P̷̷͇̳͔̪̹͉̯̟̟',
      '̶̪͖̞̯Q̢͔͉̮',
      '̰͖̯͕̥̱̲̰̳͟Ŗ̜̯͟͡',
      '̥͇̰͉͖̭̫̻̜͡Ş̯͕',
      '̙̥̻̰̻̀͡T̩̙̰̬͙͖ͅ',
      '̗͈̳̙̕ͅŲ̵̼̳̱͙͎̲̘̩',
      '͕̦͇̣V̶̧̩̞̙͙͎̤̠͠',
      '̰͟W̨̛̺̪̱̼',
      '̶̞͖̱́X̧͇̥̞͙̻',
      '̼͓̮̟̱̩̼̪͎͞Y̺̱̪͘',
      '̮͓̗̮̹͕ͅZ̵͔̞̥͙̜͕͇͓',
    ],
    digits: ['0̶̡͍̕', '̴̦̗̪1̙̙̝̤̬̕͜', '̶͍̩̦̣2̨̝͉͎̥', '̶̮̰͢3͈̲̖̠̺͞', '̛̠͈̗̪̜4̶̫̠ͅ', '̸̡̗̣̥͍5̸̼͖͢', '̶̧̤̳̦̕6̭͎̖̖̯̠̣̀', '̴̦̱̱͇̙͈7̫̜͉̜̥̟̺͘', '͈̱̮͟͟8̸̠͖͙̩̘̠͚͟', '̰͕̤9̪͖͝'],
    categories: [6],
    className: 'highBottom',
    id: 132,
    mainCategory: FontCategory.Glitch,
  },
  '133': {
    name: 'Weird Text 4',
    lower: [
      'a̓̏̿͌ͯ̑̇̊͠',
      'ͫ̓̃̒ͫ̌̀b̵͑̓͒ͯ͒͜',
      'ͣ̈͛͐҉c̷̢͛ͫ̄̒ͤ̊̅ͩ',
      '̛ͧ̐̈́́͊̿d̓͋͜',
      '̛͒̎͑ͫ͐͐̚̕̕ȅ̡',
      '̸̏̐f̸̉͒̉',
      '̸̐̈̌̂g̶̶̡̊',
      '͑̊ͧ̈̀ͪḩ̐ͯ̆͑̏͘',
      '̵̸̈́̇̿̽̃́͛́ͣ̀ĩ͊ͯͨ̇̽͋̂́',
      '̵̂̄ͬ̽ͮ̂̆̀j̊͛ͫ͞',
      '̧̊ͦ͐͌͏kͬ̋',
      '̴̶͋̽̇͛̇̐ͧ͒l̴͑͛̍̀',
      '̸̢̾͛̇̏̓ͭ̌͢m̢̑̑̃̾͑ͪ̐',
      '̾n̈͗ͭ́͟',
      '̵̢ͭ̄ͥ͌͂̓ͫ̀o̸ͮ̿̐ͭ̂̌͢',
      'ͩ̈́p͆͋ͯ͆̎ͪ̾̈',
      '̂̉̓͋͆ͫ́͜͡q̧̈́ͪ͑͂͝',
      '̸͆̌̄r̄̀̂͌ͨ̀',
      '̧̡̑̍̋ͣͪ̿̀s͑̎̕',
      '̷ͩ̃͗͋̕t͛̽̏ͨ̓ͭ͝͏',
      '͗̀̕ủ̷͗̓́͡',
      '͐̓̓̚͏v̶ͪ̓͋̎̄͛̋͘͏',
      'ͥ͊́́҉w̌ͥ̄͗̅',
      '̴̢ͤ̽ͮ͗xͫ̏͂́̀',
      '̧̈ͤͫ͌ͣͧͤ̚y̎҉́',
      '̊̾͒̏ͤͧ͑z̄ͮ̎̾̄̈̽͏',
    ],
    upper: [
      'A̡̓ͩ̄̑̓̀͗',
      'ͬ̐̂͑͗̓͟͡Bͬ́͋̅̾̆͞',
      '̛͛ͦ̈́̑ͪC̄ͮͯ̒ͨͮ̑҉̷͡',
      '̄̏̓̆̏ͣ́̚҉D̄ͯ͢',
      'ͮͫͩ́͜E͆́͆̑ͧ̐͢',
      '̴ͩͤ͑̏̿́̕F̈́̐ͣ̓͆͛ͧ̀̀',
      '͑̂̔ͨ҉͠G͋̋͐͋ͩ̌҉',
      '̢̾ͪ̌ͪ͘H͆̿͒҉̸',
      '̒ͤ̊Iͭ̂͂͒ͤ͡',
      '͗̉ͭ̓̋̽͏͞Jͯ̆ͩ͞',
      '̌̌̓ͨ̾Kͭ̎ͨͣ̓́',
      '̵̴ͯ́̊̉̈́̇̀ͦ́͜L̓',
      '̵̍̾̕͜Mͪ͆ͧ́ͯ',
      '̴͗̓͋̄̆̓̉ͪ̚͡N̸ͭͩ̍̊͑͑͊̉͌',
      '̴̨ͥ͐͟Ŏ̏̅͊͠',
      '̃ͭ͂͑̆ͤP̡̐͐́̊͢͜',
      '̷̢̈́ͩͤ̌̀Q̨̈́̆̍͒̈̏',
      'ͥ͐ͨ̈̃͑̉̍͛͞R̛ͥ̇̽͘',
      'ͭ̆͐̿ͧ͒̏͋̉Ṡͣ̒҉̨̢',
      '̈̃͡Tͯͬ͋̐ͮ͌ͨ͘͟͢',
      '̡͊̇̇̒ͯ́͆Ů̀͡͞',
      '̶̷̎ͩ͘V̴ͪ̎́ͬͥͣͮͤ̔͝',
      '̢̋̆̆̒W̢ͥ͆',
      '̃̇̔̍̈͊҉X̡͛̋̌͒',
      'ͬͩ́Y̶̛̾̋͗̐',
      'ͣ͘Z̈́ͦ̓͆ͨͧ͠',
    ],
    digits: ['0̷̑̋҉', '͊̇ͭ̈́͒͡͞1̢ͩ̐̚', 'ͪͯ́͏2̈͆͐͒̾͆', '̄͌͏3̸ͦ͋ͩ́̉́͞', '̸ͨ̈́̌́4ͭ̅̏̀͆̿ͬͣ̅', '͌̂̅̎̒5̈́̄̿̄̀҉̷', '͋̃̅͋ͯ̾͞6̸̇ͦͦͭͫ̿̀̃͜', '̵̸̶́̊̂ͭ̽̈ͤ7́ͭ̒ͤ͗', '̍ͫ̿̿̽͠8̨͊̇̓', '̨̧͛ͫ̓9ͩͭ́ͥ́͗ͬͯ͘͟'],
    categories: [6],
    className: 'highTop',
    id: 133,
    mainCategory: FontCategory.Glitch,
  },
  '134': {
    name: 'Waved Text',
    lower: [
      '~a~',
      '~b~',
      '~c~',
      '~d~',
      '~e~',
      '~f~',
      '~g~',
      '~h~',
      '~i~',
      '~j~',
      '~k~',
      '~l~',
      '~m~',
      '~n~',
      '~o~',
      '~p~',
      '~q~',
      '~r~',
      '~s~',
      '~t~',
      '~u~',
      '~v~',
      '~w~',
      '~x~',
      '~y~',
      '~z~',
    ],
    upper: [
      '~A~',
      '~B~',
      '~C~',
      '~D~',
      '~E~',
      '~F~',
      '~G~',
      '~H~',
      '~I~',
      '~J~',
      '~K~',
      '~L~',
      '~M~',
      '~N~',
      '~O~',
      '~P~',
      '~Q~',
      '~R~',
      '~S~',
      '~T~',
      '~U~',
      '~V~',
      '~W~',
      '~X~',
      '~Y~',
      '~Z~',
    ],
    digits: ['~0~', '~1~', '~2~', '~3~', '~4~', '~5~', '~6~', '~7~', '~8~', '~9~'],
    categories: [9],
    id: 134,
    mainCategory: FontCategory.Wrappers,
  },
  '135': {
    name: 'Barcode',
    lower: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [8],
    prefix: ' ▌║█║▌│║▌│║▌║▌█║',
    suffix: ' ▌│║▌║▌│║║▌█║▌║█',
    id: 135,
    mainCategory: FontCategory.SymbolText,
  },
  // '136': {
  //   name: 'Mirrored Faces',
  //   lower: [
  //     'z',
  //     'Y',
  //     'x',
  //     'w',
  //     'v',
  //     'U',
  //     'T',
  //     'ꙅ',
  //     'ᴙ',
  //     'p',
  //     'q',
  //     'o',
  //     'ᴎ',
  //     'm',
  //     'l',
  //     'k',
  //     'j',
  //     'i',
  //     'H',
  //     'g',
  //     'ꟻ',
  //     'ɘ',
  //     'b',
  //     'ↄ',
  //     'd',
  //     'A',
  //   ],
  //   upper: [
  //     'Z',
  //     'Y',
  //     'X',
  //     'W',
  //     'V',
  //     'U',
  //     'T',
  //     'Ꙅ',
  //     'ᴙ',
  //     'p',
  //     'ꟼ',
  //     'O',
  //     'ᴎ',
  //     'M',
  //     '⅃',
  //     'K',
  //     'J',
  //     'I',
  //     'H',
  //     'G',
  //     'ꟻ',
  //     'Ǝ',
  //     'b',
  //     'Ↄ',
  //     'd',
  //     'A',
  //   ],
  //   digits: [
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //     '',
  //   ],
  //   categories: [8],
  //   prefix: '٩◔̯◔۶ ',
  //   suffix: ' ఠ ͟ಠ',
  //   id: 136,
  //   mainCategory: FontCategory.SymbolText,
  // },
  '137': {
    name: 'Bubbly Bubbles',
    lower: [
      'ⓐ',
      'ⓑ',
      'ⓒ',
      'ⓓ',
      'ⓔ',
      'ⓕ',
      'ⓖ',
      'ⓗ',
      'ⓘ',
      'ⓙ',
      'ⓚ',
      'ⓛ',
      'ⓜ',
      'ⓝ',
      'ⓞ',
      'ⓟ',
      'ⓠ',
      'ⓡ',
      'ⓢ',
      'ⓣ',
      'ⓤ',
      'ⓥ',
      'ⓦ',
      'ⓧ',
      'ⓨ',
      'ⓩ',
    ],
    upper: [
      'Ⓐ',
      'Ⓑ',
      'Ⓒ',
      'Ⓓ',
      'Ⓔ',
      'Ⓕ',
      'Ⓖ',
      'Ⓗ',
      'Ⓘ',
      'Ⓙ',
      'Ⓚ',
      'Ⓛ',
      'Ⓜ',
      'Ⓝ',
      'Ⓞ',
      'Ⓟ',
      'Ⓠ',
      'Ⓡ',
      'Ⓢ',
      'Ⓣ',
      'Ⓤ',
      'Ⓥ',
      'Ⓦ',
      'Ⓧ',
      'Ⓨ',
      'Ⓩ',
    ],
    digits: ['0', '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨'],
    categories: [8],
    prefix: '∙∙·▫▫ᵒᴼᵒ▫ₒₒ▫ᵒᴼ',
    suffix: 'ᴼᵒ▫ₒₒ▫ᵒᴼᵒ▫▫·∙∙',
    id: 137,
    mainCategory: FontCategory.SymbolText,
  },
  '138': {
    name: 'Sweets Emojis',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: [],
    categories: [2, 4, 8],
    prefix: '🍰🍪🧁🍬🍨 ',
    suffix: ' 🥧🎂🍦🍭🍩',
    id: 138,
    mainCategory: FontCategory.SymbolText,
  },
  '139': {
    name: 'Square Brackets',
    lower: [
      '[a]',
      '[b]',
      '[c]',
      '[d]',
      '[e]',
      '[f]',
      '[g]',
      '[h]',
      '[i]',
      '[j]',
      '[k]',
      '[l]',
      '[m]',
      '[n]',
      '[o]',
      '[p]',
      '[q]',
      '[r]',
      '[s]',
      '[t]',
      '[u]',
      '[v]',
      '[w]',
      '[x]',
      '[y]',
      '[z]',
    ],
    upper: [
      '[A]',
      '[B]',
      '[C]',
      '[D]',
      '[E]',
      '[F]',
      '[G]',
      '[H]',
      '[I]',
      '[J]',
      '[K]',
      '[L]',
      '[M]',
      '[N]',
      '[O]',
      '[P]',
      '[Q]',
      '[R]',
      '[S]',
      '[T]',
      '[U]',
      '[V]',
      '[W]',
      '[X]',
      '[Y]',
      '[Z]',
    ],
    digits: ['[0]', '[1]', '[2]', '[3]', '[4]', '[5]', '[6]', '[7]', '[8]', '[9]'],
    categories: [9],
    id: 139,
    mainCategory: FontCategory.Wrappers,
  },
  '140': {
    name: 'Cross It Under',
    lower: [
      '͓a͓',
      '͓b͓',
      '͓c͓',
      '͓d͓',
      '͓e͓',
      '͓f͓',
      '͓g͓',
      '͓h͓',
      '͓i͓',
      '͓j͓',
      '͓k͓',
      '͓l͓',
      '͓m͓',
      '͓n͓',
      '͓o͓',
      '͓p͓',
      '͓q͓',
      '͓r͓',
      '͓s͓',
      '͓t͓',
      '͓u͓',
      '͓v͓',
      '͓w͓',
      '͓x͓',
      '͓y͓',
      '͓z͓',
    ],
    upper: [
      '͓A͓',
      '͓B͓',
      '͓C͓',
      '͓D͓',
      '͓E͓',
      '͓F͓',
      '͓G͓',
      '͓H͓',
      '͓I͓',
      '͓J͓',
      '͓K͓',
      '͓L͓',
      '͓M͓',
      '͓N͓',
      '͓O͓',
      '͓P͓',
      '͓Q͓',
      '͓R͓',
      '͓S͓',
      '͓T͓',
      '͓U͓',
      '͓V͓',
      '͓W͓',
      '͓X͓',
      '͓Y͓',
      '͓Z͓',
    ],
    digits: ['͓0͓', '͓1͓', '͓2͓', '͓3͓', '͓4͓', '͓5͓', '͓6͓', '͓7͓', '͓8͓', '͓9͓'],
    categories: [6],
    id: 140,
    mainCategory: FontCategory.Glitch,
  },
  '141': {
    name: 'Rain On Top',
    lower: [
      '̋a̋',
      '̋b̋',
      '̋c̋',
      '̋d̋',
      '̋e̋',
      '̋f̋',
      '̋g̋',
      '̋h̋',
      '̋i̋',
      '̋j̋',
      '̋k̋',
      '̋l̋',
      '̋m̋',
      '̋n̋',
      '̋ő',
      '̋p̋',
      '̋q̋',
      '̋r̋',
      '̋s̋',
      '̋t̋',
      '̋ű',
      '̋v̋',
      '̋w̋',
      '̋x̋',
      '̋y̋',
      '̋z̋',
    ],
    upper: [
      '̋A̋',
      '̋B̋',
      '̋C̋',
      '̋D̋',
      '̋E̋',
      '̋F̋',
      '̋G̋',
      '̋H̋',
      '̋I̋',
      '̋J̋',
      '̋K̋',
      '̋L̋',
      '̋M̋',
      '̋N̋',
      '̋Ő',
      '̋P̋',
      '̋Q̋',
      '̋R̋',
      '̋S̋',
      '̋T̋',
      '̋Ű',
      '̋V̋',
      '̋W̋',
      '̋X̋',
      '̋Y̋',
      '̋Z̋',
    ],
    digits: ['̋0̋', '̋1̋', '̋2̋', '̋3̋', '̋4̋', '̋5̋', '̋6̋', '̋7̋', '̋8̋', '̋9̋'],
    categories: [6],
    id: 141,
    mainCategory: FontCategory.Glitch,
  },
  '142': {
    name: 'Sea',
    lower: [
      '࿐a࿐',
      '࿐b࿐',
      '࿐c࿐',
      '࿐d࿐',
      '࿐e࿐',
      '࿐f࿐',
      '࿐g࿐',
      '࿐h࿐',
      '࿐i࿐',
      '࿐j࿐',
      '࿐k࿐',
      '࿐l࿐',
      '࿐m࿐',
      '࿐n࿐',
      '࿐o࿐',
      '࿐p࿐',
      '࿐q࿐',
      '࿐r࿐',
      '࿐s࿐',
      '࿐t࿐',
      '࿐u࿐',
      '࿐v࿐',
      '࿐w࿐',
      '࿐x࿐',
      '࿐y࿐',
      '࿐',
    ],
    upper: [
      '࿐A࿐',
      '࿐B࿐',
      '࿐C࿐',
      '࿐D࿐',
      '࿐E࿐',
      '࿐F࿐',
      '࿐G࿐',
      '࿐H࿐',
      '࿐I࿐',
      '࿐J࿐',
      '࿐K࿐',
      '࿐L࿐',
      '࿐M࿐',
      '࿐N࿐',
      '࿐O࿐',
      '࿐P࿐',
      '࿐Q࿐',
      '࿐R࿐',
      '࿐S࿐',
      '࿐T࿐',
      '࿐U࿐',
      '࿐V࿐',
      '࿐W࿐',
      '࿐X࿐',
      '࿐Y࿐',
      '࿐',
    ],
    digits: ['࿐0࿐', '࿐1࿐', '࿐2࿐', '࿐3࿐', '࿐4࿐', '࿐5࿐', '࿐6࿐', '࿐7࿐', '࿐8࿐', '࿐'],
    categories: [8],
    prefix: '࿐🌊🐋࿐',
    suffix: '࿐🐬࿐࿐',
    id: 142,
    mainCategory: FontCategory.SymbolText,
  },
  '143': {
    name: 'Veggies Emojis',
    lower: [
      '𝓪',
      '𝓫',
      '𝓬',
      '𝓭',
      '𝓮',
      '𝓯',
      '𝓰',
      '𝓱',
      '𝓲',
      '𝓳',
      '𝓴',
      '𝓵',
      '𝓶',
      '𝓷',
      '𝓸',
      '𝓹',
      '𝓺',
      '𝓻',
      '𝓼',
      '𝓽',
      '𝓾',
      '𝓿',
      '𝔀',
      '𝔁',
      '𝔂',
      '𝔃',
    ],
    upper: [
      '𝓐',
      '𝓑',
      '𝓒',
      '𝓓',
      '𝓔',
      '𝓕',
      '𝓖',
      '𝓗',
      '𝓘',
      '𝓙',
      '𝓚',
      '𝓛',
      '𝓜',
      '𝓝',
      '𝓞',
      '𝓟',
      '𝓠',
      '𝓡',
      '𝓢',
      '𝓣',
      '𝓤',
      '𝓥',
      '𝓦',
      '𝓧',
      '𝓨',
      '𝓩',
    ],
    digits: [],
    categories: [2, 4, 8],
    prefix: '🥕🍅🥬🥦 ',
    suffix: ' 🍆🥔🌽🥑',
    id: 143,
    mainCategory: FontCategory.SymbolText,
  },
  '144': {
    name: 'Bubbles On Top',
    lower: [
      '̊å',
      '̊b̊',
      '̊c̊',
      '̊d̊',
      '̊e̊',
      '̊f̊',
      '̊g̊',
      '̊h̊',
      '̊i̊',
      '̊j̊',
      '̊k̊',
      '̊l̊',
      '̊m̊',
      '̊n̊',
      '̊o̊',
      '̊p̊',
      '̊q̊',
      '̊r̊',
      '̊s̊',
      '̊t̊',
      '̊ů',
      '̊v̊',
      '̊ẘ',
      '̊x̊',
      '̊ẙ',
      '̊z̊',
    ],
    upper: [
      '̊Å',
      '̊B̊',
      '̊C̊',
      '̊D̊',
      '̊E̊',
      '̊F̊',
      '̊G̊',
      '̊H̊',
      '̊I̊',
      '̊J̊',
      '̊K̊',
      '̊L̊',
      '̊M̊',
      '̊N̊',
      '̊O̊',
      '̊P̊',
      '̊Q̊',
      '̊R̊',
      '̊S̊',
      '̊T̊',
      '̊Ů',
      '̊V̊',
      '̊W̊',
      '̊X̊',
      '̊Y̊',
      '̊Z̊',
    ],
    digits: ['̊0̊', '̊1̊', '̊2̊', '̊3̊', '̊4̊', '̊5̊', '̊6̊', '̊7̊', '̊8̊', '̊9̊'],
    categories: [6],
    id: 144,
    mainCategory: FontCategory.Glitch,
  },
  '145': {
    name: 'Weights',
    lower: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [8],
    prefix: '❚█══',
    suffix: '══█❚',
    id: 145,
    mainCategory: FontCategory.SymbolText,
  },
  '146': {
    name: 'all lowercase',
    lower: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    upper: [
      'a',
      'b',
      'c',
      'd',
      'e',
      'f',
      'g',
      'h',
      'i',
      'j',
      'k',
      'l',
      'm',
      'n',
      'o',
      'p',
      'q',
      'r',
      's',
      't',
      'u',
      'v',
      'w',
      'x',
      'y',
      'z',
    ],
    digits: [],
    categories: [10],
    id: 146,
    mainCategory: FontCategory.Lettercases,
  },
  '147': {
    name: 'ALL UPPERCASE',
    lower: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    upper: [
      'A',
      'B',
      'C',
      'D',
      'E',
      'F',
      'G',
      'H',
      'I',
      'J',
      'K',
      'L',
      'M',
      'N',
      'O',
      'P',
      'Q',
      'R',
      'S',
      'T',
      'U',
      'V',
      'W',
      'X',
      'Y',
      'Z',
    ],
    digits: [],
    categories: [10],
    id: 147,
    mainCategory: FontCategory.Lettercases,
  },
  '148': {
    name: 'Sentence case.',
    transform: sentenceCase,
    categories: [10],
    id: 148,
    mainCategory: FontCategory.Lettercases,
  },
  '149': {
    name: 'Title Case',
    transform: titleCase,
    categories: [10],
    id: 149,
    mainCategory: FontCategory.Lettercases,
  },
  '150': {
    name: 'AlTeRnAtInG CaSe',
    transform: alterCase,
    categories: [10],
    id: 150,
    mainCategory: FontCategory.Lettercases,
  },
  '151': {
    name: 'RanDoM cASE',
    transform: randCase,
    categories: [10],
    id: 151,
    mainCategory: FontCategory.Lettercases,
  },
  '152': {
    name: 'PascalCase',
    transform: pascalCase,
    categories: [10],
    id: 152,
    mainCategory: FontCategory.Lettercases,
  },
  '153': {
    name: 'hyphen-case',
    transform: hyphenCase,
    categories: [10],
    id: 153,
    mainCategory: FontCategory.Lettercases,
  },
  '154': {
    name: 'snake_case',
    transform: snakeCase,
    categories: [10],
    id: 154,
    mainCategory: FontCategory.Lettercases,
  },
  '155': {
    name: 'Remove punctuation',
    transform: removePunctuation,
    categories: [10],
    id: 155,
    mainCategory: FontCategory.Lettercases,
  },
  '156': {
    name: 'Standard text art',
    asciiFont: 'Standard',
    categories: [FontCategory.TextArt],
    id: 156,
    mainCategory: FontCategory.TextArt,
  },
  '157': {
    name: 'Squared letters',
    asciiFont: 'Big',
    categories: [FontCategory.TextArt],
    id: 157,
    mainCategory: FontCategory.TextArt,
  },
  '158': {
    name: 'Modern',
    asciiFont: 'Bulbhead',
    categories: [FontCategory.TextArt],
    id: 158,
    mainCategory: FontCategory.TextArt,
  },
  '159': {
    name: 'Retro Vibes',
    asciiFont: 'ANSI Regular',
    categories: [FontCategory.TextArt],
    id: 159,
    mainCategory: FontCategory.TextArt,
  },
  '160': {
    name: 'Shadows',
    asciiFont: 'ANSI Shadow',
    categories: [FontCategory.TextArt],
    id: 160,
    mainCategory: FontCategory.TextArt,
  },
  '161': {
    name: 'Rectangles',
    asciiFont: 'Rectangles',
    categories: [FontCategory.TextArt],
    id: 161,
    mainCategory: FontCategory.TextArt,
  },
  '162': {
    name: 'Ogre',
    asciiFont: 'Ogre',
    categories: [FontCategory.TextArt],
    id: 162,
    mainCategory: FontCategory.TextArt,
  },
  '163': {
    name: 'Italic letters',
    asciiFont: 'Italic',
    categories: [FontCategory.TextArt],
    id: 163,
    mainCategory: FontCategory.TextArt,
  },
  '164': {
    name: 'Slant',
    asciiFont: 'Slant',
    categories: [FontCategory.TextArt],
    id: 164,
    mainCategory: FontCategory.TextArt,
  },
  '165': {
    name: 'Small letters',
    asciiFont: 'Small',
    categories: [FontCategory.TextArt],
    id: 165,
    mainCategory: FontCategory.TextArt,
  },
  '166': {
    name: 'Stick letters',
    asciiFont: 'Stick Letters',
    categories: [FontCategory.TextArt],
    id: 166,
    mainCategory: FontCategory.TextArt,
  },
  '167': {
    name: 'Sub-Zero',
    asciiFont: 'Sub-Zero',
    categories: [FontCategory.TextArt],
    id: 167,
    mainCategory: FontCategory.TextArt,
  },
  '168': {
    name: '3D text art',
    asciiFont: '3D-ASCII',
    categories: [FontCategory.TextArt],
    id: 168,
    mainCategory: FontCategory.TextArt,
  },
  '169': {
    name: 'Block letters',
    asciiFont: 'Ivrit',
    categories: [FontCategory.TextArt],
    id: 169,
    mainCategory: FontCategory.TextArt,
  },
  '170': {
    name: 'Lines and dots',
    asciiFont: 'AMC 3 Line',
    categories: [FontCategory.TextArt],
    id: 170,
    mainCategory: FontCategory.TextArt,
  },
  '171': {
    name: 'Broadway letters',
    asciiFont: 'Broadway KB',
    categories: [FontCategory.TextArt],
    id: 171,
    mainCategory: FontCategory.TextArt,
  },
  '172': {
    name: 'Acrobats',
    asciiFont: 'Acrobatic',
    categories: [FontCategory.TextArt],
    id: 172,
    mainCategory: FontCategory.TextArt,
  },
  '173': {
    name: 'Serif Caps',
    asciiFont: 'Serifcap',
    categories: [FontCategory.TextArt],
    id: 173,
    mainCategory: FontCategory.TextArt,
  },
} as AllFonts;
